webpackJsonp([108],{

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return SET_LOADING; });
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_GET_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_GET_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_GET_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_GET_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_GET_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_GET_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_CHANGE_USER_NPI_PERMIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_CHANGE_USER_NPI_PERMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_CHANGE_USER_NPI_PERMIT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE; });
/* unused harmony export CORE_AUTH_VERIFY_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_AUTH_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_AUTH_VERIFY_FAILURE; });
/* unused harmony export CORE_GET_REQUEST_INFO_REQUEST */
/* unused harmony export CORE_GET_REQUEST_INFO_SUCCESS */
/* unused harmony export CORE_GET_REQUEST_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_LOAD_DRAWING_INFORMATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_LOAD_DRAWING_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_LOAD_DRAWING_INFORMATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return CORE_SEARCH_DRAWING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return CORE_SEARCH_DRAWING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return CORE_SEARCH_DRAWING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_CREATE_DRAWING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_CREATE_DRAWING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_CREATE_DRAWING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return CORE_UPDATE_DRAWING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return CORE_UPDATE_DRAWING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return CORE_UPDATE_DRAWING_INFO_FAILURE; });
/* unused harmony export CORE_LOAD_MASTER_DATA_REQUEST */
/* unused harmony export CORE_LOAD_MASTER_DATA_SUCCESS */
/* unused harmony export CORE_LOAD_MASTER_DATA_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_LOAD_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_LOAD_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_LOAD_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_CREATE_CUSTOMER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_CREATE_CUSTOMER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_CREATE_CUSTOMER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_LOAD_ITEM_INFORMATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_LOAD_ITEM_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_ITEM_INFORMATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return CORE_SAVE_ITEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return CORE_SAVE_ITEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return CORE_SAVE_ITEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return CORE_SUBMIT_ITEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return CORE_SUBMIT_ITEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return CORE_SUBMIT_ITEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_APPROVE_ITEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_APPROVE_ITEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_APPROVE_ITEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_GEN_CODE_ITEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_GEN_CODE_ITEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_GEN_CODE_ITEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return CORE_RE_SEND_ITEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return CORE_RE_SEND_ITEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return CORE_RE_SEND_ITEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_CREATE_DRAWING_CONFIRM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_CREATE_DRAWING_CONFIRM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_CREATE_DRAWING_CONFIRM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_DELETE_DRAWING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_DELETE_DRAWING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_DELETE_DRAWING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_CREATE_DRAWING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_CREATE_DRAWING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_CREATE_DRAWING_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_GET_REPORT_DRAWING_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_GET_REPORT_DRAWING_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_GET_REPORT_DRAWING_STATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_GET_REPORT_VIEW_DRAWING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_GET_REPORT_VIEW_DRAWING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_GET_REPORT_VIEW_DRAWING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_GET_TUBE_INSIDE_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_GET_TUBE_INSIDE_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_GET_TUBE_INSIDE_DATA_FAILURE; });
/* unused harmony export CORE_SEARCH_TUBE_INSIDE_DATA_REQUEST */
/* unused harmony export CORE_SEARCH_TUBE_INSIDE_DATA_SUCCESS */
/* unused harmony export CORE_SEARCH_TUBE_INSIDE_DATA_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_GET_PIPE_TYPE_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_GET_PIPE_TYPE_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_GET_PIPE_TYPE_DATA_FAILURE; });
/* unused harmony export CORE_SEARCH_PIPE_TYPE_DATA_REQUEST */
/* unused harmony export CORE_SEARCH_PIPE_TYPE_DATA_SUCCESS */
/* unused harmony export CORE_SEARCH_PIPE_TYPE_DATA_FAILURE */
/* unused harmony export CORE_GET_FIN_EDGE_DATA_REQUEST */
/* unused harmony export CORE_GET_FIN_EDGE_DATA_SUCCESS */
/* unused harmony export CORE_GET_FIN_EDGE_DATA_FAILURE */
/* unused harmony export CORE_SEARCH_FIN_EDGE_DATA_REQUEST */
/* unused harmony export CORE_SEARCH_FIN_EDGE_DATA_SUCCESS */
/* unused harmony export CORE_SEARCH_FIN_EDGE_DATA_FAILURE */
/* unused harmony export CORE_GET_FIN_SURFACE_DATA_REQUEST */
/* unused harmony export CORE_GET_FIN_SURFACE_DATA_SUCCESS */
/* unused harmony export CORE_GET_FIN_SURFACE_DATA_FAILURE */
/* unused harmony export CORE_SEARCH_FIN_SURFACE_DATA_REQUEST */
/* unused harmony export CORE_SEARCH_FIN_SURFACE_DATA_SUCCESS */
/* unused harmony export CORE_SEARCH_FIN_SURFACE_DATA_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_CREATE_SELL_ORDER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_CREATE_SELL_ORDER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_CREATE_SELL_ORDER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return CORE_SEARCH_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return CORE_SEARCH_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return CORE_SEARCH_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return CORE_UPDATE_SELL_ORDER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return CORE_UPDATE_SELL_ORDER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return CORE_UPDATE_SELL_ORDER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_APPROVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_APPROVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_APPROVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_PRE_APPROVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_PRE_APPROVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_PRE_APPROVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_CUSTOMER_APPROVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_CUSTOMER_APPROVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_CUSTOMER_APPROVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_DELETE_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_DELETE_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_DELETE_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return CORE_REJECT_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return CORE_REJECT_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return CORE_REJECT_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_LOAD_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_LOAD_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_LOAD_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_CHANGE_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_CHANGE_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CHANGE_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return CORE_SUBMIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return CORE_SUBMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return CORE_SUBMIT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_COMPLETE_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_COMPLETE_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_COMPLETE_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_COMMENT_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_COMMENT_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_COMMENT_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_ATTACH_FILE_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_ATTACH_FILE_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_ATTACH_FILE_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_GENCODE_NPI_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_GENCODE_NPI_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_GENCODE_NPI_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return CORE_SHOP_APPROVE_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return CORE_SHOP_APPROVE_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CANCEL_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CANCEL_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CANCEL_SELL_ORDER_FAILURE; });
/* unused harmony export CORE_GET_REPORT_REQ_DRAWING_STATUS_REQUEST */
/* unused harmony export CORE_GET_REPORT_REQ_DRAWING_STATUS_SUCCESS */
/* unused harmony export CORE_GET_REPORT_REQ_DRAWING_STATUS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return CORE_RE_STATUS_SELL_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return CORE_RE_STATUS_SELL_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return CORE_RE_STATUS_SELL_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_GET_ONEDRIVE_LINK_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_GET_ONEDRIVE_LINK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_GET_ONEDRIVE_LINK_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_CREATE_REQ_TUBE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_CREATE_REQ_TUBE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_CREATE_REQ_TUBE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return CORE_UPDATE_REQ_TUBE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return CORE_UPDATE_REQ_TUBE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return CORE_UPDATE_REQ_TUBE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return CORE_SEARCH_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return CORE_SEARCH_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return CORE_SEARCH_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_APPROVE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_APPROVE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_APPROVE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_PRE_APPROVE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_PRE_APPROVE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_PRE_APPROVE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return CORE_REJECT_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return CORE_REJECT_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_REJECT_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_DELETE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_DELETE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_DELETE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return CORE_SUBMIT_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return CORE_SUBMIT_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return CORE_SUBMIT_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_COMPLETE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_COMPLETE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_COMPLETE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_COMMENT_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_COMMENT_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_COMMENT_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_ATTACH_FILE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_ATTACH_FILE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_ATTACH_FILE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_GENCODE_NPI_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_GENCODE_NPI_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_GENCODE_NPI_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return CORE_SHOP_APPROVE_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return CORE_SHOP_APPROVE_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CANCEL_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CANCEL_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CANCEL_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return CORE_RE_STATUS_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return CORE_RE_STATUS_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return CORE_RE_STATUS_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_GET_SYSTEM_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_GET_SYSTEM_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_GET_SYSTEM_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_LOAD_REQ_ACC_INFORMATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_LOAD_REQ_ACC_INFORMATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_CREATE_REQ_ACC_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_CREATE_REQ_ACC_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_CREATE_REQ_ACC_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return CORE_UPDATE_REQ_ACC_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return CORE_UPDATE_REQ_ACC_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return CORE_UPDATE_REQ_ACC_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return CORE_SEARCH_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return CORE_SEARCH_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return CORE_SEARCH_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_APPROVE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_APPROVE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_APPROVE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_PRE_APPROVE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_PRE_APPROVE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_PRE_APPROVE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_REJECT_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_REJECT_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_REJECT_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_DELETE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_DELETE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_DELETE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return CORE_SUBMIT_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return CORE_SUBMIT_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return CORE_SUBMIT_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return CORE_SHOP_SUBMIT_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return CORE_SHOP_SUBMIT_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_COMPLETE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_COMPLETE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_COMPLETE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_COMMENT_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_COMMENT_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_COMMENT_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_ATTACH_FILE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_ATTACH_FILE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_ATTACH_FILE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_GENCODE_NPI_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_GENCODE_NPI_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_GENCODE_NPI_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return CORE_SHOP_APPROVE_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return CORE_SHOP_APPROVE_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return CORE_SHOP_APPROVE_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CANCEL_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CANCEL_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CANCEL_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return CORE_RE_STATUS_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return CORE_RE_STATUS_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return CORE_RE_STATUS_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_GET_REQ_ACC_ALL_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_GET_REQ_ACC_ALL_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_GET_DOWNLOAD_DRAWING_FILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_GET_REPORT_FOLLOW_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_GET_REPORT_FOLLOW_STATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_GET_REPORT_SUMMARY_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_GET_REPORT_SUMMARY_STATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return CORE_UPDATE_DESIGN_PLAN_COIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return CORE_UPDATE_DESIGN_PLAN_COIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return CORE_UPDATE_DESIGN_PLAN_COIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return CORE_UPDATE_DESIGN_PLAN_TUBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return CORE_UPDATE_DESIGN_PLAN_TUBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return CORE_UPDATE_DESIGN_PLAN_TUBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return CORE_UPDATE_DESIGN_PLAN_ACC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return CORE_UPDATE_DESIGN_PLAN_ACC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return CORE_UPDATE_DESIGN_PLAN_ACC_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_DOWNLOAD_FILE_ONEDRIVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_DOWNLOAD_FILE_ONEDRIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_DOWNLOAD_FILE_ONEDRIVE_FAILURE; });
var REQUEST_STATE = 'REQUEST_STATE';
var SET_ERROR = 'SET_ERROR';
var SET_LOADING = 'SET_LOADING';

var LOGOUT = 'LOGOUT';
var CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST';
var CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS';
var CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE';

var CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST';
var CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS';
var CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE';

var CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST';
var CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS';
var CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE';

var CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST';
var CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS';
var CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE';

//AUTH
var CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

var CORE_GET_REQUEST_INFO_REQUEST = "CORE_GET_REQUEST_INFO_REQUEST";
var CORE_GET_REQUEST_INFO_SUCCESS = "CORE_GET_REQUEST_INFO_SUCCESS";
var CORE_GET_REQUEST_INFO_FAILURE = "CORE_GET_REQUEST_INFO_FAILURE";

//  Drawing
var CORE_LOAD_DRAWING_INFORMATION_REQUEST = "CORE_LOAD_DRAWING_INFORMATION_REQUEST";
var CORE_LOAD_DRAWING_INFORMATION_SUCCESS = "CORE_LOAD_DRAWING_INFORMATION_SUCCESS";
var CORE_LOAD_DRAWING_INFORMATION_FAILURE = "CORE_LOAD_DRAWING_INFORMATION_FAILURE";

var CORE_SEARCH_DRAWING_REQUEST = "CORE_SEARCH_DRAWING_REQUEST";
var CORE_SEARCH_DRAWING_SUCCESS = "CORE_SEARCH_DRAWING_SUCCESS";
var CORE_SEARCH_DRAWING_FAILURE = "CORE_SEARCH_DRAWING_FAILURE";

var CORE_CREATE_DRAWING_REQUEST = "CORE_CREATE_DRAWING_REQUEST";
var CORE_CREATE_DRAWING_SUCCESS = "CORE_CREATE_DRAWING_SUCCESS";
var CORE_CREATE_DRAWING_FAILURE = "CORE_CREATE_DRAWING_FAILURE";

var CORE_UPDATE_DRAWING_INFO_REQUEST = "CORE_UPDATE_DRAWING_INFO_REQUEST";
var CORE_UPDATE_DRAWING_INFO_SUCCESS = "CORE_UPDATE_DRAWING_INFO_SUCCESS";
var CORE_UPDATE_DRAWING_INFO_FAILURE = "CORE_UPDATE_DRAWING_INFO_FAILURE";

// Master
var CORE_LOAD_MASTER_DATA_REQUEST = 'CORE_LOAD_MASTER_DATA_REQUEST';
var CORE_LOAD_MASTER_DATA_SUCCESS = 'CORE_LOAD_MASTER_DATA_SUCCESS';
var CORE_LOAD_MASTER_DATA_FAILURE = 'CORE_LOAD_MASTER_DATA_FAILURE';

// Customer
var CORE_LOAD_CUSTOMER_REQUEST = "CORE_LOAD_CUSTOMER_REQUEST";
var CORE_LOAD_CUSTOMER_SUCCESS = "CORE_LOAD_CUSTOMER_SUCCESS";
var CORE_LOAD_CUSTOMER_FAILURE = "CORE_LOAD_CUSTOMER_FAILURE";

var CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST = "CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST";
var CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS = "CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS";
var CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE = "CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE";

var CORE_CREATE_CUSTOMER_REQUEST = "CORE_CREATE_CUSTOMER_REQUEST";
var CORE_CREATE_CUSTOMER_SUCCESS = "CORE_CREATE_CUSTOMER_SUCCESS";
var CORE_CREATE_CUSTOMER_FAILURE = "CORE_CREATE_CUSTOMER_FAILURE";

// Item
var CORE_LOAD_ITEM_INFORMATION_REQUEST = 'CORE_LOAD_ITEM_INFORMATION_REQUEST';
var CORE_LOAD_ITEM_INFORMATION_SUCCESS = 'CORE_LOAD_ITEM_INFORMATION_SUCCESS';
var CORE_LOAD_ITEM_INFORMATION_FAILURE = 'CORE_LOAD_ITEM_INFORMATION_FAILURE';

var CORE_SAVE_ITEM_REQUEST = 'CORE_SAVE_ITEM_REQUEST';
var CORE_SAVE_ITEM_SUCCESS = 'CORE_SAVE_ITEM_SUCCESS';
var CORE_SAVE_ITEM_FAILURE = 'CORE_SAVE_ITEM_FAILURE';

var CORE_SUBMIT_ITEM_REQUEST = 'CORE_SUBMIT_ITEM_REQUEST';
var CORE_SUBMIT_ITEM_SUCCESS = 'CORE_SUBMIT_ITEM_SUCCESS';
var CORE_SUBMIT_ITEM_FAILURE = 'CORE_SUBMIT_ITEM_FAILURE';

var CORE_APPROVE_ITEM_REQUEST = 'CORE_APPROVE_ITEM_REQUEST';
var CORE_APPROVE_ITEM_SUCCESS = 'CORE_APPROVE_ITEM_SUCCESS';
var CORE_APPROVE_ITEM_FAILURE = 'CORE_APPROVE_ITEM_FAILURE';

var CORE_GEN_CODE_ITEM_REQUEST = 'CORE_GEN_CODE_ITEM_REQUEST';
var CORE_GEN_CODE_ITEM_SUCCESS = 'CORE_GEN_CODE_ITEM_SUCCESS';
var CORE_GEN_CODE_ITEM_FAILURE = 'CORE_GEN_CODE_ITEM_FAILURE';

var CORE_RE_SEND_ITEM_REQUEST = 'CORE_RE_SEND_ITEM_REQUEST';
var CORE_RE_SEND_ITEM_SUCCESS = 'CORE_RE_SEND_ITEM_SUCCESS';
var CORE_RE_SEND_ITEM_FAILURE = 'CORE_RE_SEND_ITEM_FAILURE';

// Item Confirm
var CORE_CREATE_DRAWING_CONFIRM_REQUEST = 'CORE_CREATE_DRAWING_CONFIRM_REQUEST';
var CORE_CREATE_DRAWING_CONFIRM_SUCCESS = 'CORE_CREATE_DRAWING_CONFIRM_SUCCESS';
var CORE_CREATE_DRAWING_CONFIRM_FAILURE = 'CORE_CREATE_DRAWING_CONFIRM_FAILURE';

//Item Delete
var CORE_DELETE_DRAWING_REQUEST = 'CORE_DELETE_DRAWING_REQUEST';
var CORE_DELETE_DRAWING_SUCCESS = 'CORE_DELETE_DRAWING_SUCCESS';
var CORE_DELETE_DRAWING_FAILURE = 'CORE_DELETE_DRAWING_FAILURE';

// Drawing Item Information
var CORE_CREATE_DRAWING_INFO_REQUEST = 'CORE_CREATE_DRAWING_INFO_REQUEST';
var CORE_CREATE_DRAWING_INFO_SUCCESS = 'CORE_CREATE_DRAWING_INFO_SUCCESS';
var CORE_CREATE_DRAWING_INFO_FAILURE = 'CORE_CREATE_DRAWING_INFO_FAILURE';

// Report
var CORE_GET_REPORT_DRAWING_STATUS_REQUEST = "CORE_GET_REPORT_DRAWING_STATUS_REQUEST";
var CORE_GET_REPORT_DRAWING_STATUS_SUCCESS = "CORE_GET_REPORT_DRAWING_STATUS_SUCCESS";
var CORE_GET_REPORT_DRAWING_STATUS_FAILURE = "CORE_GET_REPORT_DRAWING_STATUS_FAILURE";

var CORE_GET_REPORT_VIEW_DRAWING_REQUEST = "CORE_GET_REPORT_VIEW_DRAWING_REQUEST";
var CORE_GET_REPORT_VIEW_DRAWING_SUCCESS = "CORE_GET_REPORT_VIEW_DRAWING_SUCCESS";
var CORE_GET_REPORT_VIEW_DRAWING_FAILURE = "CORE_GET_REPORT_VIEW_DRAWING_FAILURE";

// Master Data
var CORE_GET_TUBE_INSIDE_DATA_REQUEST = "CORE_GET_TUBE_INSIDE_DATA_REQUEST";
var CORE_GET_TUBE_INSIDE_DATA_SUCCESS = "CORE_GET_TUBE_INSIDE_DATA_SUCCESS";
var CORE_GET_TUBE_INSIDE_DATA_FAILURE = "CORE_GET_TUBE_INSIDE_DATA_FAILURE";

var CORE_SEARCH_TUBE_INSIDE_DATA_REQUEST = "CORE_SEARCH_TUBE_INSIDE_DATA_REQUEST";
var CORE_SEARCH_TUBE_INSIDE_DATA_SUCCESS = "CORE_SEARCH_TUBE_INSIDE_DATA_SUCCESS";
var CORE_SEARCH_TUBE_INSIDE_DATA_FAILURE = "CORE_SEARCH_TUBE_INSIDE_DATA_FAILURE";

var CORE_GET_PIPE_TYPE_DATA_REQUEST = "CORE_GET_PIPE_TYPE_DATA_REQUEST";
var CORE_GET_PIPE_TYPE_DATA_SUCCESS = "CORE_GET_PIPE_TYPE_DATA_SUCCESS";
var CORE_GET_PIPE_TYPE_DATA_FAILURE = "CORE_GET_PIPE_TYPE_DATA_FAILURE";

var CORE_SEARCH_PIPE_TYPE_DATA_REQUEST = "CORE_SEARCH_PIPE_TYPE_DATA_REQUEST";
var CORE_SEARCH_PIPE_TYPE_DATA_SUCCESS = "CORE_SEARCH_PIPE_TYPE_DATA_SUCCESS";
var CORE_SEARCH_PIPE_TYPE_DATA_FAILURE = "CORE_SEARCH_PIPE_TYPE_DATA_FAILURE";

var CORE_GET_FIN_EDGE_DATA_REQUEST = "CORE_GET_FIN_EDGE_DATA_REQUEST";
var CORE_GET_FIN_EDGE_DATA_SUCCESS = "CORE_GET_FIN_EDGE_DATA_SUCCESS";
var CORE_GET_FIN_EDGE_DATA_FAILURE = "CORE_GET_FIN_EDGE_DATA_FAILURE";

var CORE_SEARCH_FIN_EDGE_DATA_REQUEST = "CORE_SEARCH_FIN_EDGE_DATA_REQUEST";
var CORE_SEARCH_FIN_EDGE_DATA_SUCCESS = "CORE_SEARCH_FIN_EDGE_DATA_SUCCESS";
var CORE_SEARCH_FIN_EDGE_DATA_FAILURE = "CORE_SEARCH_FIN_EDGE_DATA_FAILURE";

var CORE_GET_FIN_SURFACE_DATA_REQUEST = "CORE_GET_FIN_SURFACE_DATA_REQUEST";
var CORE_GET_FIN_SURFACE_DATA_SUCCESS = "CORE_GET_FIN_SURFACE_DATA_SUCCESS";
var CORE_GET_FIN_SURFACE_DATA_FAILURE = "CORE_GET_FIN_SURFACE_DATA_FAILURE";

var CORE_SEARCH_FIN_SURFACE_DATA_REQUEST = "CORE_SEARCH_FIN_SURFACE_DATA_REQUEST";
var CORE_SEARCH_FIN_SURFACE_DATA_SUCCESS = "CORE_SEARCH_FIN_SURFACE_DATA_SUCCESS";
var CORE_SEARCH_FIN_SURFACE_DATA_FAILURE = "CORE_SEARCH_FIN_SURFACE_DATA_FAILURE";

// Sell Order
var CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST = "CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST";
var CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS = "CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS";
var CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE = "CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE";

var CORE_CREATE_SELL_ORDER_INFO_REQUEST = "CORE_CREATE_SELL_ORDER_INFO_REQUEST";
var CORE_CREATE_SELL_ORDER_INFO_SUCCESS = "CORE_CREATE_SELL_ORDER_INFO_SUCCESS";
var CORE_CREATE_SELL_ORDER_INFO_FAILURE = "CORE_CREATE_SELL_ORDER_INFO_FAILURE";

var CORE_SEARCH_SELL_ORDER_REQUEST = "CORE_SEARCH_SELL_ORDER_REQUEST";
var CORE_SEARCH_SELL_ORDER_SUCCESS = "CORE_SEARCH_SELL_ORDER_SUCCESS";
var CORE_SEARCH_SELL_ORDER_FAILURE = "CORE_SEARCH_SELL_ORDER_FAILURE";

var CORE_UPDATE_SELL_ORDER_INFO_REQUEST = "CORE_UPDATE_SELL_ORDER_INFO_REQUEST";
var CORE_UPDATE_SELL_ORDER_INFO_SUCCESS = "CORE_UPDATE_SELL_ORDER_INFO_SUCCESS";
var CORE_UPDATE_SELL_ORDER_INFO_FAILURE = "CORE_UPDATE_SELL_ORDER_INFO_FAILURE";

var CORE_APPROVE_REQUEST = "CORE_APPROVE_REQUEST";
var CORE_APPROVE_SUCCESS = "CORE_APPROVE_SUCCESS";
var CORE_APPROVE_FAILURE = "CORE_APPROVE_FAILURE";

var CORE_PRE_APPROVE_REQUEST = "CORE_PRE_APPROVE_REQUEST";
var CORE_PRE_APPROVE_SUCCESS = "CORE_PRE_APPROVE_SUCCESS";
var CORE_PRE_APPROVE_FAILURE = "CORE_PRE_APPROVE_FAILURE";

var CORE_CUSTOMER_APPROVE_REQUEST = "CORE_CUSTOMER_APPROVE_REQUEST";
var CORE_CUSTOMER_APPROVE_SUCCESS = "CORE_CUSTOMER_APPROVE_SUCCESS";
var CORE_CUSTOMER_APPROVE_FAILURE = "CORE_CUSTOMER_APPROVE_FAILURE";

var CORE_DELETE_SELL_ORDER_REQUEST = "CORE_DELETE_SELL_ORDER_REQUEST";
var CORE_DELETE_SELL_ORDER_SUCCESS = "CORE_DELETE_SELL_ORDER_SUCCESS";
var CORE_DELETE_SELL_ORDER_FAILURE = "CORE_DELETE_SELL_ORDER_FAILURE";

var CORE_REJECT_SELL_ORDER_REQUEST = "CORE_REJECT_SELL_ORDER_REQUEST";
var CORE_REJECT_SELL_ORDER_SUCCESS = "CORE_REJECT_SELL_ORDER_SUCCESS";
var CORE_REJECT_SELL_ORDER_FAILURE = "CORE_REJECT_SELL_ORDER_FAILURE";

var CORE_LOAD_SETTING_REQUEST = "CORE_LOAD_SETTING_REQUEST";
var CORE_LOAD_SETTING_SUCCESS = "CORE_LOAD_SETTING_SUCCESS";
var CORE_LOAD_SETTING_FAILURE = "CORE_LOAD_SETTING_FAILURE";

var CORE_CHANGE_SETTING_REQUEST = "CORE_CHANGE_SETTING_REQUEST";
var CORE_CHANGE_SETTING_SUCCESS = "CORE_CHANGE_SETTING_SUCCESS";
var CORE_CHANGE_SETTING_FAILURE = "CORE_CHANGE_SETTING_FAILURE";

var CORE_SUBMIT_REQUEST = "CORE_SUBMIT_REQUEST";
var CORE_SUBMIT_SUCCESS = "CORE_SUBMIT_SUCCESS";
var CORE_SUBMIT_FAILURE = "CORE_SUBMIT_FAILURE";

var CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST = "CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST";
var CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS = "CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS";
var CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE = "CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE";

var CORE_COMPLETE_SELL_ORDER_REQUEST = "CORE_COMPLETE_SELL_ORDER_REQUEST";
var CORE_COMPLETE_SELL_ORDER_SUCCESS = "CORE_COMPLETE_SELL_ORDER_SUCCESS";
var CORE_COMPLETE_SELL_ORDER_FAILURE = "CORE_COMPLETE_SELL_ORDER_FAILURE";

var CORE_COMMENT_SELL_ORDER_REQUEST = "CORE_COMMENT_SELL_ORDER_REQUEST";
var CORE_COMMENT_SELL_ORDER_SUCCESS = "CORE_COMMENT_SELL_ORDER_SUCCESS";
var CORE_COMMENT_SELL_ORDER_FAILURE = "CORE_COMMENT_SELL_ORDER_FAILURE";

var CORE_ATTACH_FILE_SELL_ORDER_REQUEST = "CORE_ATTACH_FILE_SELL_ORDER_REQUEST";
var CORE_ATTACH_FILE_SELL_ORDER_SUCCESS = "CORE_ATTACH_FILE_SELL_ORDER_SUCCESS";
var CORE_ATTACH_FILE_SELL_ORDER_FAILURE = "CORE_ATTACH_FILE_SELL_ORDER_FAILURE";

var CORE_GENCODE_NPI_SELL_ORDER_REQUEST = "CORE_GENCODE_NPI_SELL_ORDER_REQUEST";
var CORE_GENCODE_NPI_SELL_ORDER_SUCCESS = "CORE_GENCODE_NPI_SELL_ORDER_SUCCESS";
var CORE_GENCODE_NPI_SELL_ORDER_FAILURE = "CORE_GENCODE_NPI_SELL_ORDER_FAILURE";

var CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST = "CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST";
var CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS = "CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS";
var CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE = "CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE";

var CORE_SHOP_APPROVE_SELL_ORDER_REQUEST = "CORE_SHOP_APPROVE_SELL_ORDER_REQUEST";
var CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS = "CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS";
var CORE_SHOP_APPROVE_SELL_ORDER_FAILURE = "CORE_SHOP_APPROVE_SELL_ORDER_FAILURE";

var CORE_CANCEL_SELL_ORDER_REQUEST = "CORE_CANCEL_SELL_ORDER_REQUEST";
var CORE_CANCEL_SELL_ORDER_SUCCESS = "CORE_CANCEL_SELL_ORDER_SUCCESS";
var CORE_CANCEL_SELL_ORDER_FAILURE = "CORE_CANCEL_SELL_ORDER_FAILURE";

var CORE_GET_REPORT_REQ_DRAWING_STATUS_REQUEST = "CORE_GET_REPORT_REQ_DRAWING_STATUS_REQUES";
var CORE_GET_REPORT_REQ_DRAWING_STATUS_SUCCESS = "CORE_GET_REPORT_REQ_DRAWING_STATUS_SUCCES";
var CORE_GET_REPORT_REQ_DRAWING_STATUS_FAILURE = "CORE_GET_REPORT_REQ_DRAWING_STATUS_FAILURE";

var CORE_RE_STATUS_SELL_ORDER_REQUEST = "CORE_RE_STATUS_SELL_ORDER_REQUEST";
var CORE_RE_STATUS_SELL_ORDER_SUCCESS = "CORE_RE_STATUS_SELL_ORDER_SUCCESS";
var CORE_RE_STATUS_SELL_ORDER_FAILURE = "CORE_RE_STATUS_SELL_ORDER_FAILURE";

var CORE_GET_ONEDRIVE_LINK_REQUEST = "CORE_GET_ONEDRIVE_LINK_REQUEST";
var CORE_GET_ONEDRIVE_LINK_SUCCESS = "CORE_GET_ONEDRIVE_LINK_SUCCESS";
var CORE_GET_ONEDRIVE_LINK_FAILURE = "CORE_GET_ONEDRIVE_LINK_FAILURE";

//Req Tube
var CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST = "CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST";
var CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS = "CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS";
var CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE = "CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE";

var CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST = "CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST";
var CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS = "CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS";
var CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE = "CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE";

var CORE_CREATE_REQ_TUBE_INFO_REQUEST = "CORE_CREATE_REQ_TUBE_INFO_REQUEST";
var CORE_CREATE_REQ_TUBE_INFO_SUCCESS = "CORE_CREATE_REQ_TUBE_INFO_SUCCESS";
var CORE_CREATE_REQ_TUBE_INFO_FAILURE = "CORE_CREATE_REQ_TUBE_INFO_FAILURE";

var CORE_UPDATE_REQ_TUBE_INFO_REQUEST = "CORE_UPDATE_REQ_TUBE_INFO_REQUEST";
var CORE_UPDATE_REQ_TUBE_INFO_SUCCESS = "CORE_UPDATE_REQ_TUBE_INFO_SUCCESS";
var CORE_UPDATE_REQ_TUBE_INFO_FAILURE = "CORE_UPDATE_REQ_TUBE_INFO_FAILURE";

var CORE_SEARCH_REQ_TUBE_REQUEST = "CORE_SEARCH_REQ_TUBE_REQUEST";
var CORE_SEARCH_REQ_TUBE_SUCCESS = "CORE_SEARCH_REQ_TUBE_SUCCESS";
var CORE_SEARCH_REQ_TUBE_FAILURE = "CORE_SEARCH_REQ_TUBE_FAILURE";

var CORE_APPROVE_REQ_TUBE_REQUEST = "CORE_APPROVE_REQ_TUBE_REQUEST";
var CORE_APPROVE_REQ_TUBE_SUCCESS = "CORE_APPROVE_REQ_TUBE_SUCCESS";
var CORE_APPROVE_REQ_TUBE_FAILURE = "CORE_APPROVE_REQ_TUBE_FAILURE";

var CORE_PRE_APPROVE_REQ_TUBE_REQUEST = "CORE_PRE_APPROVE_REQ_TUBE_REQUEST";
var CORE_PRE_APPROVE_REQ_TUBE_SUCCESS = "CORE_PRE_APPROVE_REQ_TUBE_SUCCESS";
var CORE_PRE_APPROVE_REQ_TUBE_FAILURE = "CORE_PRE_APPROVE_REQ_TUBE_FAILURE";

var CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST = "CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST";
var CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS = "CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS";
var CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE = "CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE";

var CORE_REJECT_REQ_TUBE_REQUEST = "CORE_REJECT_REQ_TUBE_REQUEST";
var CORE_REJECT_REQ_TUBE_SUCCESS = "CORE_REJECT_REQ_TUBE_SUCCESS";
var CORE_REJECT_REQ_TUBE_FAILURE = "CORE_REJECT_REQ_TUBE_FAILURE";

var CORE_DELETE_REQ_TUBE_REQUEST = "CORE_DELETE_REQ_TUBE_REQUEST";
var CORE_DELETE_REQ_TUBE_SUCCESS = "CORE_DELETE_REQ_TUBE_SUCCESS";
var CORE_DELETE_REQ_TUBE_FAILURE = "CORE_DELETE_REQ_TUBE_FAILURE";

var CORE_SUBMIT_REQ_TUBE_REQUEST = "CORE_SUBMIT_REQ_TUBE_REQUEST";
var CORE_SUBMIT_REQ_TUBE_SUCCESS = "CORE_SUBMIT_REQ_TUBE_SUCCESS";
var CORE_SUBMIT_REQ_TUBE_FAILURE = "CORE_SUBMIT_REQ_TUBE_FAILURE";

var CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST = "CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST";
var CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS = "CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS";
var CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE = "CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE";

var CORE_COMPLETE_REQ_TUBE_REQUEST = "CORE_COMPLETE_REQ_TUBE_REQUEST";
var CORE_COMPLETE_REQ_TUBE_SUCCESS = "CORE_COMPLETE_REQ_TUBE_SUCCESS";
var CORE_COMPLETE_REQ_TUBE_FAILURE = "CORE_COMPLETE_REQ_TUBE_FAILURE";

var CORE_COMMENT_REQ_TUBE_REQUEST = "CORE_COMMENT_REQ_TUBE_REQUEST";
var CORE_COMMENT_REQ_TUBE_SUCCESS = "CORE_COMMENT_REQ_TUBE_SUCCESS";
var CORE_COMMENT_REQ_TUBE_FAILURE = "CORE_COMMENT_REQ_TUBE_FAILURE";

var CORE_ATTACH_FILE_REQ_TUBE_REQUEST = "CORE_ATTACH_FILE_REQ_TUBE_REQUEST";
var CORE_ATTACH_FILE_REQ_TUBE_SUCCESS = "CORE_ATTACH_FILE_REQ_TUBE_SUCCESS";
var CORE_ATTACH_FILE_REQ_TUBE_FAILURE = "CORE_ATTACH_FILE_REQ_TUBE_FAILURE";

var CORE_GENCODE_NPI_REQ_TUBE_REQUEST = "CORE_GENCODE_NPI_REQ_TUBE_REQUEST";
var CORE_GENCODE_NPI_REQ_TUBE_SUCCESS = "CORE_GENCODE_NPI_REQ_TUBE_SUCCESS";
var CORE_GENCODE_NPI_REQ_TUBE_FAILURE = "CORE_GENCODE_NPI_REQ_TUBE_FAILURE";

var CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST = "CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST";
var CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS = "CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS";
var CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE = "CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE";

var CORE_SHOP_APPROVE_REQ_TUBE_REQUEST = "CORE_SHOP_APPROVE_REQ_TUBE_REQUEST";
var CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS = "CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS";
var CORE_SHOP_APPROVE_REQ_TUBE_FAILURE = "CORE_SHOP_APPROVE_REQ_TUBE_FAILURE";

var CORE_CANCEL_REQ_TUBE_REQUEST = "CORE_CANCEL_REQ_TUBE_REQUEST";
var CORE_CANCEL_REQ_TUBE_SUCCESS = "CORE_CANCEL_REQ_TUBE_SUCCESS";
var CORE_CANCEL_REQ_TUBE_FAILURE = "CORE_CANCEL_REQ_TUBE_FAILURE";

var CORE_RE_STATUS_REQ_TUBE_REQUEST = "CORE_RE_STATUS_REQ_TUBE_REQUEST";
var CORE_RE_STATUS_REQ_TUBE_SUCCESS = "CORE_RE_STATUS_REQ_TUBE_SUCCESS";
var CORE_RE_STATUS_REQ_TUBE_FAILURE = "CORE_RE_STATUS_REQ_TUBE_FAILURE";

var CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST = "CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST";
var CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS = "CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS";
var CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE = "CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE";

var CORE_GET_SYSTEM_INFO_REQUEST = "CORE_GET_SYSTEM_INFO_REQUEST";
var CORE_GET_SYSTEM_INFO_SUCCESS = "CORE_GET_SYSTEM_INFO_SUCCESS";
var CORE_GET_SYSTEM_INFO_FAILURE = "CORE_GET_SYSTEM_INFO_FAILURE";

// Req Acc
var CORE_LOAD_REQ_ACC_INFORMATION_REQUEST = "CORE_LOAD_REQ_ACC_INFORMATION_REQUEST";
var CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS = "CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS";
var CORE_LOAD_REQ_ACC_INFORMATION_FAILURE = "CORE_LOAD_REQ_ACC_INFORMATION_FAILURE";

var CORE_CREATE_REQ_ACC_INFO_REQUEST = "CORE_CREATE_REQ_ACC_INFO_REQUEST";
var CORE_CREATE_REQ_ACC_INFO_SUCCESS = "CORE_CREATE_REQ_ACC_INFO_SUCCESS";
var CORE_CREATE_REQ_ACC_INFO_FAILURE = "CORE_CREATE_REQ_ACC_INFO_FAILURE";

var CORE_UPDATE_REQ_ACC_INFO_REQUEST = "CORE_UPDATE_REQ_ACC_INFO_REQUEST";
var CORE_UPDATE_REQ_ACC_INFO_SUCCESS = "CORE_UPDATE_REQ_ACC_INFO_SUCCESS";
var CORE_UPDATE_REQ_ACC_INFO_FAILURE = "CORE_UPDATE_REQ_ACC_INFO_FAILURE";

var CORE_SEARCH_REQ_ACC_REQUEST = "CORE_SEARCH_REQ_ACC_REQUEST";
var CORE_SEARCH_REQ_ACC_SUCCESS = "CORE_SEARCH_REQ_ACC_SUCCESS";
var CORE_SEARCH_REQ_ACC_FAILURE = "CORE_SEARCH_REQ_ACC_FAILURE";

var CORE_APPROVE_REQ_ACC_REQUEST = "CORE_APPROVE_REQ_ACC_REQUEST";
var CORE_APPROVE_REQ_ACC_SUCCESS = "CORE_APPROVE_REQ_ACC_SUCCESS";
var CORE_APPROVE_REQ_ACC_FAILURE = "CORE_APPROVE_REQ_ACC_FAILURE";

var CORE_PRE_APPROVE_REQ_ACC_REQUEST = "CORE_PRE_APPROVE_REQ_ACC_REQUEST";
var CORE_PRE_APPROVE_REQ_ACC_SUCCESS = "CORE_PRE_APPROVE_REQ_ACC_SUCCESS";
var CORE_PRE_APPROVE_REQ_ACC_FAILURE = "CORE_PRE_APPROVE_REQ_ACC_FAILURE";

var CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST = "CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST";
var CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS = "CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS";
var CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE = "CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE";

var CORE_REJECT_REQ_ACC_REQUEST = "CORE_REJECT_REQ_ACC_REQUEST";
var CORE_REJECT_REQ_ACC_SUCCESS = "CORE_REJECT_REQ_ACC_SUCCESS";
var CORE_REJECT_REQ_ACC_FAILURE = "CORE_REJECT_REQ_ACC_FAILURE";

var CORE_DELETE_REQ_ACC_REQUEST = "CORE_DELETE_REQ_ACC_REQUEST";
var CORE_DELETE_REQ_ACC_SUCCESS = "CORE_DELETE_REQ_ACC_SUCCESS";
var CORE_DELETE_REQ_ACC_FAILURE = "CORE_DELETE_REQ_ACC_FAILURE";

var CORE_SUBMIT_REQ_ACC_REQUEST = "CORE_SUBMIT_REQ_ACC_REQUEST";
var CORE_SUBMIT_REQ_ACC_SUCCESS = "CORE_SUBMIT_REQ_ACC_SUCCESS";
var CORE_SUBMIT_REQ_ACC_FAILURE = "CORE_SUBMIT_REQ_ACC_FAILURE";

var CORE_SHOP_SUBMIT_REQ_ACC_REQUEST = "CORE_SHOP_SUBMIT_REQ_ACC_REQUEST";
var CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS = "CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS";
var CORE_SHOP_SUBMIT_REQ_ACC_FAILURE = "CORE_SHOP_SUBMIT_REQ_ACC_FAILURE";

var CORE_COMPLETE_REQ_ACC_REQUEST = "CORE_COMPLETE_REQ_ACC_REQUEST";
var CORE_COMPLETE_REQ_ACC_SUCCESS = "CORE_COMPLETE_REQ_ACC_SUCCESS";
var CORE_COMPLETE_REQ_ACC_FAILURE = "CORE_COMPLETE_REQ_ACC_FAILURE";

var CORE_COMMENT_REQ_ACC_REQUEST = "CORE_COMMENT_REQ_ACC_REQUEST";
var CORE_COMMENT_REQ_ACC_SUCCESS = "CORE_COMMENT_REQ_ACC_SUCCESS";
var CORE_COMMENT_REQ_ACC_FAILURE = "CORE_COMMENT_REQ_ACC_FAILURE";

var CORE_ATTACH_FILE_REQ_ACC_REQUEST = "CORE_ATTACH_FILE_REQ_ACC_REQUEST";
var CORE_ATTACH_FILE_REQ_ACC_SUCCESS = "CORE_ATTACH_FILE_REQ_ACC_SUCCESS";
var CORE_ATTACH_FILE_REQ_ACC_FAILURE = "CORE_ATTACH_FILE_REQ_ACC_FAILURE";

var CORE_GENCODE_NPI_REQ_ACC_REQUEST = "CORE_GENCODE_NPI_REQ_ACC_REQUEST";
var CORE_GENCODE_NPI_REQ_ACC_SUCCESS = "CORE_GENCODE_NPI_REQ_ACC_SUCCESS";
var CORE_GENCODE_NPI_REQ_ACC_FAILURE = "CORE_GENCODE_NPI_REQ_ACC_FAILURE";

var CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST = "CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST";
var CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS = "CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS";
var CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE = "CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE";

var CORE_SHOP_APPROVE_REQ_ACC_REQUEST = "CORE_SHOP_APPROVE_REQ_ACC_REQUEST";
var CORE_SHOP_APPROVE_REQ_ACC_SUCCESS = "CORE_SHOP_APPROVE_REQ_ACC_SUCCESS";
var CORE_SHOP_APPROVE_REQ_ACC_FAILURE = "CORE_SHOP_APPROVE_REQ_ACC_FAILURE";

var CORE_CANCEL_REQ_ACC_REQUEST = "CORE_CANCEL_REQ_ACC_REQUEST";
var CORE_CANCEL_REQ_ACC_SUCCESS = "CORE_CANCEL_REQ_ACC_SUCCESS";
var CORE_CANCEL_REQ_ACC_FAILURE = "CORE_CANCEL_REQ_ACC_FAILURE";

var CORE_RE_STATUS_REQ_ACC_REQUEST = "CORE_RE_STATUS_REQ_ACC_REQUEST";
var CORE_RE_STATUS_REQ_ACC_SUCCESS = "CORE_RE_STATUS_REQ_ACC_SUCCESS";
var CORE_RE_STATUS_REQ_ACC_FAILURE = "CORE_RE_STATUS_REQ_ACC_FAILURE";

var CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST = "CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST";
var CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS = "CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS";
var CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE = "CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE";

var CORE_GET_REQ_ACC_ALL_TUBE_REQUEST = "CORE_GET_REQ_ACC_ALL_TUBE_REQUEST";
var CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS = "CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS";
var CORE_GET_REQ_ACC_ALL_TUBE_FAILURE = "CORE_GET_REQ_ACC_ALL_TUBE_FAILURE";

var CORE_GET_DOWNLOAD_DRAWING_FILE_REQUEST = "CORE_GET_DOWNLOAD_DRAWING_FILE_REQUEST";
var CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS = "CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS";
var CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE = "CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE";

var CORE_GET_REPORT_FOLLOW_STATUS_REQUEST = "CORE_GET_REPORT_FOLLOW_STATUS_REQUEST";
var CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS = "CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS";
var CORE_GET_REPORT_FOLLOW_STATUS_FAILURE = "CORE_GET_REPORT_FOLLOW_STATUS_FAILURE";

var CORE_GET_REPORT_SUMMARY_STATUS_REQUEST = "CORE_GET_REPORT_SUMMARY_STATUS_REQUEST";
var CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS = "CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS";
var CORE_GET_REPORT_SUMMARY_STATUS_FAILURE = "CORE_GET_REPORT_SUMMARY_STATUS_FAILURE";

var CORE_UPDATE_DESIGN_PLAN_COIL_REQUEST = "CORE_UPDATE_DESIGN_PLAN_COIL_REQUEST";
var CORE_UPDATE_DESIGN_PLAN_COIL_SUCCESS = "CORE_UPDATE_DESIGN_PLAN_COIL_SUCCESS";
var CORE_UPDATE_DESIGN_PLAN_COIL_FAILURE = "CORE_UPDATE_DESIGN_PLAN_COIL_FAILURE";

var CORE_UPDATE_DESIGN_PLAN_TUBE_REQUEST = "CORE_UPDATE_DESIGN_PLAN_TUBE_REQUEST";
var CORE_UPDATE_DESIGN_PLAN_TUBE_SUCCESS = "CORE_UPDATE_DESIGN_PLAN_TUBE_SUCCESS";
var CORE_UPDATE_DESIGN_PLAN_TUBE_FAILURE = "CORE_UPDATE_DESIGN_PLAN_TUBE_FAILURE";

var CORE_UPDATE_DESIGN_PLAN_ACC_REQUEST = "CORE_UPDATE_DESIGN_PLAN_ACC_REQUEST";
var CORE_UPDATE_DESIGN_PLAN_ACC_SUCCESS = "CORE_UPDATE_DESIGN_PLAN_ACC_SUCCESS";
var CORE_UPDATE_DESIGN_PLAN_ACC_FAILURE = "CORE_UPDATE_DESIGN_PLAN_ACC_FAILURE";

var CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST = "CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST";
var CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS = "CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS";
var CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE = "CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE";

var CORE_DOWNLOAD_FILE_ONEDRIVE_REQUEST = "CORE_DOWNLOAD_FILE_ONEDRIVE_REQUEST";
var CORE_DOWNLOAD_FILE_ONEDRIVE_SUCCESS = "CORE_DOWNLOAD_FILE_ONEDRIVE_SUCCESS";
var CORE_DOWNLOAD_FILE_ONEDRIVE_FAILURE = "CORE_DOWNLOAD_FILE_ONEDRIVE_FAILURE";

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOKEN; });
/* unused harmony export EXPIRES_ON */
/* unused harmony export EXPIRES_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_ID; });
/* unused harmony export FULL_NAME */
/* unused harmony export ROLE */
/* unused harmony export EMAIL */
/* unused harmony export O365_TOKEN */
/* unused harmony export USER_IMAGE */
/* unused harmony export IS_NPI_ADMIN */
/* unused harmony export IS_ADMIN */
/* unused harmony export SALE_SEARCH_STATUS */
/* unused harmony export SALE_SEARCH_PRIORITY */
/* unused harmony export SALE_SEARCH_TEXT */
/* unused harmony export SALE_SEARCH_API */
/* unused harmony export SALE_SEARCH_CUSTOMER */
/* unused harmony export TUBE_SEARCH_STATUS */
/* unused harmony export TUBE_SEARCH_PRIORITY */
/* unused harmony export TUBE_SEARCH_TEXT */
/* unused harmony export TUBE_SEARCH_API */
/* unused harmony export TUBE_SEARCH_CUSTOMER */
/* unused harmony export ACC_SEARCH_STATUS */
/* unused harmony export ACC_SEARCH_PRIORITY */
/* unused harmony export ACC_SEARCH_TEXT */
/* unused harmony export ACC_SEARCH_API */
/* unused harmony export ACC_SEARCH_CUSTOMER */
/* unused harmony export ACC_SEARCH_TYPE */
/* unused harmony export IS_NPI */
/* unused harmony export IS_PLANNING */
/* unused harmony export IS_SALE */
/* unused harmony export URL_INCOMING */
/* harmony export (immutable) */ __webpack_exports__["c"] = authentication;
/* harmony export (immutable) */ __webpack_exports__["v"] = setO365TokenCookie;
/* unused harmony export getO365Token */
/* harmony export (immutable) */ __webpack_exports__["z"] = setUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["t"] = getUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["i"] = getAllCookies;
/* harmony export (immutable) */ __webpack_exports__["q"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["j"] = getFullName;
/* unused harmony export getRole */
/* unused harmony export getExpireDate */
/* harmony export (immutable) */ __webpack_exports__["m"] = getIsNpiAdmin;
/* harmony export (immutable) */ __webpack_exports__["k"] = getIsAdmin;
/* harmony export (immutable) */ __webpack_exports__["w"] = setSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["p"] = getSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["x"] = setTubeSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["r"] = getTubeSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["g"] = clearTubeSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["u"] = setAccSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAccSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearAccSearchCookie;
/* harmony export (immutable) */ __webpack_exports__["l"] = getIsNpi;
/* harmony export (immutable) */ __webpack_exports__["n"] = getIsPlanning;
/* harmony export (immutable) */ __webpack_exports__["o"] = getIsSale;
/* harmony export (immutable) */ __webpack_exports__["y"] = setUrlIncoming;
/* harmony export (immutable) */ __webpack_exports__["s"] = getUrlIncoming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var EXPIRES_DATE = 'expires_date';
var USER_ID = 'user_id';
var FULL_NAME = "fullname";
var ROLE = "role";
var EMAIL = "email";
var O365_TOKEN = "o365_token";
var USER_IMAGE = "user_image";
var IS_NPI_ADMIN = "is_npi_admin";
var IS_ADMIN = "is_admin";

var SALE_SEARCH_STATUS = "sale_search_status";
var SALE_SEARCH_PRIORITY = "sale_search_priority";
var SALE_SEARCH_TEXT = "sale_search_text";
var SALE_SEARCH_API = "sale_search_api";
var SALE_SEARCH_CUSTOMER = "sale_search_customer";

var TUBE_SEARCH_STATUS = "tube_search_status";
var TUBE_SEARCH_PRIORITY = "tube_search_priority";
var TUBE_SEARCH_TEXT = "tube_search_text";
var TUBE_SEARCH_API = "tube_search_api";
var TUBE_SEARCH_CUSTOMER = "tube_search_customer";

var ACC_SEARCH_STATUS = "acc_search_status";
var ACC_SEARCH_PRIORITY = "acc_search_priority";
var ACC_SEARCH_TEXT = "acc_search_text";
var ACC_SEARCH_API = "acc_search_api";
var ACC_SEARCH_CUSTOMER = "acc_search_customer";
var ACC_SEARCH_TYPE = "acc_search_type";

var IS_NPI = "is_npi";
var IS_PLANNING = "is_planning";
var IS_SALE = "is_sale";

var URL_INCOMING = "url_incoming";

function getCookie(key) {
    try {
        var value = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(key);
        var setValue = '';

        if (value && typeof value === 'string') {
            setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(value);
        }
        return setValue;
    } catch (error) {
        return null;
    }
}

function setCookie(key, value, expires) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(valueToString);
    }
    if (expires && typeof expires === "number" && expires > 0) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue, { expires: expires });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove(key);
}

function authentication(dataAuth, isRemember) {
    var _dataAuth$user = dataAuth.user,
        email = _dataAuth$user.email,
        fullName = _dataAuth$user.fullName,
        id = _dataAuth$user.id,
        isNpiAdmin = _dataAuth$user.isNpiAdmin,
        isAdmin = _dataAuth$user.isAdmin,
        isNpi = _dataAuth$user.isNpi,
        isPlanning = _dataAuth$user.isPlanning,
        isSale = _dataAuth$user.isSale,
        token = dataAuth.token,
        expiresDate = dataAuth.expiresDate,
        expiresOn = dataAuth.expiresOn;


    clearToken();
    setCookie(FULL_NAME, fullName);
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);

    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(IS_NPI_ADMIN, isNpiAdmin);
    setCookie(IS_ADMIN, isAdmin);
    setCookie(IS_NPI, isNpi);
    setCookie(IS_PLANNING, isPlanning);
    setCookie(IS_SALE, isSale);
}
function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data);
}
function getO365Token() {
    return getCookie(O365_TOKEN);
}

function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data);
}
function getUserImageCookie() {
    return getCookie(USER_IMAGE);
}
function clearToken() {
    removeCookie(TOKEN);
    removeCookie(EXPIRES_DATE);
    removeCookie(USER_ID);
    removeCookie(FULL_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_ADMIN);
    removeCookie(IS_NPI_ADMIN);
    removeCookie(IS_NPI);
    removeCookie(IS_PLANNING);
    removeCookie(IS_SALE);
}

function getAllCookies() {
    var _ref;

    console.log('test fff getAllCookies');
    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, EXPIRES_DATE, getCookie(EXPIRES_DATE)), _defineProperty(_ref, USER_ID, getCookie(USER_ID)), _defineProperty(_ref, IS_NPI_ADMIN, getCookie(IS_NPI_ADMIN)), _defineProperty(_ref, IS_ADMIN, getCookie(IS_ADMIN)), _defineProperty(_ref, FULL_NAME, getCookie(FULL_NAME)), _ref;
}

function getToken() {
    return getCookie(TOKEN);
}

function getFullName() {
    return getCookie(FULL_NAME);
}

function getRole() {
    return getCookie(ROLE);
}

function getExpireDate() {
    return getCookie(EXPIRES_DATE);
}

function getIsNpiAdmin() {
    return getCookie(IS_NPI_ADMIN);
}

function getIsAdmin() {
    return getCookie(IS_ADMIN);
}

function setSearchCookie(data) {
    var priorityCode = data.priorityCode,
        statusCode = data.statusCode,
        searchText = data.searchText,
        searchAPI = data.searchAPI,
        searchCustomer = data.searchCustomer;

    clearSearchCookie();
    setCookie(SALE_SEARCH_STATUS, statusCode);
    setCookie(SALE_SEARCH_PRIORITY, priorityCode);
    setCookie(SALE_SEARCH_TEXT, searchText);
    setCookie(SALE_SEARCH_API, searchAPI);
    setCookie(SALE_SEARCH_CUSTOMER, searchCustomer);
}

function getSearchCookie() {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, SALE_SEARCH_STATUS, getCookie(SALE_SEARCH_STATUS)), _defineProperty(_ref2, SALE_SEARCH_PRIORITY, getCookie(SALE_SEARCH_PRIORITY)), _defineProperty(_ref2, SALE_SEARCH_TEXT, getCookie(SALE_SEARCH_TEXT)), _defineProperty(_ref2, SALE_SEARCH_API, getCookie(SALE_SEARCH_API)), _defineProperty(_ref2, SALE_SEARCH_CUSTOMER, getCookie(SALE_SEARCH_CUSTOMER)), _ref2;
}

function clearSearchCookie() {
    removeCookie(SALE_SEARCH_STATUS);
    removeCookie(SALE_SEARCH_PRIORITY);
    removeCookie(SALE_SEARCH_TEXT);
    removeCookie(SALE_SEARCH_API);
    removeCookie(SALE_SEARCH_CUSTOMER);
}

function setTubeSearchCookie(data) {
    var priorityCode = data.priorityCode,
        statusCode = data.statusCode,
        searchText = data.searchText,
        searchAPI = data.searchAPI,
        searchCustomer = data.searchCustomer;

    clearSearchCookie();
    setCookie(TUBE_SEARCH_STATUS, statusCode);
    setCookie(TUBE_SEARCH_PRIORITY, priorityCode);
    setCookie(TUBE_SEARCH_TEXT, searchText);
    setCookie(TUBE_SEARCH_API, searchAPI);
    setCookie(TUBE_SEARCH_CUSTOMER, searchCustomer);
}

function getTubeSearchCookie() {
    var _ref3;

    return _ref3 = {}, _defineProperty(_ref3, TUBE_SEARCH_STATUS, getCookie(TUBE_SEARCH_STATUS)), _defineProperty(_ref3, TUBE_SEARCH_PRIORITY, getCookie(TUBE_SEARCH_PRIORITY)), _defineProperty(_ref3, TUBE_SEARCH_TEXT, getCookie(TUBE_SEARCH_TEXT)), _defineProperty(_ref3, TUBE_SEARCH_API, getCookie(TUBE_SEARCH_API)), _defineProperty(_ref3, TUBE_SEARCH_CUSTOMER, getCookie(TUBE_SEARCH_CUSTOMER)), _ref3;
}

function clearTubeSearchCookie() {
    removeCookie(TUBE_SEARCH_STATUS);
    removeCookie(TUBE_SEARCH_PRIORITY);
    removeCookie(TUBE_SEARCH_TEXT);
    removeCookie(TUBE_SEARCH_API);
    removeCookie(TUBE_SEARCH_CUSTOMER);
}

function setAccSearchCookie(data) {
    var priorityCode = data.priorityCode,
        statusCode = data.statusCode,
        searchText = data.searchText,
        searchAPI = data.searchAPI,
        searchCustomer = data.searchCustomer,
        searchTypeAcc = data.searchTypeAcc;

    clearSearchCookie();
    setCookie(ACC_SEARCH_STATUS, statusCode);
    setCookie(ACC_SEARCH_PRIORITY, priorityCode);
    setCookie(ACC_SEARCH_TEXT, searchText);
    setCookie(ACC_SEARCH_API, searchAPI);
    setCookie(ACC_SEARCH_CUSTOMER, searchCustomer);
    setCookie(ACC_SEARCH_TYPE, searchTypeAcc);
}

function getAccSearchCookie() {
    var _ref4;

    return _ref4 = {}, _defineProperty(_ref4, ACC_SEARCH_STATUS, getCookie(ACC_SEARCH_STATUS)), _defineProperty(_ref4, ACC_SEARCH_PRIORITY, getCookie(ACC_SEARCH_PRIORITY)), _defineProperty(_ref4, ACC_SEARCH_TEXT, getCookie(ACC_SEARCH_TEXT)), _defineProperty(_ref4, ACC_SEARCH_API, getCookie(ACC_SEARCH_API)), _defineProperty(_ref4, ACC_SEARCH_CUSTOMER, getCookie(ACC_SEARCH_CUSTOMER)), _defineProperty(_ref4, ACC_SEARCH_TYPE, getCookie(ACC_SEARCH_TYPE)), _ref4;
}

function clearAccSearchCookie() {
    removeCookie(ACC_SEARCH_STATUS);
    removeCookie(ACC_SEARCH_PRIORITY);
    removeCookie(ACC_SEARCH_TEXT);
    removeCookie(ACC_SEARCH_API);
    removeCookie(ACC_SEARCH_CUSTOMER);
    removeCookie(ACC_SEARCH_TYPE);
}

function getIsNpi() {
    return getCookie(IS_NPI);
}

function getIsPlanning() {
    return getCookie(IS_PLANNING);
}

function getIsSale() {
    return getCookie(IS_SALE);
}

function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data);
}
function getUrlIncoming() {
    return getCookie(URL_INCOMING);
}

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_LOAD_MANAGE_SYSTEMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_LOAD_MANAGE_SYSTEMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_LOAD_MANAGE_SYSTEMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_LOAD_MANAGE_SYSTEM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_LOAD_MANAGE_SYSTEM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_LOAD_MANAGE_SYSTEM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_LOAD_MANAGE_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_LOAD_MANAGE_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_LOAD_MANAGE_GROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_LOAD_MANAGE_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_LOAD_MANAGE_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_LOAD_MANAGE_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE; });


var CORE_LOAD_MANAGE_SYSTEMS_REQUEST = 'CORE_LOAD_MANAGE_SYSTEMS_REQUEST';
var CORE_LOAD_MANAGE_SYSTEMS_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEMS_SUCCESS';
var CORE_LOAD_MANAGE_SYSTEMS_FAILURE = 'CORE_LOAD_MANAGE_SYSTEMS_FAILURE';

var CORE_LOAD_MANAGE_SYSTEM_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_REQUEST';
var CORE_LOAD_MANAGE_SYSTEM_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_SUCCESS';
var CORE_LOAD_MANAGE_SYSTEM_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_FAILURE';

var CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST';
var CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS';
var CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE';

var CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST';
var CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS';
var CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE';

var CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST = 'CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST';
var CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS = 'CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS';
var CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE = 'CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE';

var CORE_LOAD_MANAGE_GROUPS_REQUEST = 'CORE_LOAD_MANAGE_GROUPS_REQUEST';
var CORE_LOAD_MANAGE_GROUPS_SUCCESS = 'CORE_LOAD_MANAGE_GROUPS_SUCCESS';
var CORE_LOAD_MANAGE_GROUPS_FAILURE = 'CORE_LOAD_MANAGE_GROUPS_FAILURE';

var CORE_LOAD_MANAGE_GROUP_REQUEST = 'CORE_LOAD_MANAGE_GROUP_REQUEST';
var CORE_LOAD_MANAGE_GROUP_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_SUCCESS';
var CORE_LOAD_MANAGE_GROUP_FAILURE = 'CORE_LOAD_MANAGE_GROUP_FAILURE';

var CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST = 'CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST';
var CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS';
var CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE = 'CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE';

var CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST = 'CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST';
var CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS';
var CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE = 'CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE';

var CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST = 'CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST';
var CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS = 'CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS';
var CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE = 'CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE';

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorList;
/* unused harmony export getCallAPI */
/* harmony export (immutable) */ __webpack_exports__["b"] = getLoading;
function getErrorList(state) {
    return state.errorList;
}

function getCallAPI(state) {
    return state.callAPI;
}

function getLoading(state) {
    return state.isLoading;
}

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_LOAD_MASTER_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_LOAD_MASTER_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_LOAD_MASTER_DATA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_LOAD_MASTER_DATA_COATINGS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_LOAD_MASTER_DATA_COATINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_LOAD_MASTER_DATA_COATING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_LOAD_MASTER_DATA_COATING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_LOAD_MASTER_DATA_COATING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_LOAD_MASTER_DATA_COATING_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_LOAD_MASTER_DATA_COATING_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_LOAD_MASTER_DATA_COATING_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE; });

var CORE_LOAD_MASTER_DATA_REQUEST = 'CORE_LOAD_MASTER_DATA_REQUEST';
var CORE_LOAD_MASTER_DATA_SUCCESS = 'CORE_LOAD_MASTER_DATA_SUCCESS';
var CORE_LOAD_MASTER_DATA_FAILURE = 'CORE_LOAD_MASTER_DATA_FAILURE';

var CORE_LOAD_MASTER_DATA_COATINGS_REQUEST = 'CORE_LOAD_MASTER_DATA_COATINGS_REQUEST';
var CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS = 'CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS';
var CORE_LOAD_MASTER_DATA_COATINGS_FAILURE = 'CORE_LOAD_MASTER_DATA_COATINGS_FAILURE';

var CORE_LOAD_MASTER_DATA_COATING_REQUEST = 'CORE_LOAD_MASTER_DATA_COATING_REQUEST';
var CORE_LOAD_MASTER_DATA_COATING_SUCCESS = 'CORE_LOAD_MASTER_DATA_COATING_SUCCESS';
var CORE_LOAD_MASTER_DATA_COATING_FAILURE = 'CORE_LOAD_MASTER_DATA_COATING_FAILURE';

var CORE_LOAD_MASTER_DATA_COATING_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_COATING_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_COATING_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_COATING_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_COATING_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_COATING_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE';

var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE';

var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE';

var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE';

var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE';

var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE';

var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_REQUEST = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_REQUEST';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_SUCCESS = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_SUCCESS';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_FAILURE = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_FAILURE';

var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_REQUEST = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_REQUEST';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_SUCCESS = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_SUCCESS';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_FAILURE = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_FAILURE';

var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_PAINT_LOCATION_DELETE_FAILURE';

var CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST = 'CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST';
var CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS = 'CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS';
var CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE = 'CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE';

var CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE';

var CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_REQUEST = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_REQUEST';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE';

var CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_REQUEST = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_REQUEST';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE';

var CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_REQUEST = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_REQUEST';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS';
var CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE = 'CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE';

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"ค้นหา","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"ค้นหา","showLess":"แสดงแบบย่อ","showAll":"แสดงทั้งหมด"}}

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(407);

// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(195);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/shareFunctions.js
var mapOptions = function mapOptions(data) {
    var options = [];
    options = data.map(function (d) {
        return {
            value: d.id,
            text: d.name
        };
    });
    return options;
};
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return api["d" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return api["e" /* REDIRECT_O365_URI */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["c" /* CLIENT_ID */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api["b" /* ACTIVE_ITEM_TAB */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* ACTIVE_ITEM2_TAB */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return api["g" /* VERSION_NO */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return api["f" /* SYSTEM_NAME */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return auth["a" /* TOKEN */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return auth["b" /* USER_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["c" /* authentication */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["v" /* setO365TokenCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["z" /* setUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return auth["t" /* getUserImageCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["f" /* clearToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return auth["i" /* getAllCookies */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["q" /* getToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return auth["j" /* getFullName */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return auth["m" /* getIsNpiAdmin */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return auth["k" /* getIsAdmin */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["w" /* setSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["p" /* getSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["e" /* clearSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["x" /* setTubeSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["r" /* getTubeSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["g" /* clearTubeSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["u" /* setAccSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["h" /* getAccSearchCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["d" /* clearAccSearchCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return auth["l" /* getIsNpi */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return auth["n" /* getIsPlanning */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return auth["o" /* getIsSale */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["y" /* setUrlIncoming */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return auth["s" /* getUrlIncoming */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return mapOptions; });





/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });
        if (resStatusError.includes(res.status)) {
            return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();
            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                var url = { endpoint: endpoint, method: method };
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true, url: url });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            next(action);
        };
    };
});
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(195);

// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {

            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = null;
            var entryType = entry.types[0];

            if (entryType.startsWith("CORE")) {
                token = Object(auth["q" /* getToken */])();
            }

            if (!token) return next(action);
            //  return false
            entry.headers = _extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
            }
            entry.headers["Access-Control-Allow-Origin"] = "*";
            entry.headers["Access-Control-Allow-Methods"] = "*";
            entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With";

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(141);



var LoaderExampleInlineCentered = function LoaderExampleInlineCentered() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["p" /* Loader */],
    { active: true, inline: 'centered', size: 'large' },
    'Loading'
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LoaderExampleInlineCentered);

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loadingInline__ = __webpack_require__(404);




var Loading = function Loading(props) {
    var active = props && props.isActive ? props.isActive : false;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["f" /* Dimmer */],
        { style: { position: 'fixed' }, active: active },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__loadingInline__["a" /* default */], null)
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDIRECT_O365_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVE_ITEM_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_ITEM2_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VERSION_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SYSTEM_NAME; });
// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"

// Localhost 
// export const CORE_API_ENDPOINT = "http://localhost:2000"
// export const REDIRECT_O365_URI = "http://localhost:8080/login"
//export const AX_URL = "http://localhost:8080"

// // NPI UAT Server
var CORE_API_ENDPOINT = "https://npitest.cigblusolutions.com/api";
var REDIRECT_O365_URI = "https://npitest.cigblusolutions.com/login";
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// NPI Prod Server
// export const CORE_API_ENDPOINT = "https://npi.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://npi.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

// NPI DEV Server 
// export const CORE_API_ENDPOINT = "https://npidev.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://npidev.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// export const CORE_API_ENDPOINT = "/api"
// export const REDIRECT_O365_URI = "/login"

var CLIENT_ID = "0b1bf20d-a148-44d2-8932-027dbaf66a46";
var ACTIVE_ITEM_TAB = 6; //6
var ACTIVE_ITEM2_TAB = 2; //6
var VERSION_NO = "3.1.0";
// export const SYSTEM_NAME = `${(CORE_API_ENDPOINT.search("localhost") > -1) || (CORE_API_ENDPOINT.search("test") > -1) ? "NPIUAT" : "NPIPROD"}`
var SYSTEM_NAME = "npi";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(409);


/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__(410);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(193);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(616);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 5 modules
var react_router_dom = __webpack_require__(109);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(61);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(633);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(634);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var react_loadable_lib = __webpack_require__(645);
var react_loadable_lib_default = /*#__PURE__*/__webpack_require__.n(react_loadable_lib);

// CONCATENATED MODULE: ./src/app/components/features/share/loadable/loadableRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// import LoadingInline from '../loadingInline'

var loadableRoute_Loading = function Loading() {
    return react_default.a.createElement('div', { className: 'module loadableRoute' });
};

/* harmony default export */ var loadableRoute = (function (opts) {
    return react_loadable_lib_default()(_extends({
        loading: loadableRoute_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 2 modules
var src_lib = __webpack_require__(401);

// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(195);

// CONCATENATED MODULE: ./src/app/routes/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var Auth = {
	isAuthenticated: function isAuthenticated() {
		var cookies = Object(src_lib["i" /* getAllCookies */])();
		var isAuth = false;

		if (cookies && cookies[src_lib["f" /* TOKEN */]] && cookies[src_lib["g" /* USER_ID */]]) {
			isAuth = true;
		}
		return isAuth;
	},
	isNpiAdmin: function isNpiAdmin() {
		var isAdmin = Object(src_lib["m" /* getIsNpiAdmin */])();
		return isAdmin.toString() === "true";
	},
	isAdmin: function isAdmin() {
		var isAdmin = Object(src_lib["k" /* getIsAdmin */])();
		return isAdmin.toString() === "true";
	}
};

var routePermission_AdminPrivateRoute = function AdminPrivateRoute(_ref) {
	var Component = _ref.component,
	    Layout = _ref.layout,
	    staticContext = _ref.staticContext,
	    rest = _objectWithoutProperties(_ref, ['component', 'layout', 'staticContext']);

	return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				var urlIncoming = props.match.url;
				routePermission_setUrlIncome(urlIncoming);
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
			}

			if (Auth.isAdmin() === false) {
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
			}

			if (Layout) {
				return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
			} else {
				if (Component !== undefined) {
					return react_default.a.createElement(Component, props);
				} else {
					return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
				}
			}
		} }));
};

var routePermission_NPIPrivateRoute = function NPIPrivateRoute(_ref2) {
	var Component = _ref2.component,
	    Layout = _ref2.layout,
	    staticContext = _ref2.staticContext,
	    rest = _objectWithoutProperties(_ref2, ['component', 'layout', 'staticContext']);

	return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				var urlIncoming = props.match.url;
				routePermission_setUrlIncome(urlIncoming);
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
			}

			if (Auth.isNpiAdmin() === false) {
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
			}

			if (Layout) {
				return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
			} else {
				if (Component !== undefined) {
					return react_default.a.createElement(Component, props);
				} else {
					return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
				}
			}
		} }));
};

var routePermission_PrivateRoute = function PrivateRoute(_ref3) {
	var Component = _ref3.component,
	    Layout = _ref3.layout,
	    staticContext = _ref3.staticContext,
	    rest = _objectWithoutProperties(_ref3, ['component', 'layout', 'staticContext']);

	return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				var urlIncoming = props.match.url;
				routePermission_setUrlIncome(urlIncoming);
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
			}

			if (Layout) {
				return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
			} else {
				if (Component !== undefined) {
					return react_default.a.createElement(Component, props);
				} else {
					return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
				}
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref4) {
	var Component = _ref4.component,
	    Layout = _ref4.layout,
	    staticContext = _ref4.staticContext,
	    rest = _objectWithoutProperties(_ref4, ['component', 'layout', 'staticContext']);

	return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
			}

			if (Layout) {
				return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
			} else {
				if (Component !== undefined) {
					return react_default.a.createElement(Component, props);
				} else {
					return null;
				}
			}
		} }));
};

var routePermission_setUrlIncome = function setUrlIncome(url) {
	Object(auth["y" /* setUrlIncoming */])(url);
};


// CONCATENATED MODULE: ./src/app/routes/Routes.js





//Layout
var LayoutMaster = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1416));
    }
});
var LayoutBlank = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1417));
    }
});

// const LayoutWithHeader = LoadableRoute({
//     loader: () => import('../components/layout/controllers/layoutWithHeader'),
// })

//Features
//Auth
var Login = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1418));
    }
});
var NotFoundController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1419));
    }
});
var UnAuthenController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1420));
    }
});

// Home
var HomeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1421));
    }
});

var CreateReportController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1422));
    }
});

var CreateDrawingController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1423));
    }
});

var CreateItemsController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1424));
    }
});

var CreateItem2Controller = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1425));
    }
});

var ExportReportController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 1426));
    }
});

var SearchDrawingController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1427));
    }
});

var ViewDrawingController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1428));
    }
});

var ViewItem2Controller = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1428));
    }
});

var CreateSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1429));
    }
});

var UpdateSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1430));
    }
});

var ViewSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1431));
    }
});

var SearchSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1432));
    }
});

var ViewReqSearchSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1433));
    }
});

var ViewReqCreateSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1434));
    }
});

var ViewReqViewSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1435));
    }
});

var ViewReqUpdateSellOrderController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1436));
    }
});

// const ListSellOrderController = LoadableRoute({
// loader: () => import('../components/features/reqDrawing/coilOrder/controllers/listSellOrderController'),
//     loader: () => import('../components/features/reqDrawing/coilOrder/controllers/searchSellOrderController'),
// })

// const OverviewControler = LoadableRoute({
//     loader: () => import('../components/features/report/controllers/overviewController'),
// })

var OverviewSellOrderControler = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1437));
    }
});

var ReStatusReqDrawingController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1438));
    }
});

var SystenInfoView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 1439));
    }
    // loader: () => import('../components/features/info/controllers/infoController'),
});
var ViewMasterHome = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 1440));
    }
});

var ViewMasterCoatingList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 1441));
    }
});
var ViewMasterCoatingCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1442));
    }
});
// const ViewMasterCoatingView = LoadableRoute({
//     loader: () => import('../components/features/masterData/controllers/coating/coatingViewController'),
// })
var ViewMasterCoatingUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1443));
    }
});

var ViewMasterFinEdgeList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 1444));
    }
});
var ViewMasterFinEdgeCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1445));
    }
});
var ViewMasterFinEdgeView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1446));
    }
});
var ViewMasterFinEdgeUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1447));
    }
});

var ViewMasterFinMaterialList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1448));
    }
});
var ViewMasterFinMaterialCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1449));
    }
});
var ViewMasterFinMaterialView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1450));
    }
});

var ViewMasterFinMaterialUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1451));
    }
});

var ViewMasterFinSurfaceList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 1452));
    }
});
var ViewMasterFinSurfaceCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1453));
    }
});
var ViewMasterFinSurfaceView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1454));
    }
});

var ViewMasterFinSurfaceUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1455));
    }
});

var ViewMasterTubeSizeList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1456));
    }
});
var ViewMasterTubeSizeCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1457));
    }
});
var ViewMasterTubeSizeView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1458));
    }
});
var ViewMasterTubeSizeUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1459));
    }
});
var ViewMasterInsideShapeList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 1460));
    }
});
var ViewMasterInsideShapeCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1461));
    }
});
var ViewMasterInsideShapeView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1462));
    }
});
var ViewMasterInsideShapeUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1463));
    }
});
var ViewMasterTubeMaterialList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1464));
    }
});
var ViewMasterTubeMaterialCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1465));
    }
});
var ViewMasterTubeMaterialView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1466));
    }
});
var ViewMasterTubeMaterialUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1467));
    }
});
var ViewMasterPlateMaterialList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1468));
    }
});
var ViewMasterPlateMaterialCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1469));
    }
});
var ViewMasterPlateMaterialView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1470));
    }
});
var ViewMasterPlateMaterialUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1471));
    }
});
var ViewMasterTubePatternList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1472));
    }
});
var ViewMasterTubePatternCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1473));
    }
});
var ViewMasterTubePatternView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1474));
    }
});
var ViewMasterTubePatternUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1475));
    }
});
var ViewMasterTubeSizeAndPatternList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1476));
    }
});
var ViewMasterTubeSizeAndPatternCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1477));
    }
});
var ViewMasterTubeSizeAndPatternView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1478));
    }
});
var ViewMasterTubeSizeAndPatternUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1479));
    }
});
var ViewMasterProductGroupList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1480));
    }
});
var ViewMasterProductGroupCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1481));
    }
});
var ViewMasterProductGroupView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1482));
    }
});
var ViewMasterProductGroupUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1483));
    }
});
var ViewMasterPaintLocationList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1484));
    }
});
var ViewMasterPaintLocationCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1485));
    }
});
var ViewMasterPaintLocationView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1486));
    }
});
var ViewMasterPaintLocationUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1487));
    }
});

var ViewSetting = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1488));
    }
});

var ViewSystemInfoSetting = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1489));
    }
});

var ViewMasterCoilTypeList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1490));
    }
});
var ViewMasterCoilTypeCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1491));
    }
});
var ViewMasterCoilTypeView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1492));
    }
});

var ViewMasterCoilTypeUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1493));
    }
});

// const ViewManageHome = LoadableRoute({
//     loader: () => import('../components/features/manage/views/viewManageHome'),
// })


var ViewManageSystemList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1494));
    }
});
var ViewManageSystemCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1495));
    }
});
var ViewManageSystemView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1496));
    }
});

var ViewManageSystemUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1497));
    }
});

var ViewManageGroupList = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 1498));
    }
});
var ViewManageGroupCreate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1499));
    }
});
var ViewManageGroupView = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1500));
    }
});

var ViewManageGroupUpdate = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1501));
    }
});

var UserListController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1502));
    }
});

var UserManageNpiController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1503));
    }
});
var UserManageAdminController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1504));
    }
});

// const ReportController = LoadableRoute({
//     loader: () => import('../components/features/user/controllers/userAdminComtroller'),
// })

var NpiReportController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1505));
    }
});

var OverviewController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 1506));
    }
});

var ReportViewDrawingController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1507));
    }
});

// New System 2022_02_15
// const ViewTubeInTubeListOrder = LoadableRoute({
//     loader: () => import('../components/features/mockup/controllers/renderMockupController'),
// })

var ListTubeInTubeControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1508));
    }
});
var CreateTubeInTubeControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1509));
    }
});
var ViewTubeInTubeControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1510));
    }
});
var UpdateTubeInTubeControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1511));
    }
});

var ListDrawingTubeInTubeControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1512));
    }
});

var ViewDrawingTubeInTubeControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1513));
    }
});

var ListDrawingAccessoryControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1514));
    }
});

var ViewDrawingAccessoryControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1515));
    }
});

var ListAccessoryControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1516));
    }
});

var ListDownloadPdfControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1517));
    }
});

var CreateAccessoryControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1518));
    }
});

var UpdateAccessoryControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1519));
    }
});

var ViewAccessoryControllers = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1520));
    }
});

var SearchOneDriveController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1521));
    }
});

var MainPageReqDrawing = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 1522));
    }
});

var MainPageDrawingSystem = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 1523));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/tubeInTube/update/:active/:id', component: UpdateTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/tubeInTube/view/:active/:id', component: ViewTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/coil/update/:active/:id', component: UpdateSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/coil/view/:active/:id', component: ViewSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/accessory/view/:active/:id', component: ViewAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coating/update/:id', component: ViewMasterCoatingUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finedge/view/:id', component: ViewMasterFinEdgeView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finedge/update/:id', component: ViewMasterFinEdgeUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finmaterial/view/:id', component: ViewMasterFinMaterialView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finmaterial/update/:id', component: ViewMasterFinMaterialUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finsurface/view/:id', component: ViewMasterFinSurfaceView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finsurface/update/:id', component: ViewMasterFinSurfaceUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesize/view/:id', component: ViewMasterTubeSizeView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesize/update/:id', component: ViewMasterTubeSizeUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/insideshape/view/:id', component: ViewMasterInsideShapeView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/insideshape/update/:id', component: ViewMasterInsideShapeUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubematerial/view/:id', component: ViewMasterTubeMaterialView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubematerial/update/:id', component: ViewMasterTubeMaterialUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/platematerial/view/:id', component: ViewMasterPlateMaterialView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/platematerial/update/:id', component: ViewMasterPlateMaterialUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubepattern/view/:id', component: ViewMasterTubePatternView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubepattern/update/:id', component: ViewMasterTubePatternUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesizeandpattern/view/:id', component: ViewMasterTubeSizeAndPatternView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesizeandpattern/update/:id', component: ViewMasterTubeSizeAndPatternUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/productgroup/view/:id', component: ViewMasterProductGroupView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/productgroup/update/:id', component: ViewMasterProductGroupUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/paintlocation/view/:id', component: ViewMasterPaintLocationView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/paintlocation/update/:id', component: ViewMasterPaintLocationUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coiltype/view/:id', component: ViewMasterCoilTypeView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coiltype/update/:id', component: ViewMasterCoilTypeUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/accessory/update/:id', component: UpdateAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/accessory/view/:id', component: ViewAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/tubeInTube/update/:id', component: UpdateTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/tubeInTube/view/:id', component: ViewTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/coil/view/:id', component: ViewSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/coil/update/:id', component: UpdateSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/group/view/:id', component: ViewManageGroupView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/group/update/:id', component: ViewManageGroupUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/system/view/:id', component: ViewManageSystemView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/system/update/:id', component: ViewManageSystemUpdate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/items/tubeInTube/view/:id', component: ViewDrawingTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/items/accessory/view/:id', component: ViewDrawingAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/drawing/view/:drawingId', component: ViewDrawingController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/drawing/update/:drawingId', component: CreateReportController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/item/view/:drawingId', component: ViewItem2Controller, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/item/update/:drawingId', component: CreateItem2Controller, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coating/create', component: ViewMasterCoatingCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finedge/create', component: ViewMasterFinEdgeCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finmaterial/create', component: ViewMasterFinMaterialCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finsurface/create', component: ViewMasterFinSurfaceCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesize/create', component: ViewMasterTubeSizeCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/insideshape/create', component: ViewMasterInsideShapeCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubematerial/create', component: ViewMasterTubeMaterialCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/platematerial/create', component: ViewMasterPlateMaterialCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubepattern/create', component: ViewMasterTubePatternCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesizeandpattern/create', component: ViewMasterTubeSizeAndPatternCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/productgroup/create', component: ViewMasterProductGroupCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/paintlocation/create', component: ViewMasterPaintLocationCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coiltype/create', component: ViewMasterCoilTypeCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/group/create', component: ViewManageGroupCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/system/create', component: ViewManageSystemCreate, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/accessory/create', component: CreateAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/tubeInTube/create', component: CreateTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/requestDrawing/restatus', component: ReStatusReqDrawingController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/coil/create', component: CreateSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewRequestDrawing/coil/update/:active/:id', component: ViewReqUpdateSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewRequestDrawing/coil/update/:id', component: ViewReqUpdateSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewRequestDrawing/coil/view/:active/:id', component: ViewReqViewSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewRequestDrawing/coil/view/:id', component: ViewReqViewSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewRequestDrawing/coil/create', component: ViewReqCreateSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/viewRequestDrawing/coil', component: ViewReqSearchSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/downloadpdf', component: ListDownloadPdfControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/accessory', component: ListAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/tubeInTube', component: ListTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing/coil', component: SearchSellOrderController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report/npi', component: NpiReportController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report/requestDrawing', component: OverviewSellOrderControler, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report/viewDrawing', component: ReportViewDrawingController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/create/drawing', component: CreateDrawingController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/create/item', component: CreateItemsController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coating', component: ViewMasterCoatingList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finedge', component: ViewMasterFinEdgeList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finmaterial', component: ViewMasterFinMaterialList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/finsurface', component: ViewMasterFinSurfaceList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesize', component: ViewMasterTubeSizeList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/insideshape', component: ViewMasterInsideShapeList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubematerial', component: ViewMasterTubeMaterialList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/platematerial', component: ViewMasterPlateMaterialList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubepattern', component: ViewMasterTubePatternList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/tubesizeandpattern', component: ViewMasterTubeSizeAndPatternList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/productgroup', component: ViewMasterProductGroupList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/paintlocation', component: ViewMasterPaintLocationList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master/coiltype', component: ViewMasterCoilTypeList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/group', component: ViewManageGroupList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/manage/system', component: ViewManageSystemList, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/user/manageadmin', component: UserManageAdminController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/user/managenpi', component: UserManageNpiController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/settings/system', component: ViewSystemInfoSetting, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/items/accessory', component: ListDrawingAccessoryControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/items/tubeInTube', component: ListDrawingTubeInTubeControllers, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/items/coil', component: SearchDrawingController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/searchOneDrive', component: SearchOneDriveController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report', component: OverviewController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_NPIPrivateRoute, { path: '/itemsmenu', component: MainPageDrawingSystem, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/export', component: ExportReportController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/master', component: ViewMasterHome, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/requestDrawing', component: MainPageReqDrawing, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/info', component: SystenInfoView, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/users', component: UserListController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_AdminPrivateRoute, { path: '/settings', component: ViewSetting, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PrivateRoute, { exact: true, path: '/', component: HomeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login', component: Login, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/unauthen', component: UnAuthenController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { component: NotFoundController, layout: LayoutMaster })
    );
});
// CONCATENATED MODULE: ./src/app/routes/App.js



/* harmony default export */ var App = (function () {
    return react_default.a.createElement(Routes, null);
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(263);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 262 modules
var dist_es = __webpack_require__(141);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(19);

// CONCATENATED MODULE: ./src/app/redux/actions/actionsCallAPI.js
var actionsCallAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// import { CALL_API } from 'Middlewares'


function actionsCallAPI_setError(errorList, newError, isShow) {
	var mapError = [];
	if (errorList && Array.isArray(errorList)) {
		if (isShow === true) {
			errorList.forEach(function (e) {
				mapError.push(actionsCallAPI__extends({}, e, { isShow: true }));
			});
		} else {
			mapError = mapError.concat(errorList);
		}
	}
	if (newError) {
		mapError.push(actionsCallAPI__extends({}, newError, { isShow: false }));
	}
	return {
		type: types["_242" /* SET_ERROR */],
		error: mapError
	};
}

function actionsCallAPI_setLoading(isLoading) {
	return {
		type: types["_243" /* SET_LOADING */],
		isLoading: isLoading
	};
}
// EXTERNAL MODULE: ./src/app/redux/selectors/selectorCallAPI.js
var selectorCallAPI = __webpack_require__(267);

// CONCATENATED MODULE: ./src/app/components/features/config.js

var imagePageLogin = '/assets/images/logo-page-login.png';
var image_header = '/assets/images/logo-mene.png';

var iconCloseModalError = '/assets/images/clear.png';
// export const iconLogoModalError = '/assets/images/icon-deleteCircle-fff.png'
var iconLogoModalError = '/assets/images/warning.png';
var iconCloseOnBG = '/assets/images/icon-delete-fff.png';

//Image Next Prev
var iconArrowLeft = '/assets/images/icon-arrow-left.png';
var iconArrowRight = '/assets/images/icon-arrow-right.png';
// CONCATENATED MODULE: ./src/app/components/features/share/modal/actionModal.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var actionModal_ActionModal = function (_React$Component) {
	_inherits(ActionModal, _React$Component);

	function ActionModal(props) {
		_classCallCheck(this, ActionModal);

		var _this = _possibleConstructorReturn(this, (ActionModal.__proto__ || Object.getPrototypeOf(ActionModal)).call(this, props));

		_this.state = {
			open: false
		};
		return _this;
	}

	_createClass(ActionModal, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    open = _props.open,
			    type = _props.type,
			    header = _props.header,
			    detail = _props.detail,
			    typeAction = _props.typeAction,
			    close = _props.close,
			    submit = _props.submit,
			    cancelButtonName = _props.cancelButtonName;


			var _type = 'question',
			    _header = '',
			    _detail = '',
			    classModal = '';

			if (type) {
				_type = type;
			}

			_header = header;
			_detail = detail;

			switch (_type) {
				case 'question':
					classModal = 'question';
					break;
				case 'warning':
					classModal = 'warning';
					break;
				case 'danger':
					classModal = 'danger';
					break;
				case 'detail':
					classModal = 'detail';
					break;
				default:
					break;
			}

			return react_default.a.createElement(
				react_default.a.Fragment,
				null,
				react_default.a.createElement(
					dist_es["r" /* Modal */],
					{ open: open, onClose: close, size: classModal !== "detail" ? "tiny" : "large",
						className: 'module actionModal' },
					react_default.a.createElement(
						dist_es["r" /* Modal */].Header,
						{ className: 'headerBG ' + classModal },
						react_default.a.createElement(
							dist_es["j" /* Grid */],
							null,
							react_default.a.createElement(
								dist_es["j" /* Grid */].Row,
								null,
								react_default.a.createElement(
									dist_es["j" /* Grid */].Column,
									{ width: 16, className: 'inlineFlex' },
									react_default.a.createElement(
										'div',
										{ className: 'boxHeaderContent' },
										react_default.a.createElement(
											'div',
											{ className: 'boxImageClose', onClick: this.props.close },
											react_default.a.createElement('img', { src: iconCloseModalError, alt: '' })
										)
									),
									classModal !== "detail" && react_default.a.createElement(
										'div',
										{ className: 'boxImageLogo' },
										react_default.a.createElement('img', { src: iconLogoModalError, alt: '', className: 'imgIcon' })
									),
									react_default.a.createElement(
										'div',
										{ className: 'boxTextHeader ' + classModal },
										react_default.a.createElement(
											'p',
											{ className: 'dialogHeader ' + (classModal !== "detail" ? " padLeft20" : "") },
											_header
										)
									)
								)
							)
						)
					),
					react_default.a.createElement(
						dist_es["r" /* Modal */].Content,
						null,
						react_default.a.createElement(
							dist_es["r" /* Modal */].Description,
							null,
							react_default.a.createElement(
								dist_es["j" /* Grid */],
								null,
								react_default.a.createElement(
									dist_es["j" /* Grid */].Row,
									null,
									react_default.a.createElement(
										dist_es["j" /* Grid */].Column,
										{ width: 16 },
										react_default.a.createElement(
											'div',
											{ className: 'boxTextDetail' },
											react_default.a.createElement(
												'p',
												null,
												_detail
											),
											react_default.a.createElement('div', { className: 'boxAction' })
										)
									)
								),
								react_default.a.createElement(
									dist_es["j" /* Grid */].Row,
									null,
									react_default.a.createElement(
										dist_es["j" /* Grid */].Column,
										{ textAlign: 'center' },
										react_default.a.createElement(
											dist_es["c" /* Button */],
											{ className: 'btn cancel', onClick: close },
											cancelButtonName ? cancelButtonName : "Cancel"
										),
										typeAction === 'delete' && react_default.a.createElement(
											dist_es["c" /* Button */],
											{ className: 'btn delete', onClick: submit },
											'Delete'
										)
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return ActionModal;
}(react_default.a.Component);

/* harmony default export */ var actionModal = (actionModal_ActionModal);
// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(192);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/errorModal.js
var errorModal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var errorModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function errorModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function errorModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function errorModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import { iconCloseModalError, iconLogoModalError } from '../../config'



var errorModal_ErrorModal = function (_React$Component) {
	errorModal__inherits(ErrorModal, _React$Component);

	function ErrorModal(props) {
		errorModal__classCallCheck(this, ErrorModal);

		var _this = errorModal__possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).call(this, props));

		_this.state = {};
		return _this;
	}

	errorModal__createClass(ErrorModal, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    errorList = _props.errorList,
			    t = _props.t;


			return react_default.a.createElement(actionModal, errorModal__extends({
				typeAction: 'danger',
				type: 'danger',
				header: t('common.somethingWrong'),
				detail: react_default.a.createElement(
					dist_es["j" /* Grid */],
					null,
					react_default.a.createElement(
						dist_es["j" /* Grid */].Row,
						null,
						react_default.a.createElement(
							dist_es["j" /* Grid */].Column,
							null,
							react_default.a.createElement(
								dist_es["o" /* List */],
								{ divided: true, verticalAlign: 'middle' },
								errorList.map(function (e, i) {
									var message = e.message,
									    path = e.path,
									    code = e.code;

									var data = { statusText: message, statusCode: path, code: code };
									return react_default.a.createElement(errorModal_ItemErrorObj, { key: i, data: data });
								})
							)
						)
					)
				)
			}, { open: errorList.length > 0, close: function close() {
					return _this2.props.setError(null, null, true);
				}, cancelButtonName: 'OK' }));
		}
	}]);

	return ErrorModal;
}(react_default.a.Component);

var errorModal_ItemErrorObj = function ItemErrorObj(props) {
	var data = props.data;


	return react_default.a.createElement(
		dist_es["o" /* List */].Item,
		{ className: 'itemError' },
		react_default.a.createElement(
			dist_es["o" /* List */].Content,
			null,
			data.code && react_default.a.createElement(
				'p',
				null,
				data.code
			),
			react_default.a.createElement(
				'p',
				{ className: 'detailError header' },
				data.statusText
			)
		)
	);
};

/* harmony default export */ var errorModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
	return {
		errorList: Object(selectorCallAPI["a" /* getErrorList */])(state)
	};
}, function (dispatch, _ref) {
	var history = _ref.history;
	return {
		setError: function setError(errorList, newError, isShow) {
			dispatch(actionsCallAPI_setError(errorList, newError, isShow));
		}
	};
}), Object(Recompose["b" /* lifecycle */])({}))(errorModal_ErrorModal));
// EXTERNAL MODULE: ./src/app/components/features/share/loading.js
var share_loading = __webpack_require__(406);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/loadingModal.js
var loadingModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function loadingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loadingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function loadingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var loadingModal_LoadingModal = function (_React$Component) {
	loadingModal__inherits(LoadingModal, _React$Component);

	function LoadingModal(props) {
		loadingModal__classCallCheck(this, LoadingModal);

		var _this = loadingModal__possibleConstructorReturn(this, (LoadingModal.__proto__ || Object.getPrototypeOf(LoadingModal)).call(this, props));

		_this.state = {
			isLoading: false
		};
		return _this;
	}

	loadingModal__createClass(LoadingModal, [{
		key: 'render',
		value: function render() {
			var loading = this.props.loading;


			return react_default.a.createElement(share_loading["a" /* default */], { isActive: loading });
		}
	}]);

	return LoadingModal;
}(react_default.a.Component);

/* harmony default export */ var loadingModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
	return {
		loading: Object(selectorCallAPI["b" /* getLoading */])(state)
	};
}, function (dispatch, _ref) {
	var history = _ref.history;
	return {
		setLoading: function setLoading(isLoading) {
			dispatch(actionsCallAPI_setLoading(isLoading));
		}
	};
}), Object(Recompose["b" /* lifecycle */])({}))(loadingModal_LoadingModal));
// EXTERNAL MODULE: ./src/app/components/scss/index.scss
var scss = __webpack_require__(903);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/app/routes/Root.js







// import ErrorBoundary from '../components/features/share/ErrorBoundary'

// import Loading from '../components/features/share/loading'


var store = configureStore_default()();

/* harmony default export */ var Root = (function () {
    return react_default.a.createElement(
        es["a" /* Provider */],
        { store: store },
        react_default.a.createElement(
            react_router_dom["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(App, null),
                react_default.a.createElement(errorModal, null),
                react_default.a.createElement(loadingModal, null)
            )
        )
    );
});
// EXTERNAL MODULE: ./src/wording/language/en/common.json
var common = __webpack_require__(911);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/wording/language/en/login.json
var login = __webpack_require__(912);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/wording/language/en/report.json
var report = __webpack_require__(913);
var report_default = /*#__PURE__*/__webpack_require__.n(report);

// EXTERNAL MODULE: ./src/wording/language/en/fin.json
var fin = __webpack_require__(914);
var fin_default = /*#__PURE__*/__webpack_require__.n(fin);

// EXTERNAL MODULE: ./src/wording/language/en/fg.json
var fg = __webpack_require__(915);
var fg_default = /*#__PURE__*/__webpack_require__.n(fg);

// EXTERNAL MODULE: ./src/wording/language/en/tube.json
var tube = __webpack_require__(916);
var tube_default = /*#__PURE__*/__webpack_require__.n(tube);

// EXTERNAL MODULE: ./src/wording/language/en/search.json
var search = __webpack_require__(917);
var search_default = /*#__PURE__*/__webpack_require__.n(search);

// EXTERNAL MODULE: ./src/wording/language/en/header.json
var en_header = __webpack_require__(918);
var header_default = /*#__PURE__*/__webpack_require__.n(en_header);

// EXTERNAL MODULE: ./src/wording/language/en/plate.json
var plate = __webpack_require__(919);
var plate_default = /*#__PURE__*/__webpack_require__.n(plate);

// EXTERNAL MODULE: ./src/wording/language/en/button.json
var en_button = __webpack_require__(920);
var button_default = /*#__PURE__*/__webpack_require__.n(en_button);

// EXTERNAL MODULE: ./src/wording/language/en/home.json
var home = __webpack_require__(921);
var home_default = /*#__PURE__*/__webpack_require__.n(home);

// EXTERNAL MODULE: ./src/wording/language/en/menu.json
var menu = __webpack_require__(922);
var menu_default = /*#__PURE__*/__webpack_require__.n(menu);

// EXTERNAL MODULE: ./src/wording/language/en/sell.json
var sell = __webpack_require__(923);
var sell_default = /*#__PURE__*/__webpack_require__.n(sell);

// EXTERNAL MODULE: ./src/wording/language/en/systeminfo.json
var systeminfo = __webpack_require__(924);
var systeminfo_default = /*#__PURE__*/__webpack_require__.n(systeminfo);

// EXTERNAL MODULE: ./src/wording/language/en/masterData.json
var masterData = __webpack_require__(925);
var masterData_default = /*#__PURE__*/__webpack_require__.n(masterData);

// EXTERNAL MODULE: ./src/wording/language/en/setting.json
var setting = __webpack_require__(926);
var setting_default = /*#__PURE__*/__webpack_require__.n(setting);

// EXTERNAL MODULE: ./src/wording/language/en/share.json
var share = __webpack_require__(927);
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/wording/language/en/user.json
var user = __webpack_require__(928);
var user_default = /*#__PURE__*/__webpack_require__.n(user);

// EXTERNAL MODULE: ./src/wording/language/en/reqDrawing.json
var reqDrawing = __webpack_require__(929);
var reqDrawing_default = /*#__PURE__*/__webpack_require__.n(reqDrawing);

// EXTERNAL MODULE: ./src/wording/language/en/urlTranslate.json
var urlTranslate = __webpack_require__(930);
var urlTranslate_default = /*#__PURE__*/__webpack_require__.n(urlTranslate);

// CONCATENATED MODULE: ./src/wording/language/en.js
var en__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















/* harmony default export */ var en = (en__extends({}, common_default.a, login_default.a, report_default.a, fin_default.a, fg_default.a, tube_default.a, search_default.a, header_default.a, plate_default.a, button_default.a, home_default.a, menu_default.a, sell_default.a, systeminfo_default.a, masterData_default.a, setting_default.a, share_default.a, user_default.a, reqDrawing_default.a, urlTranslate_default.a));
// EXTERNAL MODULE: ./src/wording/language/th/common.json
var th_common = __webpack_require__(931);
var th_common_default = /*#__PURE__*/__webpack_require__.n(th_common);

// EXTERNAL MODULE: ./src/wording/language/th/login.json
var th_login = __webpack_require__(932);
var th_login_default = /*#__PURE__*/__webpack_require__.n(th_login);

// EXTERNAL MODULE: ./src/wording/language/th/report.json
var th_report = __webpack_require__(933);
var th_report_default = /*#__PURE__*/__webpack_require__.n(th_report);

// EXTERNAL MODULE: ./src/wording/language/th/fin.json
var th_fin = __webpack_require__(934);
var th_fin_default = /*#__PURE__*/__webpack_require__.n(th_fin);

// EXTERNAL MODULE: ./src/wording/language/th/fg.json
var th_fg = __webpack_require__(935);
var th_fg_default = /*#__PURE__*/__webpack_require__.n(th_fg);

// EXTERNAL MODULE: ./src/wording/language/th/tube.json
var th_tube = __webpack_require__(936);
var th_tube_default = /*#__PURE__*/__webpack_require__.n(th_tube);

// EXTERNAL MODULE: ./src/wording/language/th/search.json
var th_search = __webpack_require__(400);
var th_search_default = /*#__PURE__*/__webpack_require__.n(th_search);

// EXTERNAL MODULE: ./src/wording/language/th/plate.json
var th_plate = __webpack_require__(937);
var th_plate_default = /*#__PURE__*/__webpack_require__.n(th_plate);

// EXTERNAL MODULE: ./src/wording/language/th/button.json
var th_button = __webpack_require__(938);
var th_button_default = /*#__PURE__*/__webpack_require__.n(th_button);

// EXTERNAL MODULE: ./src/wording/language/th/home.json
var th_home = __webpack_require__(939);
var th_home_default = /*#__PURE__*/__webpack_require__.n(th_home);

// EXTERNAL MODULE: ./src/wording/language/th/menu.json
var th_menu = __webpack_require__(940);
var th_menu_default = /*#__PURE__*/__webpack_require__.n(th_menu);

// EXTERNAL MODULE: ./src/wording/language/th/sell.json
var th_sell = __webpack_require__(941);
var th_sell_default = /*#__PURE__*/__webpack_require__.n(th_sell);

// EXTERNAL MODULE: ./src/wording/language/th/systeminfo.json
var th_systeminfo = __webpack_require__(942);
var th_systeminfo_default = /*#__PURE__*/__webpack_require__.n(th_systeminfo);

// EXTERNAL MODULE: ./src/wording/language/th/masterData.json
var th_masterData = __webpack_require__(943);
var th_masterData_default = /*#__PURE__*/__webpack_require__.n(th_masterData);

// EXTERNAL MODULE: ./src/wording/language/th/setting.json
var th_setting = __webpack_require__(944);
var th_setting_default = /*#__PURE__*/__webpack_require__.n(th_setting);

// EXTERNAL MODULE: ./src/wording/language/th/share.json
var th_share = __webpack_require__(945);
var th_share_default = /*#__PURE__*/__webpack_require__.n(th_share);

// EXTERNAL MODULE: ./src/wording/language/th/user.json
var th_user = __webpack_require__(946);
var th_user_default = /*#__PURE__*/__webpack_require__.n(th_user);

// EXTERNAL MODULE: ./src/wording/language/th/reqDrawing.json
var th_reqDrawing = __webpack_require__(947);
var th_reqDrawing_default = /*#__PURE__*/__webpack_require__.n(th_reqDrawing);

// EXTERNAL MODULE: ./src/wording/language/th/urlTranslate.json
var th_urlTranslate = __webpack_require__(948);
var th_urlTranslate_default = /*#__PURE__*/__webpack_require__.n(th_urlTranslate);

// CONCATENATED MODULE: ./src/wording/language/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















/* harmony default export */ var th = (th__extends({}, th_common_default.a, th_login_default.a, th_report_default.a, th_fin_default.a, th_fg_default.a, th_tube_default.a, th_search_default.a, th_search_default.a, th_plate_default.a, th_button_default.a, th_home_default.a, th_menu_default.a, th_sell_default.a, th_systeminfo_default.a, th_masterData_default.a, th_setting_default.a, th_share_default.a, th_user_default.a, th_reqDrawing_default.a, th_urlTranslate_default.a));
// CONCATENATED MODULE: ./src/index.js











Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('en');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root);

if (false) {
    module.hot.accept('./app/routes/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(635);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(118);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(636);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(402);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 229 modules
var redux_form_es = __webpack_require__(639);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerAuth.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var reducerAuth_initialState = {
    user: null
};

/* harmony default export */ var reducerAuth = ({
    authen: function authen() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialState;
        var action = arguments[1];

        switch (action.type) {
            default:
                return _extends({}, state);
        }
    }
});
// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(19);

// EXTERNAL MODULE: ./src/app/redux/masterDataTypes.js
var masterDataTypes = __webpack_require__(31);

// EXTERNAL MODULE: ./src/app/redux/manageTypes.js
var manageTypes = __webpack_require__(196);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCallAPI.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







var initialStateCallAPI = {
	isLoading: false,

	hasError: false,
	errorMessage: '',
	errorCode: '',
	statusText: ''
},
    initialStateArray = [];

/* harmony default export */ var reducerCallAPI = ({
	errorList: function errorList() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateArray;
		var action = arguments[1];

		switch (action.type) {
			case types["_242" /* SET_ERROR */]:
				var newError = [];
				if (action && Array.isArray(action.error)) {
					newError = action.error;
				}
				return newError;

			case types["w" /* CORE_AUTH_VERIFY_SUCCESS */]:
			case types["_114" /* CORE_LOAD_DRAWING_INFORMATION_SUCCESS */]:
			case masterDataTypes["_85" /* CORE_LOAD_MASTER_DATA_SUCCESS */]:
			case types["_117" /* CORE_LOAD_ITEM_INFORMATION_SUCCESS */]:
			case types["_165" /* CORE_SAVE_ITEM_SUCCESS */]:
			case types["_208" /* CORE_SUBMIT_ITEM_SUCCESS */]:
			case types["_63" /* CORE_GEN_CODE_ITEM_SUCCESS */]:
			case types["d" /* CORE_APPROVE_ITEM_SUCCESS */]:
			case types["_231" /* CORE_UPDATE_DRAWING_INFO_SUCCESS */]:
			case types["_16" /* CORE_CREATE_DRAWING_INFO_SUCCESS */]:
			case types["_102" /* CORE_GET_TUBE_INSIDE_DATA_SUCCESS */]:
			case types["_78" /* CORE_GET_PIPE_TYPE_DATA_SUCCESS */]:
			case types["_111" /* CORE_LOAD_CUSTOMER_SUCCESS */]:
			case types["_219" /* CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS */]:
			case types["_27" /* CORE_CREATE_SELL_ORDER_INFO_SUCCESS */]:
			case types["_129" /* CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS */]:
			case types["_240" /* CORE_UPDATE_SELL_ORDER_INFO_SUCCESS */]:
			case types["_177" /* CORE_SEARCH_SELL_ORDER_SUCCESS */]:
			case masterDataTypes["c" /* CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS */]:
			case masterDataTypes["l" /* CORE_LOAD_MASTER_DATA_COATING_SUCCESS */]:
			case masterDataTypes["f" /* CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS */]:
			case masterDataTypes["o" /* CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS */]:
			case masterDataTypes["i" /* CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS */]:
			case masterDataTypes["H" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS */]:
			case masterDataTypes["Q" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS */]:
			case masterDataTypes["K" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS */]:
			case masterDataTypes["T" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS */]:
			case masterDataTypes["N" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS */]:
			case masterDataTypes["W" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS */]:
			case masterDataTypes["_5" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS */]:
			case masterDataTypes["Z" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS */]:
			case masterDataTypes["_8" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS */]:
			case masterDataTypes["_2" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS */]:
			case masterDataTypes["_11" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS */]:
			case masterDataTypes["_20" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS */]:
			case masterDataTypes["_14" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS */]:
			case masterDataTypes["_23" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS */]:
			case masterDataTypes["_17" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS */]:
			case masterDataTypes["_118" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS */]:
			case masterDataTypes["_142" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS */]:
			case masterDataTypes["_136" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS */]:
			case masterDataTypes["_145" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS */]:
			case masterDataTypes["_139" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS */]:
			case masterDataTypes["_26" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS */]:
			case masterDataTypes["_35" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS */]:
			case masterDataTypes["_29" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS */]:
			case masterDataTypes["_38" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS */]:
			case masterDataTypes["_32" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS */]:
			case masterDataTypes["_88" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS */]:
			case masterDataTypes["_97" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS */]:
			case masterDataTypes["_91" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS */]:
			case masterDataTypes["_100" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS */]:
			case masterDataTypes["_94" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS */]:
			case masterDataTypes["_56" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS */]:
			case masterDataTypes["_65" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS */]:
			case masterDataTypes["_59" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS */]:
			case masterDataTypes["_68" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS */]:
			case masterDataTypes["_62" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS */]:
			case masterDataTypes["_103" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS */]:
			case masterDataTypes["_112" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS */]:
			case masterDataTypes["_106" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS */]:
			case masterDataTypes["_115" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS */]:
			case masterDataTypes["_109" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS */]:
			case masterDataTypes["_121" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS */]:
			case masterDataTypes["_130" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS */]:
			case masterDataTypes["_124" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS */]:
			case masterDataTypes["_133" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS */]:
			case masterDataTypes["_127" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS */]:
			case masterDataTypes["_71" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS */]:
			case masterDataTypes["_80" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS */]:
			case masterDataTypes["_74" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS */]:
			case masterDataTypes["_83" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS */]:
			case masterDataTypes["_77" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS */]:
			case types["_132" /* CORE_LOAD_SETTING_SUCCESS */]:
			case types["I" /* CORE_CHANGE_SETTING_SUCCESS */]:
			case masterDataTypes["r" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS */]:
			case masterDataTypes["A" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS */]:
			case masterDataTypes["u" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS */]:
			case masterDataTypes["D" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS */]:
			case masterDataTypes["x" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS */]:
			case types["_150" /* CORE_REJECT_SELL_ORDER_SUCCESS */]:
			case types["_48" /* CORE_DELETE_SELL_ORDER_SUCCESS */]:
			case types["_141" /* CORE_PRE_APPROVE_SUCCESS */]:
			case types["_36" /* CORE_CUSTOMER_APPROVE_SUCCESS */]:
			case types["l" /* CORE_APPROVE_SUCCESS */]:
			case types["_216" /* CORE_SUBMIT_SUCCESS */]:
			case types["_195" /* CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS */]:
			case types["_6" /* CORE_COMPLETE_SELL_ORDER_SUCCESS */]:
			case types["X" /* CORE_COMMENT_SELL_ORDER_SUCCESS */]:
			case manageTypes["r" /* CORE_LOAD_MANAGE_SYSTEMS_SUCCESS */]:
			case manageTypes["A" /* CORE_LOAD_MANAGE_SYSTEM_SUCCESS */]:
			case manageTypes["u" /* CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS */]:
			case manageTypes["D" /* CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS */]:
			case manageTypes["x" /* CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS */]:
			case manageTypes["c" /* CORE_LOAD_MANAGE_GROUPS_SUCCESS */]:
			case manageTypes["l" /* CORE_LOAD_MANAGE_GROUP_SUCCESS */]:
			case manageTypes["f" /* CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS */]:
			case manageTypes["o" /* CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS */]:
			case manageTypes["i" /* CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS */]:
			case types["O" /* CORE_CHANGE_USER_NPI_PERMIT_SUCCESS */]:
			case types["L" /* CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS */]:
			case types["_9" /* CORE_CREATE_CUSTOMER_SUCCESS */]:
			case types["_60" /* CORE_GENCODE_NPI_SELL_ORDER_SUCCESS */]:
			case types["_204" /* CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS */]:
			case types["F" /* CORE_CANCEL_SELL_ORDER_SUCCESS */]:
			case types["_186" /* CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS */]:
			case types["_96" /* CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS */]:
			case types["_24" /* CORE_CREATE_REQ_TUBE_INFO_SUCCESS */]:
			case types["_237" /* CORE_UPDATE_REQ_TUBE_INFO_SUCCESS */]:
			case types["_21" /* CORE_CREATE_REQ_ACC_INFO_SUCCESS */]:
			case types["_234" /* CORE_UPDATE_REQ_ACC_INFO_SUCCESS */]:
			case types["_162" /* CORE_RE_STATUS_SELL_ORDER_SUCCESS */]:
			case types["_66" /* CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS */]:
			case types["u" /* CORE_ATTACH_FILE_SELL_ORDER_SUCCESS */]:
			case types["r" /* CORE_ATTACH_FILE_REQ_TUBE_SUCCESS */]:
			case types["o" /* CORE_ATTACH_FILE_REQ_ACC_SUCCESS */]:
			case types["_153" /* CORE_RE_SEND_ITEM_SUCCESS */]:
			case types["_120" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS */]:
				if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
					var _action$payload = action.payload,
					    errors = _action$payload.errors,
					    result = _action$payload.result;
					var url = action.url;

					var _newError = [];
					if (!result) {
						if (Array.isArray(errors)) {
							errors.map(function (e) {
								var path = e.path,
								    code = e.code,
								    message = e.message;

								return _newError.push({ code: code, message: message, isShow: true, path: path, url: url, isFromAction: true });
							});
						} else _newError.push({ code: "unknow", message: "Some thing went wrong", isShow: true, path: "", url: url, isFromAction: true });
					}

					return _newError;
				}
				return state;

			case types["v" /* CORE_AUTH_VERIFY_FAILURE */]:
			case types["_112" /* CORE_LOAD_DRAWING_INFORMATION_FAILURE */]:
			case masterDataTypes["E" /* CORE_LOAD_MASTER_DATA_FAILURE */]:
			case types["_115" /* CORE_LOAD_ITEM_INFORMATION_FAILURE */]:
			case types["_163" /* CORE_SAVE_ITEM_FAILURE */]:
			case types["_206" /* CORE_SUBMIT_ITEM_FAILURE */]:
			case types["_61" /* CORE_GEN_CODE_ITEM_FAILURE */]:
			case types["b" /* CORE_APPROVE_ITEM_FAILURE */]:
			case types["_229" /* CORE_UPDATE_DRAWING_INFO_FAILURE */]:
			case types["_14" /* CORE_CREATE_DRAWING_INFO_FAILURE */]:
			case types["_100" /* CORE_GET_TUBE_INSIDE_DATA_FAILURE */]:
			case types["_76" /* CORE_GET_PIPE_TYPE_DATA_FAILURE */]:
			case types["_109" /* CORE_LOAD_CUSTOMER_FAILURE */]:
			case types["_217" /* CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE */]:
			case types["_25" /* CORE_CREATE_SELL_ORDER_INFO_FAILURE */]:
			case types["_127" /* CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE */]:
			case types["_238" /* CORE_UPDATE_SELL_ORDER_INFO_FAILURE */]:
			case types["_175" /* CORE_SEARCH_SELL_ORDER_FAILURE */]:
			case masterDataTypes["a" /* CORE_LOAD_MASTER_DATA_COATINGS_FAILURE */]:
			case masterDataTypes["j" /* CORE_LOAD_MASTER_DATA_COATING_FAILURE */]:
			case masterDataTypes["d" /* CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE */]:
			case masterDataTypes["m" /* CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE */]:
			case masterDataTypes["g" /* CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE */]:
			case masterDataTypes["F" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE */]:
			case masterDataTypes["O" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE */]:
			case masterDataTypes["I" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE */]:
			case masterDataTypes["R" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE */]:
			case masterDataTypes["L" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE */]:
			case masterDataTypes["U" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE */]:
			case masterDataTypes["_3" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE */]:
			case masterDataTypes["X" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE */]:
			case masterDataTypes["_6" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE */]:
			case masterDataTypes["_0" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE */]:
			case masterDataTypes["_9" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE */]:
			case masterDataTypes["_18" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE */]:
			case masterDataTypes["_12" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE */]:
			case masterDataTypes["_21" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE */]:
			case masterDataTypes["_15" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE */]:
			case masterDataTypes["_116" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE */]:
			case masterDataTypes["_140" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE */]:
			case masterDataTypes["_134" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE */]:
			case masterDataTypes["_143" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE */]:
			case masterDataTypes["_137" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE */]:
			case masterDataTypes["_24" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE */]:
			case masterDataTypes["_33" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE */]:
			case masterDataTypes["_27" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE */]:
			case masterDataTypes["_36" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE */]:
			case masterDataTypes["_30" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE */]:
			case masterDataTypes["_86" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE */]:
			case masterDataTypes["_95" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE */]:
			case masterDataTypes["_89" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE */]:
			case masterDataTypes["_98" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE */]:
			case masterDataTypes["_92" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE */]:
			case masterDataTypes["_54" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE */]:
			case masterDataTypes["_63" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE */]:
			case masterDataTypes["_57" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE */]:
			case masterDataTypes["_66" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE */]:
			case masterDataTypes["_60" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE */]:
			case masterDataTypes["_101" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE */]:
			case masterDataTypes["_110" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE */]:
			case masterDataTypes["_104" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE */]:
			case masterDataTypes["_113" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE */]:
			case masterDataTypes["_107" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE */]:
			case masterDataTypes["_119" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE */]:
			case masterDataTypes["_128" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE */]:
			case masterDataTypes["_122" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE */]:
			case masterDataTypes["_131" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE */]:
			case masterDataTypes["_125" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE */]:
			case masterDataTypes["_69" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE */]:
			case masterDataTypes["_78" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE */]:
			case masterDataTypes["_72" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE */]:
			case masterDataTypes["_81" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE */]:
			case masterDataTypes["_75" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE */]:
			case types["_130" /* CORE_LOAD_SETTING_FAILURE */]:
			case types["G" /* CORE_CHANGE_SETTING_FAILURE */]:
			case masterDataTypes["p" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE */]:
			case masterDataTypes["y" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE */]:
			case masterDataTypes["s" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE */]:
			case masterDataTypes["B" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE */]:
			case masterDataTypes["v" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE */]:
			case types["_148" /* CORE_REJECT_SELL_ORDER_FAILURE */]:
			case types["_46" /* CORE_DELETE_SELL_ORDER_FAILURE */]:
			case types["_133" /* CORE_PRE_APPROVE_FAILURE */]:
			case types["_28" /* CORE_CUSTOMER_APPROVE_FAILURE */]:
			case types["a" /* CORE_APPROVE_FAILURE */]:
			case types["_205" /* CORE_SUBMIT_FAILURE */]:
			case types["_193" /* CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE */]:
			case types["_4" /* CORE_COMPLETE_SELL_ORDER_FAILURE */]:
			case types["V" /* CORE_COMMENT_SELL_ORDER_FAILURE */]:
			case types["s" /* CORE_ATTACH_FILE_SELL_ORDER_FAILURE */]:
			case manageTypes["p" /* CORE_LOAD_MANAGE_SYSTEMS_FAILURE */]:
			case manageTypes["y" /* CORE_LOAD_MANAGE_SYSTEM_FAILURE */]:
			case manageTypes["s" /* CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE */]:
			case manageTypes["B" /* CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE */]:
			case manageTypes["v" /* CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE */]:
			case manageTypes["a" /* CORE_LOAD_MANAGE_GROUPS_FAILURE */]:
			case manageTypes["j" /* CORE_LOAD_MANAGE_GROUP_FAILURE */]:
			case manageTypes["d" /* CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE */]:
			case manageTypes["m" /* CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE */]:
			case manageTypes["g" /* CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE */]:
			case types["M" /* CORE_CHANGE_USER_NPI_PERMIT_FAILURE */]:
			case types["J" /* CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE */]:
			case types["_7" /* CORE_CREATE_CUSTOMER_FAILURE */]:
			case types["_58" /* CORE_GENCODE_NPI_SELL_ORDER_FAILURE */]:
			case types["_202" /* CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE */]:
			case types["_184" /* CORE_SHOP_APPROVE_SELL_ORDER_FAILURE */]:
			case types["D" /* CORE_CANCEL_SELL_ORDER_FAILURE */]:
			case types["_94" /* CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE */]:
			case types["_22" /* CORE_CREATE_REQ_TUBE_INFO_FAILURE */]:
			case types["_235" /* CORE_UPDATE_REQ_TUBE_INFO_FAILURE */]:
			case types["_19" /* CORE_CREATE_REQ_ACC_INFO_FAILURE */]:
			case types["_232" /* CORE_UPDATE_REQ_ACC_INFO_FAILURE */]:
			case types["_160" /* CORE_RE_STATUS_SELL_ORDER_FAILURE */]:
			case types["_64" /* CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE */]:
			case types["_151" /* CORE_RE_SEND_ITEM_FAILURE */]:
			case types["_118" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE */]:
				if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
					var _action$payload2 = action.payload,
					    code = _action$payload2.code,
					    message = _action$payload2.message,
					    statusText = _action$payload2.statusText,
					    statusCode = _action$payload2.statusCode;
					var _url = action.url;

					var _newError2 = [];

					_newError2.push({
						code: code ? code : "404",
						message: message,
						isShow: false,
						statusText: statusText,
						statusCode: statusCode,
						url: _url
					});

					return _newError2;
				}
				return state;
			default:
				return state;
		}
	},
	isLoading: function isLoading() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		var action = arguments[1];

		switch (action.type) {
			case types["_17" /* CORE_CREATE_DRAWING_REQUEST */]:
			// case CORE_SEARCH_DRAWING_REQUEST:
			case types["_164" /* CORE_SAVE_ITEM_REQUEST */]:
			case types["_207" /* CORE_SUBMIT_ITEM_REQUEST */]:
			case types["_62" /* CORE_GEN_CODE_ITEM_REQUEST */]:
			case types["_152" /* CORE_RE_SEND_ITEM_REQUEST */]:
			case types["c" /* CORE_APPROVE_ITEM_REQUEST */]:
			case types["_230" /* CORE_UPDATE_DRAWING_INFO_REQUEST */]:
			case types["_15" /* CORE_CREATE_DRAWING_INFO_REQUEST */]:
			case types["_101" /* CORE_GET_TUBE_INSIDE_DATA_REQUEST */]:
			case types["_77" /* CORE_GET_PIPE_TYPE_DATA_REQUEST */]:
			case types["_218" /* CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST */]:
			case types["_26" /* CORE_CREATE_SELL_ORDER_INFO_REQUEST */]:
			case types["_128" /* CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST */]:
			case types["_239" /* CORE_UPDATE_SELL_ORDER_INFO_REQUEST */]:
			case masterDataTypes["b" /* CORE_LOAD_MASTER_DATA_COATINGS_REQUEST */]:
			case masterDataTypes["k" /* CORE_LOAD_MASTER_DATA_COATING_REQUEST */]:
			case masterDataTypes["e" /* CORE_LOAD_MASTER_DATA_COATING_CREATE_REQUEST */]:
			case masterDataTypes["n" /* CORE_LOAD_MASTER_DATA_COATING_UPDATE_REQUEST */]:
			case masterDataTypes["h" /* CORE_LOAD_MASTER_DATA_COATING_DELETE_REQUEST */]:
			case masterDataTypes["G" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST */]:
			case masterDataTypes["P" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST */]:
			case masterDataTypes["J" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_REQUEST */]:
			case masterDataTypes["S" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_REQUEST */]:
			case masterDataTypes["M" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_REQUEST */]:
			case masterDataTypes["V" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST */]:
			case masterDataTypes["_4" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST */]:
			case masterDataTypes["Y" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_REQUEST */]:
			case masterDataTypes["_7" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_REQUEST */]:
			case masterDataTypes["_1" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_REQUEST */]:
			case masterDataTypes["_10" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST */]:
			case masterDataTypes["_19" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST */]:
			case masterDataTypes["_13" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_REQUEST */]:
			case masterDataTypes["_22" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_REQUEST */]:
			case masterDataTypes["_16" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_REQUEST */]:
			case masterDataTypes["_117" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST */]:
			case masterDataTypes["_141" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST */]:
			case masterDataTypes["_135" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_REQUEST */]:
			case masterDataTypes["_144" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_REQUEST */]:
			case masterDataTypes["_138" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_REQUEST */]:
			case masterDataTypes["_25" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST */]:
			case masterDataTypes["_34" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST */]:
			case masterDataTypes["_28" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_REQUEST */]:
			case masterDataTypes["_37" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_REQUEST */]:
			case masterDataTypes["_31" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_REQUEST */]:
			case masterDataTypes["_87" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST */]:
			case masterDataTypes["_96" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST */]:
			case masterDataTypes["_90" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_REQUEST */]:
			case masterDataTypes["_99" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_REQUEST */]:
			case masterDataTypes["_93" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_REQUEST */]:
			case masterDataTypes["_55" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST */]:
			case masterDataTypes["_64" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST */]:
			case masterDataTypes["_58" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_REQUEST */]:
			case masterDataTypes["_67" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_REQUEST */]:
			case masterDataTypes["_61" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_REQUEST */]:
			case masterDataTypes["_102" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST */]:
			case masterDataTypes["_111" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST */]:
			case masterDataTypes["_105" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_REQUEST */]:
			case masterDataTypes["_114" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_REQUEST */]:
			case masterDataTypes["_108" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_REQUEST */]:
			case masterDataTypes["_120" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST */]:
			case masterDataTypes["_129" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST */]:
			case masterDataTypes["_123" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_REQUEST */]:
			case masterDataTypes["_132" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_REQUEST */]:
			case masterDataTypes["_126" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_REQUEST */]:
			case masterDataTypes["_70" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST */]:
			case masterDataTypes["_79" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST */]:
			case masterDataTypes["_73" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_REQUEST */]:
			case masterDataTypes["_82" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_REQUEST */]:
			case masterDataTypes["_76" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_REQUEST */]:
			case types["_131" /* CORE_LOAD_SETTING_REQUEST */]:
			case types["H" /* CORE_CHANGE_SETTING_REQUEST */]:
			case masterDataTypes["q" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST */]:
			case masterDataTypes["z" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST */]:
			case masterDataTypes["t" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_REQUEST */]:
			case masterDataTypes["C" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_REQUEST */]:
			case masterDataTypes["w" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_REQUEST */]:
			case types["_149" /* CORE_REJECT_SELL_ORDER_REQUEST */]:
			case types["_47" /* CORE_DELETE_SELL_ORDER_REQUEST */]:
			case types["_134" /* CORE_PRE_APPROVE_REQUEST */]:
			case types["_29" /* CORE_CUSTOMER_APPROVE_REQUEST */]:
			case types["e" /* CORE_APPROVE_REQUEST */]:
			case types["_209" /* CORE_SUBMIT_REQUEST */]:
			case types["_194" /* CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST */]:
			case types["_5" /* CORE_COMPLETE_SELL_ORDER_REQUEST */]:
			case types["W" /* CORE_COMMENT_SELL_ORDER_REQUEST */]:
			case types["t" /* CORE_ATTACH_FILE_SELL_ORDER_REQUEST */]:
			case manageTypes["q" /* CORE_LOAD_MANAGE_SYSTEMS_REQUEST */]:
			case manageTypes["z" /* CORE_LOAD_MANAGE_SYSTEM_REQUEST */]:
			case manageTypes["t" /* CORE_LOAD_MANAGE_SYSTEM_CREATE_REQUEST */]:
			case manageTypes["C" /* CORE_LOAD_MANAGE_SYSTEM_UPDATE_REQUEST */]:
			case manageTypes["w" /* CORE_LOAD_MANAGE_SYSTEM_DELETE_REQUEST */]:
			case manageTypes["b" /* CORE_LOAD_MANAGE_GROUPS_REQUEST */]:
			case manageTypes["k" /* CORE_LOAD_MANAGE_GROUP_REQUEST */]:
			case manageTypes["e" /* CORE_LOAD_MANAGE_GROUP_CREATE_REQUEST */]:
			case manageTypes["n" /* CORE_LOAD_MANAGE_GROUP_UPDATE_REQUEST */]:
			case manageTypes["h" /* CORE_LOAD_MANAGE_GROUP_DELETE_REQUEST */]:
			case types["N" /* CORE_CHANGE_USER_NPI_PERMIT_REQUEST */]:
			case types["K" /* CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST */]:
			case types["_8" /* CORE_CREATE_CUSTOMER_REQUEST */]:
			case types["_59" /* CORE_GENCODE_NPI_SELL_ORDER_REQUEST */]:
			case types["_203" /* CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST */]:
			case types["_185" /* CORE_SHOP_APPROVE_SELL_ORDER_REQUEST */]:
			case types["E" /* CORE_CANCEL_SELL_ORDER_REQUEST */]:
			case types["_110" /* CORE_LOAD_CUSTOMER_REQUEST */]:
			case types["_176" /* CORE_SEARCH_SELL_ORDER_REQUEST */]:
			case types["_95" /* CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST */]:
			case types["q" /* CORE_ATTACH_FILE_REQ_TUBE_REQUEST */]:
			case types["_23" /* CORE_CREATE_REQ_TUBE_INFO_REQUEST */]:
			case types["_236" /* CORE_UPDATE_REQ_TUBE_INFO_REQUEST */]:
			case types["_170" /* CORE_SEARCH_REQ_ACC_REQUEST */]:
			case types["_173" /* CORE_SEARCH_REQ_TUBE_REQUEST */]:
			case types["g" /* CORE_APPROVE_REQ_ACC_REQUEST */]:
			case types["_136" /* CORE_PRE_APPROVE_REQ_ACC_REQUEST */]:
			case types["_31" /* CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST */]:
			case types["_143" /* CORE_REJECT_REQ_ACC_REQUEST */]:
			case types["_41" /* CORE_DELETE_REQ_ACC_REQUEST */]:
			case types["_211" /* CORE_SUBMIT_REQ_ACC_REQUEST */]:
			case types["_188" /* CORE_SHOP_SUBMIT_REQ_ACC_REQUEST */]:
			case types["Z" /* CORE_COMPLETE_REQ_ACC_REQUEST */]:
			case types["Q" /* CORE_COMMENT_REQ_ACC_REQUEST */]:
			case types["n" /* CORE_ATTACH_FILE_REQ_ACC_REQUEST */]:
			case types["_53" /* CORE_GENCODE_NPI_REQ_ACC_REQUEST */]:
			case types["_197" /* CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST */]:
			case types["_179" /* CORE_SHOP_APPROVE_REQ_ACC_REQUEST */]:
			case types["y" /* CORE_CANCEL_REQ_ACC_REQUEST */]:
			case types["_155" /* CORE_RE_STATUS_REQ_ACC_REQUEST */]:
			case types["_70" /* CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST */]:
			case types["j" /* CORE_APPROVE_REQ_TUBE_REQUEST */]:
			case types["_139" /* CORE_PRE_APPROVE_REQ_TUBE_REQUEST */]:
			case types["_34" /* CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST */]:
			case types["_146" /* CORE_REJECT_REQ_TUBE_REQUEST */]:
			case types["_44" /* CORE_DELETE_REQ_TUBE_REQUEST */]:
			case types["_214" /* CORE_SUBMIT_REQ_TUBE_REQUEST */]:
			case types["_191" /* CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST */]:
			case types["_2" /* CORE_COMPLETE_REQ_TUBE_REQUEST */]:
			case types["T" /* CORE_COMMENT_REQ_TUBE_REQUEST */]:
			case types["_56" /* CORE_GENCODE_NPI_REQ_TUBE_REQUEST */]:
			case types["_200" /* CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST */]:
			case types["_182" /* CORE_SHOP_APPROVE_REQ_TUBE_REQUEST */]:
			case types["B" /* CORE_CANCEL_REQ_TUBE_REQUEST */]:
			case types["_158" /* CORE_RE_STATUS_REQ_TUBE_REQUEST */]:
			case types["_73" /* CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST */]:
			case types["_80" /* CORE_GET_REPORT_DRAWING_STATUS_REQUEST */]:
			case types["_89" /* CORE_GET_REPORT_VIEW_DRAWING_REQUEST */]:
			case types["_161" /* CORE_RE_STATUS_SELL_ORDER_REQUEST */]:
			case types["_83" /* CORE_GET_REPORT_FOLLOW_STATUS_REQUEST */]:
			case types["_86" /* CORE_GET_REPORT_SUMMARY_STATUS_REQUEST */]:
			case types["_119" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST */]:
				return true;
			case types["_18" /* CORE_CREATE_DRAWING_SUCCESS */]:
			// case CORE_SEARCH_DRAWING_SUCCESS:
			case types["_165" /* CORE_SAVE_ITEM_SUCCESS */]:
			case types["_208" /* CORE_SUBMIT_ITEM_SUCCESS */]:
			case types["_63" /* CORE_GEN_CODE_ITEM_SUCCESS */]:
			case types["_153" /* CORE_RE_SEND_ITEM_SUCCESS */]:
			case types["d" /* CORE_APPROVE_ITEM_SUCCESS */]:
			case types["_231" /* CORE_UPDATE_DRAWING_INFO_SUCCESS */]:
			case types["_16" /* CORE_CREATE_DRAWING_INFO_SUCCESS */]:
			case types["_102" /* CORE_GET_TUBE_INSIDE_DATA_SUCCESS */]:
			case types["_78" /* CORE_GET_PIPE_TYPE_DATA_SUCCESS */]:
			case types["_219" /* CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS */]:
			case types["_27" /* CORE_CREATE_SELL_ORDER_INFO_SUCCESS */]:
			case types["_129" /* CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS */]:
			case types["_240" /* CORE_UPDATE_SELL_ORDER_INFO_SUCCESS */]:
			case masterDataTypes["c" /* CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS */]:
			case masterDataTypes["l" /* CORE_LOAD_MASTER_DATA_COATING_SUCCESS */]:
			case masterDataTypes["f" /* CORE_LOAD_MASTER_DATA_COATING_CREATE_SUCCESS */]:
			case masterDataTypes["o" /* CORE_LOAD_MASTER_DATA_COATING_UPDATE_SUCCESS */]:
			case masterDataTypes["i" /* CORE_LOAD_MASTER_DATA_COATING_DELETE_SUCCESS */]:
			case masterDataTypes["H" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS */]:
			case masterDataTypes["Q" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS */]:
			case masterDataTypes["K" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_SUCCESS */]:
			case masterDataTypes["T" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_SUCCESS */]:
			case masterDataTypes["N" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_SUCCESS */]:
			case masterDataTypes["W" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS */]:
			case masterDataTypes["_5" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS */]:
			case masterDataTypes["Z" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_SUCCESS */]:
			case masterDataTypes["_8" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_SUCCESS */]:
			case masterDataTypes["_2" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_SUCCESS */]:
			case masterDataTypes["_11" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS */]:
			case masterDataTypes["_20" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS */]:
			case masterDataTypes["_14" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_SUCCESS */]:
			case masterDataTypes["_23" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_SUCCESS */]:
			case masterDataTypes["_17" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_SUCCESS */]:
			case masterDataTypes["_118" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS */]:
			case masterDataTypes["_142" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS */]:
			case masterDataTypes["_136" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_SUCCESS */]:
			case masterDataTypes["_145" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_SUCCESS */]:
			case masterDataTypes["_139" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_SUCCESS */]:
			case masterDataTypes["_26" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS */]:
			case masterDataTypes["_35" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS */]:
			case masterDataTypes["_29" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_SUCCESS */]:
			case masterDataTypes["_38" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_SUCCESS */]:
			case masterDataTypes["_32" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_SUCCESS */]:
			case masterDataTypes["_88" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS */]:
			case masterDataTypes["_97" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS */]:
			case masterDataTypes["_91" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_SUCCESS */]:
			case masterDataTypes["_100" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_SUCCESS */]:
			case masterDataTypes["_94" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_SUCCESS */]:
			case masterDataTypes["_56" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS */]:
			case masterDataTypes["_65" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS */]:
			case masterDataTypes["_59" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_SUCCESS */]:
			case masterDataTypes["_68" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_SUCCESS */]:
			case masterDataTypes["_62" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_SUCCESS */]:
			case masterDataTypes["_103" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS */]:
			case masterDataTypes["_112" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS */]:
			case masterDataTypes["_106" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_SUCCESS */]:
			case masterDataTypes["_115" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_SUCCESS */]:
			case masterDataTypes["_109" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_SUCCESS */]:
			case masterDataTypes["_121" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS */]:
			case masterDataTypes["_130" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS */]:
			case masterDataTypes["_124" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_SUCCESS */]:
			case masterDataTypes["_133" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_SUCCESS */]:
			case masterDataTypes["_127" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_SUCCESS */]:
			case masterDataTypes["_71" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS */]:
			case masterDataTypes["_80" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS */]:
			case masterDataTypes["_74" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_SUCCESS */]:
			case masterDataTypes["_83" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_SUCCESS */]:
			case masterDataTypes["_77" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_SUCCESS */]:
			case types["_132" /* CORE_LOAD_SETTING_SUCCESS */]:
			case types["I" /* CORE_CHANGE_SETTING_SUCCESS */]:
			case masterDataTypes["r" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS */]:
			case masterDataTypes["A" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS */]:
			case masterDataTypes["u" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_SUCCESS */]:
			case masterDataTypes["D" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_SUCCESS */]:
			case masterDataTypes["x" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_SUCCESS */]:
			case types["_150" /* CORE_REJECT_SELL_ORDER_SUCCESS */]:
			case types["_48" /* CORE_DELETE_SELL_ORDER_SUCCESS */]:
			case types["_141" /* CORE_PRE_APPROVE_SUCCESS */]:
			case types["_36" /* CORE_CUSTOMER_APPROVE_SUCCESS */]:
			case types["l" /* CORE_APPROVE_SUCCESS */]:
			case types["_216" /* CORE_SUBMIT_SUCCESS */]:
			case types["_195" /* CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS */]:
			case types["_6" /* CORE_COMPLETE_SELL_ORDER_SUCCESS */]:
			case types["X" /* CORE_COMMENT_SELL_ORDER_SUCCESS */]:
			case types["u" /* CORE_ATTACH_FILE_SELL_ORDER_SUCCESS */]:
			case manageTypes["r" /* CORE_LOAD_MANAGE_SYSTEMS_SUCCESS */]:
			case manageTypes["A" /* CORE_LOAD_MANAGE_SYSTEM_SUCCESS */]:
			case manageTypes["u" /* CORE_LOAD_MANAGE_SYSTEM_CREATE_SUCCESS */]:
			case manageTypes["D" /* CORE_LOAD_MANAGE_SYSTEM_UPDATE_SUCCESS */]:
			case manageTypes["x" /* CORE_LOAD_MANAGE_SYSTEM_DELETE_SUCCESS */]:
			case manageTypes["c" /* CORE_LOAD_MANAGE_GROUPS_SUCCESS */]:
			case manageTypes["l" /* CORE_LOAD_MANAGE_GROUP_SUCCESS */]:
			case manageTypes["f" /* CORE_LOAD_MANAGE_GROUP_CREATE_SUCCESS */]:
			case manageTypes["o" /* CORE_LOAD_MANAGE_GROUP_UPDATE_SUCCESS */]:
			case manageTypes["i" /* CORE_LOAD_MANAGE_GROUP_DELETE_SUCCESS */]:
			case types["O" /* CORE_CHANGE_USER_NPI_PERMIT_SUCCESS */]:
			case types["L" /* CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS */]:
			case types["_9" /* CORE_CREATE_CUSTOMER_SUCCESS */]:
			case types["_60" /* CORE_GENCODE_NPI_SELL_ORDER_SUCCESS */]:
			case types["_204" /* CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS */]:
			case types["_186" /* CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS */]:
			case types["F" /* CORE_CANCEL_SELL_ORDER_SUCCESS */]:
			case types["_111" /* CORE_LOAD_CUSTOMER_SUCCESS */]:
			case types["_177" /* CORE_SEARCH_SELL_ORDER_SUCCESS */]:
			case types["_96" /* CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS */]:
			case types["r" /* CORE_ATTACH_FILE_REQ_TUBE_SUCCESS */]:
			case types["_24" /* CORE_CREATE_REQ_TUBE_INFO_SUCCESS */]:
			case types["_237" /* CORE_UPDATE_REQ_TUBE_INFO_SUCCESS */]:
			case types["_171" /* CORE_SEARCH_REQ_ACC_SUCCESS */]:
			case types["_174" /* CORE_SEARCH_REQ_TUBE_SUCCESS */]:
			case types["h" /* CORE_APPROVE_REQ_ACC_SUCCESS */]:
			case types["_137" /* CORE_PRE_APPROVE_REQ_ACC_SUCCESS */]:
			case types["_32" /* CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS */]:
			case types["_144" /* CORE_REJECT_REQ_ACC_SUCCESS */]:
			case types["_42" /* CORE_DELETE_REQ_ACC_SUCCESS */]:
			case types["_212" /* CORE_SUBMIT_REQ_ACC_SUCCESS */]:
			case types["_189" /* CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS */]:
			case types["_0" /* CORE_COMPLETE_REQ_ACC_SUCCESS */]:
			case types["R" /* CORE_COMMENT_REQ_ACC_SUCCESS */]:
			case types["o" /* CORE_ATTACH_FILE_REQ_ACC_SUCCESS */]:
			case types["_54" /* CORE_GENCODE_NPI_REQ_ACC_SUCCESS */]:
			case types["_198" /* CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS */]:
			case types["_180" /* CORE_SHOP_APPROVE_REQ_ACC_SUCCESS */]:
			case types["z" /* CORE_CANCEL_REQ_ACC_SUCCESS */]:
			case types["_156" /* CORE_RE_STATUS_REQ_ACC_SUCCESS */]:
			case types["_71" /* CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS */]:
			case types["k" /* CORE_APPROVE_REQ_TUBE_SUCCESS */]:
			case types["_140" /* CORE_PRE_APPROVE_REQ_TUBE_SUCCESS */]:
			case types["_35" /* CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS */]:
			case types["_147" /* CORE_REJECT_REQ_TUBE_SUCCESS */]:
			case types["_45" /* CORE_DELETE_REQ_TUBE_SUCCESS */]:
			case types["_215" /* CORE_SUBMIT_REQ_TUBE_SUCCESS */]:
			case types["_192" /* CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS */]:
			case types["_3" /* CORE_COMPLETE_REQ_TUBE_SUCCESS */]:
			case types["U" /* CORE_COMMENT_REQ_TUBE_SUCCESS */]:
			case types["_57" /* CORE_GENCODE_NPI_REQ_TUBE_SUCCESS */]:
			case types["_201" /* CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS */]:
			case types["_183" /* CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS */]:
			case types["C" /* CORE_CANCEL_REQ_TUBE_SUCCESS */]:
			case types["_159" /* CORE_RE_STATUS_REQ_TUBE_SUCCESS */]:
			case types["_74" /* CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS */]:
			case types["_81" /* CORE_GET_REPORT_DRAWING_STATUS_SUCCESS */]:
			case types["_90" /* CORE_GET_REPORT_VIEW_DRAWING_SUCCESS */]:
			case types["_162" /* CORE_RE_STATUS_SELL_ORDER_SUCCESS */]:
			case types["_84" /* CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS */]:
			case types["_87" /* CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS */]:
			case types["_120" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS */]:
				return false;
			case types["_13" /* CORE_CREATE_DRAWING_FAILURE */]:
			// case CORE_SEARCH_DRAWING_FAILURE:
			case types["_163" /* CORE_SAVE_ITEM_FAILURE */]:
			case types["_206" /* CORE_SUBMIT_ITEM_FAILURE */]:
			case types["_61" /* CORE_GEN_CODE_ITEM_FAILURE */]:
			case types["_151" /* CORE_RE_SEND_ITEM_FAILURE */]:
			case types["b" /* CORE_APPROVE_ITEM_FAILURE */]:
			case types["_229" /* CORE_UPDATE_DRAWING_INFO_FAILURE */]:
			case types["_14" /* CORE_CREATE_DRAWING_INFO_FAILURE */]:
			case types["_100" /* CORE_GET_TUBE_INSIDE_DATA_FAILURE */]:
			case types["_76" /* CORE_GET_PIPE_TYPE_DATA_FAILURE */]:
			case types["_217" /* CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE */]:
			case types["_25" /* CORE_CREATE_SELL_ORDER_INFO_FAILURE */]:
			case types["_238" /* CORE_UPDATE_SELL_ORDER_INFO_FAILURE */]:
			case types["_127" /* CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE */]:
			case masterDataTypes["a" /* CORE_LOAD_MASTER_DATA_COATINGS_FAILURE */]:
			case masterDataTypes["j" /* CORE_LOAD_MASTER_DATA_COATING_FAILURE */]:
			case masterDataTypes["d" /* CORE_LOAD_MASTER_DATA_COATING_CREATE_FAILURE */]:
			case masterDataTypes["m" /* CORE_LOAD_MASTER_DATA_COATING_UPDATE_FAILURE */]:
			case masterDataTypes["g" /* CORE_LOAD_MASTER_DATA_COATING_DELETE_FAILURE */]:
			case masterDataTypes["F" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE */]:
			case masterDataTypes["O" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE */]:
			case masterDataTypes["I" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_CREATE_FAILURE */]:
			case masterDataTypes["R" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_UPDATE_FAILURE */]:
			case masterDataTypes["L" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_DELETE_FAILURE */]:
			case masterDataTypes["U" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE */]:
			case masterDataTypes["_3" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE */]:
			case masterDataTypes["X" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_CREATE_FAILURE */]:
			case masterDataTypes["_6" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_UPDATE_FAILURE */]:
			case masterDataTypes["_0" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_DELETE_FAILURE */]:
			case masterDataTypes["_9" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE */]:
			case masterDataTypes["_18" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE */]:
			case masterDataTypes["_12" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_CREATE_FAILURE */]:
			case masterDataTypes["_21" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_UPDATE_FAILURE */]:
			case masterDataTypes["_15" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_DELETE_FAILURE */]:
			case masterDataTypes["_116" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE */]:
			case masterDataTypes["_140" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE */]:
			case masterDataTypes["_134" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_CREATE_FAILURE */]:
			case masterDataTypes["_143" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_UPDATE_FAILURE */]:
			case masterDataTypes["_137" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_DELETE_FAILURE */]:
			case masterDataTypes["_24" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE */]:
			case masterDataTypes["_33" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE */]:
			case masterDataTypes["_27" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_CREATE_FAILURE */]:
			case masterDataTypes["_36" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_UPDATE_FAILURE */]:
			case masterDataTypes["_30" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_DELETE_FAILURE */]:
			case masterDataTypes["_86" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE */]:
			case masterDataTypes["_95" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE */]:
			case masterDataTypes["_89" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_CREATE_FAILURE */]:
			case masterDataTypes["_98" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_UPDATE_FAILURE */]:
			case masterDataTypes["_92" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_DELETE_FAILURE */]:
			case masterDataTypes["_54" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE */]:
			case masterDataTypes["_63" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE */]:
			case masterDataTypes["_57" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_CREATE_FAILURE */]:
			case masterDataTypes["_66" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_UPDATE_FAILURE */]:
			case masterDataTypes["_60" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_DELETE_FAILURE */]:
			case masterDataTypes["_101" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE */]:
			case masterDataTypes["_110" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE */]:
			case masterDataTypes["_104" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_CREATE_FAILURE */]:
			case masterDataTypes["_113" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_UPDATE_FAILURE */]:
			case masterDataTypes["_107" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_DELETE_FAILURE */]:
			case masterDataTypes["_119" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE */]:
			case masterDataTypes["_128" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE */]:
			case masterDataTypes["_122" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_CREATE_FAILURE */]:
			case masterDataTypes["_131" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_UPDATE_FAILURE */]:
			case masterDataTypes["_125" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_DELETE_FAILURE */]:
			case masterDataTypes["_69" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE */]:
			case masterDataTypes["_78" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE */]:
			case masterDataTypes["_72" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_CREATE_FAILURE */]:
			case masterDataTypes["_81" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_UPDATE_FAILURE */]:
			case masterDataTypes["_75" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_DELETE_FAILURE */]:
			case types["_130" /* CORE_LOAD_SETTING_FAILURE */]:
			case types["G" /* CORE_CHANGE_SETTING_FAILURE */]:
			case masterDataTypes["p" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE */]:
			case masterDataTypes["y" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE */]:
			case masterDataTypes["s" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_CREATE_FAILURE */]:
			case masterDataTypes["B" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_UPDATE_FAILURE */]:
			case masterDataTypes["v" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_DELETE_FAILURE */]:
			case types["_148" /* CORE_REJECT_SELL_ORDER_FAILURE */]:
			case types["_46" /* CORE_DELETE_SELL_ORDER_FAILURE */]:
			case types["_133" /* CORE_PRE_APPROVE_FAILURE */]:
			case types["_28" /* CORE_CUSTOMER_APPROVE_FAILURE */]:
			case types["a" /* CORE_APPROVE_FAILURE */]:
			case types["_205" /* CORE_SUBMIT_FAILURE */]:
			case types["_193" /* CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE */]:
			case types["_4" /* CORE_COMPLETE_SELL_ORDER_FAILURE */]:
			case types["V" /* CORE_COMMENT_SELL_ORDER_FAILURE */]:
			case types["s" /* CORE_ATTACH_FILE_SELL_ORDER_FAILURE */]:
			case manageTypes["p" /* CORE_LOAD_MANAGE_SYSTEMS_FAILURE */]:
			case manageTypes["y" /* CORE_LOAD_MANAGE_SYSTEM_FAILURE */]:
			case manageTypes["s" /* CORE_LOAD_MANAGE_SYSTEM_CREATE_FAILURE */]:
			case manageTypes["B" /* CORE_LOAD_MANAGE_SYSTEM_UPDATE_FAILURE */]:
			case manageTypes["v" /* CORE_LOAD_MANAGE_SYSTEM_DELETE_FAILURE */]:
			case manageTypes["a" /* CORE_LOAD_MANAGE_GROUPS_FAILURE */]:
			case manageTypes["j" /* CORE_LOAD_MANAGE_GROUP_FAILURE */]:
			case manageTypes["d" /* CORE_LOAD_MANAGE_GROUP_CREATE_FAILURE */]:
			case manageTypes["m" /* CORE_LOAD_MANAGE_GROUP_UPDATE_FAILURE */]:
			case manageTypes["g" /* CORE_LOAD_MANAGE_GROUP_DELETE_FAILURE */]:
			case types["M" /* CORE_CHANGE_USER_NPI_PERMIT_FAILURE */]:
			case types["J" /* CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE */]:
			case types["_7" /* CORE_CREATE_CUSTOMER_FAILURE */]:
			case types["_58" /* CORE_GENCODE_NPI_SELL_ORDER_FAILURE */]:
			case types["_202" /* CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE */]:
			case types["_184" /* CORE_SHOP_APPROVE_SELL_ORDER_FAILURE */]:
			case types["D" /* CORE_CANCEL_SELL_ORDER_FAILURE */]:
			case types["_109" /* CORE_LOAD_CUSTOMER_FAILURE */]:
			case types["_175" /* CORE_SEARCH_SELL_ORDER_FAILURE */]:
			case types["_94" /* CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE */]:
			case types["p" /* CORE_ATTACH_FILE_REQ_TUBE_FAILURE */]:
			case types["_22" /* CORE_CREATE_REQ_TUBE_INFO_FAILURE */]:
			case types["_235" /* CORE_UPDATE_REQ_TUBE_INFO_FAILURE */]:
			case types["_169" /* CORE_SEARCH_REQ_ACC_FAILURE */]:
			case types["_172" /* CORE_SEARCH_REQ_TUBE_FAILURE */]:
			case types["f" /* CORE_APPROVE_REQ_ACC_FAILURE */]:
			case types["_135" /* CORE_PRE_APPROVE_REQ_ACC_FAILURE */]:
			case types["_30" /* CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE */]:
			case types["_142" /* CORE_REJECT_REQ_ACC_FAILURE */]:
			case types["_40" /* CORE_DELETE_REQ_ACC_FAILURE */]:
			case types["_210" /* CORE_SUBMIT_REQ_ACC_FAILURE */]:
			case types["_187" /* CORE_SHOP_SUBMIT_REQ_ACC_FAILURE */]:
			case types["Y" /* CORE_COMPLETE_REQ_ACC_FAILURE */]:
			case types["P" /* CORE_COMMENT_REQ_ACC_FAILURE */]:
			case types["m" /* CORE_ATTACH_FILE_REQ_ACC_FAILURE */]:
			case types["_52" /* CORE_GENCODE_NPI_REQ_ACC_FAILURE */]:
			case types["_196" /* CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE */]:
			case types["_178" /* CORE_SHOP_APPROVE_REQ_ACC_FAILURE */]:
			case types["x" /* CORE_CANCEL_REQ_ACC_FAILURE */]:
			case types["_154" /* CORE_RE_STATUS_REQ_ACC_FAILURE */]:
			case types["_69" /* CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE */]:
			case types["i" /* CORE_APPROVE_REQ_TUBE_FAILURE */]:
			case types["_138" /* CORE_PRE_APPROVE_REQ_TUBE_FAILURE */]:
			case types["_33" /* CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE */]:
			case types["_145" /* CORE_REJECT_REQ_TUBE_FAILURE */]:
			case types["_43" /* CORE_DELETE_REQ_TUBE_FAILURE */]:
			case types["_213" /* CORE_SUBMIT_REQ_TUBE_FAILURE */]:
			case types["_190" /* CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE */]:
			case types["_1" /* CORE_COMPLETE_REQ_TUBE_FAILURE */]:
			case types["S" /* CORE_COMMENT_REQ_TUBE_FAILURE */]:
			case types["_55" /* CORE_GENCODE_NPI_REQ_TUBE_FAILURE */]:
			case types["_199" /* CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE */]:
			case types["_181" /* CORE_SHOP_APPROVE_REQ_TUBE_FAILURE */]:
			case types["A" /* CORE_CANCEL_REQ_TUBE_FAILURE */]:
			case types["_157" /* CORE_RE_STATUS_REQ_TUBE_FAILURE */]:
			case types["_72" /* CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE */]:
			case types["_79" /* CORE_GET_REPORT_DRAWING_STATUS_FAILURE */]:
			case types["_88" /* CORE_GET_REPORT_VIEW_DRAWING_FAILURE */]:
			case types["_160" /* CORE_RE_STATUS_SELL_ORDER_FAILURE */]:
			case types["_82" /* CORE_GET_REPORT_FOLLOW_STATUS_FAILURE */]:
			case types["_85" /* CORE_GET_REPORT_SUMMARY_STATUS_FAILURE */]:
			case types["_118" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE */]:
				return false;

			default:
				return state;
		}
	},
	reducerCallAPI: function reducerCallAPI() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateCallAPI;
		var action = arguments[1];

		switch (action.type) {

			default:
				return state;
		}
	}

});
// CONCATENATED MODULE: ./src/app/redux/reducers/drawing.js
var drawing__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_drawing = ({
    drawing: function drawing() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_113" /* CORE_LOAD_DRAWING_INFORMATION_REQUEST */]:
                return state;
            case types["_114" /* CORE_LOAD_DRAWING_INFORMATION_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && drawing__typeof(action.payload) === "object") {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_112" /* CORE_LOAD_DRAWING_INFORMATION_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    drawings: function drawings() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_167" /* CORE_SEARCH_DRAWING_REQUEST */]:
                return state;
            case types["_168" /* CORE_SEARCH_DRAWING_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_166" /* CORE_SEARCH_DRAWING_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterData.js



var masterData_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_masterData = ({
    masterData: function masterData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : masterData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_84" /* CORE_LOAD_MASTER_DATA_REQUEST */]:
                return state;
            case masterDataTypes["_85" /* CORE_LOAD_MASTER_DATA_SUCCESS */]:
                if (action.payload) {
                    console.log("action.payload", action.payload);
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["E" /* CORE_LOAD_MASTER_DATA_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/customerData.js


var customerData_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_customerData = ({
    customerData: function customerData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : customerData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_110" /* CORE_LOAD_CUSTOMER_REQUEST */]:
                return state;
            case types["_111" /* CORE_LOAD_CUSTOMER_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["_109" /* CORE_LOAD_CUSTOMER_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/item.js
var item__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var item_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_item = ({
    item: function item() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : item_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_116" /* CORE_LOAD_ITEM_INFORMATION_REQUEST */]:
                return state;
            case types["_117" /* CORE_LOAD_ITEM_INFORMATION_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && item__typeof(action.payload) === "object") {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_115" /* CORE_LOAD_ITEM_INFORMATION_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/report.js


var report_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_report = ({
    report: function report() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_80" /* CORE_GET_REPORT_DRAWING_STATUS_REQUEST */]:
                return state;
            case types["_81" /* CORE_GET_REPORT_DRAWING_STATUS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_79" /* CORE_GET_REPORT_DRAWING_STATUS_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    reportFollow: function reportFollow() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_83" /* CORE_GET_REPORT_FOLLOW_STATUS_REQUEST */]:
                return state;
            case types["_84" /* CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_82" /* CORE_GET_REPORT_FOLLOW_STATUS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    reportSummary: function reportSummary() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_86" /* CORE_GET_REPORT_SUMMARY_STATUS_REQUEST */]:
                return state;
            case types["_87" /* CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        datas = _action$payload3.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_85" /* CORE_GET_REPORT_SUMMARY_STATUS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    reportViewDrawing: function reportViewDrawing() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_89" /* CORE_GET_REPORT_VIEW_DRAWING_REQUEST */]:
                return state;
            case types["_90" /* CORE_GET_REPORT_VIEW_DRAWING_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && Array.isArray(datas)) {
                        return action.payload;
                    }
                    return { datas: [] };
                } else return { datas: [] };
            case types["_88" /* CORE_GET_REPORT_VIEW_DRAWING_FAILURE */]:
                return { datas: [] };
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/sellOrder.js
var sellOrder__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var sellOrder_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_sellOrder = ({
    reqTubeAllTube: function reqTubeAllTube() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_95" /* CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST */]:
                return state;
            case types["_96" /* CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && sellOrder__typeof(action.payload) === "object") {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_94" /* CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    reqAccAllTube: function reqAccAllTube() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_92" /* CORE_GET_REQ_ACC_ALL_TUBE_REQUEST */]:
                return state;
            case types["_93" /* CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && sellOrder__typeof(action.payload) === "object") {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_91" /* CORE_GET_REQ_ACC_ALL_TUBE_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    sellOrder: function sellOrder() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_128" /* CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST */]:
                return state;
            case types["_129" /* CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && sellOrder__typeof(action.payload) === "object") {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_127" /* CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    sellOrders: function sellOrders() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_176" /* CORE_SEARCH_SELL_ORDER_REQUEST */]:
                return state;
            case types["_177" /* CORE_SEARCH_SELL_ORDER_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_175" /* CORE_SEARCH_SELL_ORDER_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    reqTube: function reqTube() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_125" /* CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST */]:
                return state;
            case types["_126" /* CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && sellOrder__typeof(action.payload) === "object") {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        data = _action$payload5.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_124" /* CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    reqTubes: function reqTubes() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_173" /* CORE_SEARCH_REQ_TUBE_REQUEST */]:
                return state;
            case types["_174" /* CORE_SEARCH_REQ_TUBE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload6 = action.payload,
                        result = _action$payload6.result,
                        datas = _action$payload6.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_172" /* CORE_SEARCH_REQ_TUBE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    reqAcc: function reqAcc() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_122" /* CORE_LOAD_REQ_ACC_INFORMATION_REQUEST */]:
                return state;
            case types["_123" /* CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && sellOrder__typeof(action.payload) === "object") {
                    var _action$payload7 = action.payload,
                        result = _action$payload7.result,
                        data = _action$payload7.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_121" /* CORE_LOAD_REQ_ACC_INFORMATION_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    reqAccs: function reqAccs() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_170" /* CORE_SEARCH_REQ_ACC_REQUEST */]:
                return state;
            case types["_171" /* CORE_SEARCH_REQ_ACC_SUCCESS */]:
                if (action.payload) {
                    var _action$payload8 = action.payload,
                        result = _action$payload8.result,
                        datas = _action$payload8.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_169" /* CORE_SEARCH_REQ_ACC_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    reStatusToSubmit: function reStatusToSubmit() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sellOrder_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_161" /* CORE_RE_STATUS_SELL_ORDER_REQUEST */]:
                return state;
            case types["_162" /* CORE_RE_STATUS_SELL_ORDER_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && sellOrder__typeof(action.payload) === "object") {
                    var _action$payload9 = action.payload,
                        result = _action$payload9.result,
                        data = _action$payload9.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_160" /* CORE_RE_STATUS_SELL_ORDER_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/coating.js



var coating_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var coating = ({
    masterCoatings: function masterCoatings() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : coating_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["b" /* CORE_LOAD_MASTER_DATA_COATINGS_REQUEST */]:
                return state;
            case masterDataTypes["c" /* CORE_LOAD_MASTER_DATA_COATINGS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["a" /* CORE_LOAD_MASTER_DATA_COATINGS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterCoating: function masterCoating() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : coating_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["k" /* CORE_LOAD_MASTER_DATA_COATING_REQUEST */]:
                return state;
            case masterDataTypes["l" /* CORE_LOAD_MASTER_DATA_COATING_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["j" /* CORE_LOAD_MASTER_DATA_COATING_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/finEdge.js



var finEdge_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var finEdge = ({
    masterFinEdges: function masterFinEdges() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finEdge_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["G" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_REQUEST */]:
                return state;
            case masterDataTypes["H" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["F" /* CORE_LOAD_MASTER_DATA_FIN_EDGES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterFinEdge: function masterFinEdge() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finEdge_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["P" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_REQUEST */]:
                return state;
            case masterDataTypes["Q" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["O" /* CORE_LOAD_MASTER_DATA_FIN_EDGE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/finMaterial.js



var finMaterial_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var finMaterial = ({
    masterFinMaterials: function masterFinMaterials() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finMaterial_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["V" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_REQUEST */]:
                return state;
            case masterDataTypes["W" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["U" /* CORE_LOAD_MASTER_DATA_FIN_MATERIALS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterFinMaterial: function masterFinMaterial() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finMaterial_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_4" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_REQUEST */]:
                return state;
            case masterDataTypes["_5" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_3" /* CORE_LOAD_MASTER_DATA_FIN_MATERIAL_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/finSurface.js



var finSurface_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var finSurface = ({
    masterFinSurfaces: function masterFinSurfaces() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finSurface_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_10" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_REQUEST */]:
                return state;
            case masterDataTypes["_11" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_9" /* CORE_LOAD_MASTER_DATA_FIN_SURFACES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterFinSurface: function masterFinSurface() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : finSurface_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_19" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_REQUEST */]:
                return state;
            case masterDataTypes["_20" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_18" /* CORE_LOAD_MASTER_DATA_FIN_SURFACE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/tubeSize.js



var tubeSize_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var tubeSize = ({
    masterTubeSizes: function masterTubeSizes() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubeSize_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_117" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_REQUEST */]:
                return state;
            case masterDataTypes["_118" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_116" /* CORE_LOAD_MASTER_DATA_TUBE_SIZES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterTubeSize: function masterTubeSize() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubeSize_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_141" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_REQUEST */]:
                return state;
            case masterDataTypes["_142" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_140" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/insideShape.js



var insideShape_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var insideShape = ({
    masterInsideShapes: function masterInsideShapes() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : insideShape_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_25" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST */]:
                return state;
            case masterDataTypes["_26" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_24" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterInsideShape: function masterInsideShape() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : insideShape_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_34" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST */]:
                return state;
            case masterDataTypes["_35" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_33" /* CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/tubeMaterial.js



var tubeMaterial_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var tubeMaterial = ({
    masterTubeMaterials: function masterTubeMaterials() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubeMaterial_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_87" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_REQUEST */]:
                return state;
            case masterDataTypes["_88" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_86" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIALS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterTubeMaterial: function masterTubeMaterial() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubeMaterial_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_96" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_REQUEST */]:
                return state;
            case masterDataTypes["_97" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_95" /* CORE_LOAD_MASTER_DATA_TUBE_MATERIAL_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/plateMaterial.js



var plateMaterial_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var plateMaterial = ({
    masterPlateMaterials: function masterPlateMaterials() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : plateMaterial_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_55" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_REQUEST */]:
                return state;
            case masterDataTypes["_56" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_54" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIALS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterPlateMaterial: function masterPlateMaterial() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : plateMaterial_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_64" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_REQUEST */]:
                return state;
            case masterDataTypes["_65" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_63" /* CORE_LOAD_MASTER_DATA_PLATE_MATERIAL_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/tubePattern.js



var tubePattern_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var tubePattern = ({
    masterTubePatterns: function masterTubePatterns() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubePattern_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_102" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_REQUEST */]:
                return state;
            case masterDataTypes["_103" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_101" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERNS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterTubePattern: function masterTubePattern() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubePattern_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_111" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_REQUEST */]:
                return state;
            case masterDataTypes["_112" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_110" /* CORE_LOAD_MASTER_DATA_TUBE_PATTERN_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/tubeSizeAndPattern.js



var tubeSizeAndPattern_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var tubeSizeAndPattern = ({
    masterTubeSizeAndPatterns: function masterTubeSizeAndPatterns() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubeSizeAndPattern_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_120" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST */]:
                return state;
            case masterDataTypes["_121" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_119" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterTubeSizeAndPattern: function masterTubeSizeAndPattern() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : tubeSizeAndPattern_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_129" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST */]:
                return state;
            case masterDataTypes["_130" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_128" /* CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/productGroup.js



var productGroup_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var productGroup = ({
    masterProductGroups: function masterProductGroups() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : productGroup_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_70" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_REQUEST */]:
                return state;
            case masterDataTypes["_71" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_69" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUPS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterProductGroup: function masterProductGroup() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : productGroup_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_79" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_REQUEST */]:
                return state;
            case masterDataTypes["_80" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_78" /* CORE_LOAD_MASTER_DATA_PRODUCT_GROUP_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/paintLocation.js



var paintLocation_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var paintLocation = ({
    masterPaintLocations: function masterPaintLocations() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paintLocation_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_40" /* CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_REQUEST */]:
                return state;
            case masterDataTypes["_41" /* CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["_39" /* CORE_LOAD_MASTER_DATA_PAINT_LOCATIONS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterPaintLocation: function masterPaintLocation() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paintLocation_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["_49" /* CORE_LOAD_MASTER_DATA_PAINT_LOCATION_REQUEST */]:
                return state;
            case masterDataTypes["_50" /* CORE_LOAD_MASTER_DATA_PAINT_LOCATION_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["_48" /* CORE_LOAD_MASTER_DATA_PAINT_LOCATION_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/setting.js


var setting_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_setting = ({
    setting: function setting() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : setting_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_131" /* CORE_LOAD_SETTING_REQUEST */]:
                return state;
            case types["_132" /* CORE_LOAD_SETTING_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_130" /* CORE_LOAD_SETTING_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterDatas/coiltype.js



var coiltype_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var coiltype = ({
    masterCoilTypes: function masterCoilTypes() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : coiltype_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["q" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_REQUEST */]:
                return state;
            case masterDataTypes["r" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case masterDataTypes["p" /* CORE_LOAD_MASTER_DATA_COIL_TYPES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    masterCoilType: function masterCoilType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : coiltype_requestState;
        var action = arguments[1];

        switch (action.type) {
            case masterDataTypes["z" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_REQUEST */]:
                return state;
            case masterDataTypes["A" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case masterDataTypes["y" /* CORE_LOAD_MASTER_DATA_COIL_TYPE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/manage/system.js



var system_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var system = ({
    manageSystems: function manageSystems() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : system_requestState;
        var action = arguments[1];

        switch (action.type) {
            case manageTypes["q" /* CORE_LOAD_MANAGE_SYSTEMS_REQUEST */]:
                return state;
            case manageTypes["r" /* CORE_LOAD_MANAGE_SYSTEMS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case manageTypes["p" /* CORE_LOAD_MANAGE_SYSTEMS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    manageSystem: function manageSystem() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : system_requestState;
        var action = arguments[1];

        switch (action.type) {
            case manageTypes["z" /* CORE_LOAD_MANAGE_SYSTEM_REQUEST */]:
                return state;
            case manageTypes["A" /* CORE_LOAD_MANAGE_SYSTEM_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case manageTypes["y" /* CORE_LOAD_MANAGE_SYSTEM_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/manage/group.js



var group_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var group = ({
    manageGroups: function manageGroups() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : group_requestState;
        var action = arguments[1];

        switch (action.type) {
            case manageTypes["b" /* CORE_LOAD_MANAGE_GROUPS_REQUEST */]:
                return state;
            case manageTypes["c" /* CORE_LOAD_MANAGE_GROUPS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case manageTypes["a" /* CORE_LOAD_MANAGE_GROUPS_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    manageGroup: function manageGroup() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : group_requestState;
        var action = arguments[1];

        switch (action.type) {
            case manageTypes["k" /* CORE_LOAD_MANAGE_GROUP_REQUEST */]:
                return state;
            case manageTypes["l" /* CORE_LOAD_MANAGE_GROUP_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case manageTypes["j" /* CORE_LOAD_MANAGE_GROUP_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/user.js
var user__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var user_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var reducers_user = ({
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_107" /* CORE_GET_USER_INFO_REQUEST */]:
                return state;
            case types["_108" /* CORE_GET_USER_INFO_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && user__typeof(action.payload) === "object") {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["_106" /* CORE_GET_USER_INFO_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    users: function users() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_104" /* CORE_GET_USERS_REQUEST */]:
                return state;
            case types["_105" /* CORE_GET_USERS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_103" /* CORE_GET_USERS_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/oneDrive.js
var oneDrive__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var oneDrive_requestState = types["_241" /* REQUEST_STATE */];

/* harmony default export */ var oneDrive = ({
    items: function items() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : oneDrive_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_119" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST */]:
                return state;
            case types["_120" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && oneDrive__typeof(action.payload) === "object") {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["_118" /* CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers.js


// import { reducer as notificationsReducer } from 'reapop'































/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: reducers_user.users,
    user: reducers_user.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API

    isLoading: reducerCallAPI.isLoading,

    drawing: reducers_drawing.drawing,
    drawings: reducers_drawing.drawings,
    masterData: reducers_masterData.masterData,
    masterCoating: coating.masterCoating,
    masterCoatings: coating.masterCoatings,
    masterFinEdge: finEdge.masterFinEdge,
    masterFinEdges: finEdge.masterFinEdges,
    masterFinMaterial: finMaterial.masterFinMaterial,
    masterFinMaterials: finMaterial.masterFinMaterials,
    masterFinSurface: finSurface.masterFinSurface,
    masterFinSurfaces: finSurface.masterFinSurfaces,
    masterTubeSize: tubeSize.masterTubeSize,
    masterTubeSizes: tubeSize.masterTubeSizes,
    masterInsideShape: insideShape.masterInsideShape,
    masterInsideShapes: insideShape.masterInsideShapes,
    masterTubeMaterial: tubeMaterial.masterTubeMaterial,
    masterTubeMaterials: tubeMaterial.masterTubeMaterials,
    masterPlateMaterial: plateMaterial.masterPlateMaterial,
    masterPlateMaterials: plateMaterial.masterPlateMaterials,
    masterTubePattern: tubePattern.masterTubePattern,
    masterTubePatterns: tubePattern.masterTubePatterns,
    masterTubeSizeAndPattern: tubeSizeAndPattern.masterTubeSizeAndPattern,
    masterTubeSizeAndPatterns: tubeSizeAndPattern.masterTubeSizeAndPatterns,
    masterProductGroup: productGroup.masterProductGroup,
    masterProductGroups: productGroup.masterProductGroups,
    masterPaintLocation: paintLocation.masterPaintLocation,
    masterPaintLocations: paintLocation.masterPaintLocations,

    masterCoilType: coiltype.masterCoilType,
    masterCoilTypes: coiltype.masterCoilTypes,

    manageSystem: system.manageSystem,
    manageSystems: system.manageSystems,
    manageGroup: group.manageGroup,
    manageGroups: group.manageGroups,

    item: reducers_item.item,
    report: reducers_report.report,
    reportFollow: reducers_report.reportFollow,
    reportSummary: reducers_report.reportSummary,
    reportViewDrawing: reducers_report.reportViewDrawing,

    customerData: reducers_customerData.customerData,
    sellOrder: reducers_sellOrder.sellOrder,
    sellOrders: reducers_sellOrder.sellOrders,
    reqTube: reducers_sellOrder.reqTube,
    reqTubes: reducers_sellOrder.reqTubes,
    reqAcc: reducers_sellOrder.reqAcc,
    reqAccs: reducers_sellOrder.reqAccs,

    reStatusToSubmit: reducers_sellOrder.reStatusToSubmit,
    setting: reducers_setting.setting,

    reqTubeAllTube: reducers_sellOrder.reqTubeAllTube,
    reqAccAllTube: reducers_sellOrder.reqAccAllTube,
    oneDriveItems: oneDrive.items

}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(904);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(403)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./index.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/dist/cjs.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(75)(false);
// imports
exports.i(__webpack_require__(905), "");
exports.i(__webpack_require__(906), "");
exports.i(__webpack_require__(907), "");
exports.i(__webpack_require__(908), "");
exports.i(__webpack_require__(909), "");
exports.i(__webpack_require__(910), "");

// module
exports.push([module.i, ".fontMini,.module.errorModal .detailError{font-size:16px;font-size:1.6rem}.btn,.fontBody,.module.errorModal .detailError.detail,.module.inputForm .boxViewValue p,.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject,.module.layoutWithSidebar .menuSidebar,.module.layoutWithSidebar .sidebarBox .actionBox .userBox p,.module.layoutWithSidebar .sidebarBox .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .email,.ui.button,p{font-size:18px;font-size:1.8rem;line-height:25px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.form,.ui.input{font-size:18px!important;font-size:1.8rem!important}.fontHeader,.module.customTable .boxNoData p,.module.errorModal .detailError.header,.module.header .menu-item.text,.module.header .menuMobile,.module.inputForm .headerBoxHeaderTap,.module.itemSettingBox .boxTextHeaderSetting p,.module.menuData .boxMenu .itemMenu p,.module.popupUser .userContent .contentDetail .detailUser .name{font-size:20px!important;font-size:2rem!important}.boxHeaderPage p,.fontHeaderBody,.fontHeaderPage,.module.loginForm .text-box p{font-size:32px;font-size:3.2rem}.fontSettingValueView,.module.itemSettingBox .boxTextValueSetting p{font-size:24px;font-size:2.4rem}.fontStep,.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{font-size:16px!important;font-size:1.6rem!important}.btn{font-weight:700!important;min-width:100px}.btnPicker>.ui.basic.button,.btnPicker>.ui.basic.button:active,.btnPicker>.ui.basic.button:hover{background-color:inherit!important;border:none;box-shadow:none!important}.ui.button.btnLogin{background-color:#000;color:#e0e0e0;margin:0;width:9rem;height:9rem;font-size:35px;margin-top:7rem;cursor:pointer}.ui.button.btnAdd{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnAdd .i.icon,.ui.button.btnAdd i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnAddInvert{padding:0;width:30px;height:30px;color:#1b2c57;background-color:#e0e0e0;font-size:13px}.ui.button.btnAddInvert .i.icon,.ui.button.btnAddInvert i.icons{padding-right:2px!important;color:#1b2c57}.btnNewBlueText,.ui.button.btnNewBlueText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;background-color:#1e48f9;font-size:13px;min-width:100px;margin-left:5px}.btnNewBlueText:hover,.ui.button.btnNewBlueText:hover{color:#1e48f9;border:1px solid #1e48f9;background-color:unset}.btnAddText,.ui.button.btnAddText{background-color:#1b2c57}.btnAddText,.btnGenItemGreenText,.ui.button.btnAddText,.ui.button.btnGenItemGreenText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnGenItemGreenText,.ui.button.btnGenItemGreenText{background-color:#119303}.btnEditBlueText,.ui.button.btnEditBlueText{padding:0 15px;margin:0;height:30px;color:#e3e4e3;background-color:#1e48f9;font-size:13px;min-width:100px;margin-left:5px}.btnSubmitItemText,.ui.button.btnSubmitItemText{background-color:#f19fff}.btnCancelText,.btnSubmitItemText,.ui.button.btnCancelText,.ui.button.btnSubmitItemText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnCancelText,.ui.button.btnCancelText{background-color:#d83838}.btnReqCancelText,.ui.button.btnReqCancelText{padding:0 15px;margin:0;height:30px;color:#000;background-color:#fff;font-size:13px;margin-left:5px;min-width:100px;border:1px solid #e2e2e2}.btnReqCancelText:hover,.ui.button.btnReqCancelText:hover{color:red}.btnBackGrayText,.ui.button.btnBackGrayText{padding:0 15px;margin:0;height:30px;color:#000;background-color:#e8e8e8;border-color:1px hsla(0,0%,74%,.7803921569) solid;border-width:1px;border-style:solid;font-size:13px;margin-left:5px;min-width:100px}.btnCancelEditText,.ui.button.btnCancelEditText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnCancelTextInvert,.ui.button.btnCancelTextInvert{color:#d83838;border:1px solid #d83838}.btnCancelTextInvert,.btnUpdate,.ui.button.btnCancelTextInvert,.ui.button.btnUpdate{padding:0 15px;margin:0;height:30px;background-color:#e3e4e3;font-size:13px;margin-left:5px;min-width:100px}.btnUpdate,.ui.button.btnUpdate{color:#383838;border:1px solid #e0e0e0}.btnAddItemText,.ui.button.btnAddItemText{background-color:#1e48f9}.btnAddItemText,.btnValidateText,.ui.button.btnAddItemText,.ui.button.btnValidateText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px;cursor:pointer}.btnValidateText,.ui.button.btnValidateText{background-color:#353386}.btnGencodeText,.ui.button.btnGencodeText{background-color:#119303}.btnGencodeText,.btnResendText,.ui.button.btnGencodeText,.ui.button.btnResendText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px;cursor:pointer}.btnResendText,.ui.button.btnResendText{background-color:#e35f06}.btnEditText,.ui.button.btnEditText{color:#e0e0e0;background-color:#9646ff}.btnEditText,.btnEditYellowText,.ui.button.btnEditText,.ui.button.btnEditYellowText{padding:0 15px;margin:0;height:30px;font-size:13px;margin-left:5px;min-width:100px;cursor:pointer}.btnEditYellowText,.ui.button.btnEditYellowText{color:#353386;background-color:#dde01a}.btnApproveText,.ui.button.btnApproveText{background-color:#119303}.btnApproveText,.btnBackText,.ui.button.btnApproveText,.ui.button.btnBackText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px;cursor:pointer}.btnBackText,.ui.button.btnBackText{background-color:#f7213b}.ui.button.btnView{padding:0;margin:0;width:30px;height:30px;color:#353386;font-size:13px}.ui.button.btnView .i.icon,.ui.button.btnView i.icons{padding-right:2px!important;color:#353386}.ui.button.btnView.reqDraw{width:33px;height:33px}.ui.button.btnSearchBlueT{padding:0;margin:0;width:32px;height:32px;color:#fff;background-color:#071a29;font-size:11px}.ui.button.btnSearchBlueT .i.icon,.ui.button.btnSearchBlueT i.icons{padding-right:2px!important;color:#353386}.ui.button.btnSearchBlueT:hover{border:1px solid #071a29;color:#071a29;background-color:unset}.ui.button.btnClearT{padding:0;margin:0;width:32px;height:32px;background-color:#fff;border:1px solid #e0e0e0;font-size:11px}.ui.button.btnClearT .i.icon,.ui.button.btnClearT i.icons{padding-right:2px!important;color:#353386}.ui.button.btnClearT:hover{border:1px solid #f7213b;color:#f7213b}.ui.button.btnSearch{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnSearch .i.icon,.ui.button.btnSearch i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnSearchInvert{padding:0;margin:0;width:40px;height:40px;color:#1b2c57;background-color:#e0e0e0;font-size:13px}.ui.button.btnSearchInvert .i.icon,.ui.button.btnSearchInvert i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnReloadData{padding:0;margin:0;width:40px;height:40px;color:rgba(27,44,87,.1294117647);background-color:hsla(0,0%,88%,.2392156863);font-size:13px}.ui.button.btnReloadData .i.icon,.ui.button.btnReloadData i.icons{padding-right:2px!important;color:#e0e0e0}.btnUploadFile,.ui.button.btnUploadFile{padding:0 15px;margin:0;height:49px;background-color:#fff;font-size:13px;margin-left:5px;min-width:100px;border:1px solid;border-color:#dededf}.ui.button.btnDeleteFile{padding:0;margin:0;width:20px;height:20px;color:#e70000;background:hsla(0,0%,100%,0);font-size:13px}.ui.button.btnDeleteFile .i.icon,.ui.button.btnDeleteFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDownloadFile{padding:0;margin:0;width:20px;height:20px;color:#1b2c57;background:hsla(0,0%,100%,0);font-size:18px}.ui.button.btnDownloadFile .i.icon,.ui.button.btnDownloadFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnEdit{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#dde01a;font-size:13px}.ui.button.btnEdit .i.icon,.ui.button.btnEdit i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnEdit{margin-left:5px}.ui.button.btnDelete{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#d83838;font-size:13px;margin-left:5px}.ui.button.btnDelete .i.icon,.ui.button.btnDelete i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnConfirm{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#06be2e;font-size:13px;margin-left:5px}.ui.button.btnConfirm .i.icon,.ui.button.btnConfirm i.icons{padding-right:2px!important;color:#e0e0e0}.iconBtnConfirm{padding:0;margin:0!important;width:30px!important;height:30px!important;color:#e0e0e0;background-color:#0b6ddd;font-size:13px!important;border-radius:3px;padding-top:7.5px}.btnIcon,.ui.circular.btnIcon{width:40px;height:40px;margin-top:20px;padding:0!important;padding-right:2px!important}.btnIcon .ui.circular.button>.icon,.ui.circular.btnIcon .ui.circular.button>.icon{padding-right:2px!important;margin-top:5px!important}.btnIcon i.icon:hover,.ui.circular.btnIcon i.icon:hover{background-color:inherit!important;color:inherit!important;border:inherit!important}.ui.circular.btnIcon>.icon{font-size:20px;padding-top:5px;padding-right:2px!important}.btnSearchText,.ui.button.btnSearchText{padding:0 15px;margin:0;height:43.1094px;line-height:19.4286px;color:#e0e0e0;background-color:#1b2c57;font-size:13px;min-width:100px;margin-left:5px}.btnSearchText.margin15,.ui.button.btnSearchText.margin15{margin-top:15px}.btnSearchText.margin15:hover,.btnSearchText:hover,.ui.button.btnSearchText.margin15:hover,.ui.button.btnSearchText:hover{background-color:#254492}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui.steps .step .title,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,span{font-family:roboto}body{background-color:#f9f9f9}p{margin:0;color:#7c7c7c}.ui.checkbox,.ui.checkbox label,.ui.dropdown,.ui.form,.ui.form textarea,.ui.input,.ui.input input{color:#7c7c7c!important}.gridNogMargin,.gridNoPaddingMargin,.gridNoPaddingMargin>.column,.gridNoPaddingMargin>.row,.gridNoPaddingMargin>.row>.column{padding:0!important;margin:0!important}.gridColumnNoPaddingTB{padding-top:0!important;padding-bottom:0!important}.contentHeightMax{height:100%}.scrollListFormBox{height:140px;overflow-y:scroll;padding:1rem;background-color:#353386}.boxDatePicker{width:200px}.boxDatePicker.fluid{width:100%}.listSelectAll{padding-bottom:.42857143em;padding-top:.42857143em;background-color:#fff}.iWAAXb{padding:0 25px 0 10px!important}.ui.dimmer{z-index:2000!important}.iconMenuRowTable{cursor:pointer}.boxHeaderPage p{font-weight:700}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}@media only screen and (max-width:767px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:10px;padding-right:10px}.customContainer .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop{display:none}.customContainer .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent .contentBox .boxBody .boxContent{padding-top:50px}}@media only screen and (min-width:768px)and (max-width:991px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:30px;padding-right:30px}.customContainer .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop{display:none}}@media only screen and (min-width:992px)and (max-width:1199px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:60px;padding-right:30px}.customContainer .boxHeader.mobile,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile{display:none}}@media only screen and (min-width:1200px)and (max-width:1919px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:100px;padding-right:60px}.customContainer .boxHeader.mobile,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile{display:none}}@media only screen and (min-width:1920px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:150px;padding-right:60px}.customContainer .boxHeader.mobile,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile{display:none}}.scrollListFormBox{height:200px;overflow-y:auto;overflow-x:hidden;border:1px solid #e6e7e8;border-radius:.285714rem;background-color:#fff;padding:10px}.cursor-pointer{cursor:pointer}.div-flex{display:flex}p.white-space{white-space:normal}p.textDetailModal,p.white-space{color:rgba(0,0,0,.87);font-size:16px}b.textSubjectModal{font-size:16px;color:#2c75b7}.tooltip{position:relative;display:inline-block}.tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;z-index:1}.tooltip:hover .tooltiptext{visibility:visible}.MuiTypography-body1{font-size:1.5rem!important}.MuiTypography-body2{font-size:1.25rem!important}.MuiTypography-caption{font-size:1.2rem!important}.MuiTypography-subtitle1{font-size:2rem!important}.MuiButton-root{font-size:1.25rem!important}.MuiPickersModal-dialogRoot{width:370px!important}.MuiPickersBasePicker-pickerView{min-width:370px!important;width:370px}.flagMenu.active{width:30px;opacity:1;cursor:pointer}.flagMenu{opacity:.5;width:30px;cursor:pointer}.paddingLeft5{padding-left:5px}.padding10{padding:10px}.padding15{padding:15px}.padding20{padding:20px}.marginLeft5{margin-left:5px}.marginLeft10{margin-left:10px}.margin10{margin:10px}.gOlFUC{padding-right:10px}.ui.steps{border:none}.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{border-radius:5px;min-width:100px;height:50px;background-color:#e0e0e0;color:#7c7c7c}.ui.steps .step:after{display:none!important}.ui.steps .step.active,.ui.steps .step.active:hover{background-color:#353386!important}.ui.steps .step.active .title,.ui.steps .step.active .title:hover{color:#e0e0e0!important}.ui.steps a.step:hover{background-color:#e0e0e0!important}.ui.form .disabled.field,.ui.form .disabled.fields .field,.ui.form .field.disabled>label,.ui.form .field :disabled,.ui.form .fields.disabled>label{opacity:1}.ui.form .field>label{min-height:20px}.module.itemSettingBox .boxTextHeaderSetting p,.module.itemSettingBox .boxTextValueSetting p,.textOverflow{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ui.menu{background-color:#f9f9f9}.ui.form .field>.selection.dropdown{min-width:auto}.ui.selection.active.dropdown .menu{width:150px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.dropdown>.text,.ui.form,.ui.input{font-size:16px!important;width:100%}.ui.input.error>input{background-color:#fff6f6;border-color:#e0b4b4;color:#9f3a38;-webkit-box-shadow:none;box-shadow:none}.ui.form .field .ui.input input,.ui.form .fields .field .ui.input input{padding:5px!important;font-weight:200}.MuiTableSortLabel-root{font-size:16px;padding:5px 0!important;font-weight:800}.MuiTableRow-head,.MuiTableRow-hover,.MuiTableRow-root{padding:15px}.MuiTableCell-paddingNone{padding:inherit!important}.MuiTableCell-root,.MuiTablePagination-select{font-size:16px!important;font-weight:300!important}.footer{position:fixed;bottom:0;right:0;padding:20px 10px;text-align:right;background-color:#f9f9f9;width:100vw;z-index:1}.footer.center{text-align:center}.ui.form .field .ui.input,.ui.form .fields .field .ui.input,.ui.form .wide.field .ui.input{height:40px}.ui.steps .step .title{font-size:16px}.ui.disabled.input,.ui.input:not(.disabled) input[disabled]{opacity:.7}.ui.disabled.dropdown,.ui.disabled.dropdown .ui.dropdown>.text,.ui.disabled.input>input,.ui.disabled.input>input .ui.dropdown>.text,.ui.input:not(.disabled) input[disabled],.ui.input:not(.disabled) input[disabled] .ui.dropdown>.text{background-color:#dadada;color:#5a5a5a!important}.ui.form .inline.fields{margin:0}.ui.table thead{width:100%}.ui.sortable.table thead th{font-size:19px;text-align:center;font-weight:700;background-color:#e4e4e4}.ui.celled.table tr td,.ui.celled.table tr th{font-size:17px;overflow-wrap:anywhere}table tbody tr:nth-child(2n){background:#f7f5f5}.ui.sortable.table thead th.noSort:hover{background:#f7f7f7;color:inherit;cursor:inherit}.cursorPointer{cursor:pointer}.marginBottom10{margin-bottom:10px!important}.width100{width:100%!important}.homePage{width:100%;display:flex!important;justify-content:center;align-items:center!important;margin-top:35vh!important;text-align:center}.pageNotFound img.ui.image{display:inline-flex;width:250px}.pageNotFound h1{font-size:26px}.pageNotFound .char404{font-size:36px;color:#ff2d2d}.gfBlAt{cursor:pointer}.card-work-list{padding:6px 12px;border-radius:4px;border:1px solid #ababab;background:#fff;margin:4px 0}.checkbox-design-plan{margin-bottom:6px!important}.text-area-modify{width:100%;padding:4px;font-size:14px}.table-work-list-design-plan{margin:4px 0}.table-work-list-design-plan .header{display:flex;background:#ababab}.table-work-list-design-plan .header div{width:25%;text-align:center;padding:4px}.table-work-list-design-plan .wrapper-detail{max-height:120px;overflow-y:auto}.table-work-list-design-plan .wrapper-detail .detail{display:flex;border-bottom:1px solid #ababab}.table-work-list-design-plan .wrapper-detail .detail div{width:25%;text-align:center;padding:4px;word-wrap:break-word}.text-bottom{display:flex!important;justify-items:flex-end}.text-bottom h1{display:flex;align-items:flex-end}.download-onedrive:hover{text-decoration:underline;color:#2c75b7;font-weight:700}.module.loadableRoute{height:100vh;display:flex;justify-content:center;align-items:center}.module.loadableController{width:80vw;overflow:hidden}.module.loadableController,.module.loadableInController{height:100vh;display:flex;position:fixed;justify-content:center;align-items:center}.module.loadableInController{overflow:auto}.module.switchLanguage{display:flex}.module.switchLanguage .language-item.select{background-color:#ccc}.module.errorBoundary .grid-header{padding-top:50px}.module.header{margin:0;box-shadow:0 4px 12px 0 rgba(0,0,0,.05)!important;background-color:#353386!important;position:absolute;width:100%;margin:0!important;top:0;z-index:2000}.module.header .logo-box{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.module.header .logo-box img{display:inline-block;max-width:100%;max-height:100%}.module.header .menu-item.logoUser{padding-top:0;padding-bottom:0}.module.header .menu-item.logo{padding:0;width:150px;height:50px}.module.header .menu-item.text p{color:#353386!important;font-weight:700}.module.header .menuBoxDesktop{width:100%}.module.header .menuBoxDesktop .menuRight{width:100%;height:100%;justify-content:flex-end}.module.header .menuBoxMobile{width:100%;display:flex}.module.header .menuMobile{padding:0!important}.module.header .menuMobile>i{display:none!important}.module.header .imageMenuMobile>i{margin:0!important}.module.header .itemMenuDropdown,.module.header .subMenuDropdown{width:180px}.module.header .userImage{width:40px;height:40px;border-radius:50%;overflow:hidden;cursor:pointer}.module.header .userImage img{width:100%;height:100%}.module.errorModal>.header{background-color:#353386}.module.errorModal>.actions,.module.errorModal>.header{border:none!important;padding:15px!important}.module.errorModal .boxHeaderContent{height:100px;display:flex;justify-content:center;align-items:center}.module.errorModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:15px;opacity:.3;cursor:pointer}.module.errorModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.errorModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.errorModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.errorModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.errorModal .itemError{padding:10px 0!important}.module.errorModal .detailError{margin:0}.module.errorModal .detailError.header{font-weight:700}.module.errorModal .boxErrorParam{padding-left:15px}.module.actionModal .ui.button{font-size:16px;padding:10px;margin:0!important;background-color:#1b2c57;color:#ccc}.module.actionModal .danger p,.module.actionModal .warning p{color:#353386}.module.actionModal .danger .dialogHeader{padding-top:5px}.module.actionModal .danger .boxImageClose{margin-top:15px}.module.actionModal .headerBG{height:65px}.module.actionModal .headerBG.danger,.module.actionModal .headerBG.detail,.module.actionModal .headerBG.warning{background-color:#e6e7e8}.module.actionModal>.actions,.module.actionModal>.header{border:none!important;padding:15px!important}.module.actionModal .boxHeaderContent{display:flex;justify-content:center;align-items:center;flex-direction:column}.module.actionModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:-5px;opacity:.3;cursor:pointer}.module.actionModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.actionModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.actionModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxTextHeader p{font-size:16px;font-weight:700}.module.actionModal .boxTextDetail{min-height:9vh;max-height:60vh;overflow-y:scroll;overflow-x:hidden}.module.actionModal .boxAction{margin-top:1.5rem;position:absolute;z-index:999;text-align:center;width:100%;margin-bottom:5px}.module.inputForm{width:100%}.module.inputForm .formField{margin:0!important}.module.inputForm .formField.pickerType{position:relative}.module.inputForm .disabledInput{opacity:.45}.module.inputForm .boxViewValue{background-color:#fff;padding:1rem}.module.inputForm .boxViewValue p{margin:0!important}.module.inputForm .boxViewValue.mini{width:20%}.module.inputForm .boxViewValue.small{width:50%}.module.inputForm .labelInput p{margin:0!important}.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject{font-weight:700;display:inline-block}.module.inputForm .labelInput .required{color:red}.module.inputForm .boxDatePicker>.MuiFormControl-root{display:none!important}.module.inputForm .textValid{color:red}.module.inputForm .hidePicker{display:none}.module.inputForm .inputFile,.module.inputForm .inputFile input,.module.inputForm .inputPicker,.module.inputForm .inputPicker input{opacity:unset!important}.module.inputForm .btnPicker,.module.inputForm .btnUploadFile{position:absolute;top:50%;right:0;transform:translateY(-50%)}.module.inputForm .btnPicker button,.module.inputForm .btnUploadFile button{transform:translateX(-30%)}.module.inputForm .boxColumSubjectTop{padding-top:1rem!important}.module.inputForm .headerBoxHeaderTap{font-weight:700}.module.inputForm .editorInputHtml{height:275px!important;border:1px solid #f1f1f1!important;padding:5px!important;border-radius:2px!important;background-color:#fff}.module.inputForm .editorInputHtml span{font-family:inherit}.module.inputForm .boxInputUploadFile{display:flex}.module.inputForm .boxInputUploadFile .inputBox{flex:1}.module.inputForm .boxInputUploadFile .actionBox{flex:0 0 auto}.module.inputForm .boxInputUploadFile .actionBox button{height:100%;margin-right:0;margin-left:.5rem}.module.popupUser .userContent{display:flex;widows:200px}.module.popupUser .userContent .contentImage{flex:0 0 auto;width:70px;height:70px;border-radius:50%;overflow:hidden}.module.popupUser .userContent .contentImage img{width:100%;height:100%}.module.popupUser .userContent .contentDetail{padding-left:1rem;flex:1}.module.popupUser .userContent .contentDetail .detailUser .name{font-weight:700}.module.popupUser .userAction{border-top:1px solid #ccc;display:flex;justify-content:flex-end;margin-top:1rem;padding-top:1rem}.module.popupUser .userAction button{padding-top:.5rem;padding-bottom:.5rem}.holiday{background:#f1f1f1}.speciaoHliday{background:#e85e6c}.fc-time-area .fc-rows td>div{height:100px!important}.fc-highlightSelect{background-color:#4183c4;height:99px!important;margin-top:1px!important;margin-left:1px!important}.fc-eventCustom{background-color:red;border:1px solid #fff}.fc-holiday{background-color:#ccc}.module.customTable{padding-bottom:0;height:100%;width:100%;overflow:hidden;overflow-x:auto}.module.customTable .boxNoData{padding:3rem 0}.module.customTable .boxNoData p{font-weight:700}.module.layoutWithSidebar .sidebarBox{position:fixed;display:flex;flex-direction:column;top:0;bottom:0;left:0;width:250px;background-color:#353386;overflow-x:hidden;flex:1}.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center;flex-direction:column}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox{max-width:230px;height:60px}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox img{height:100%;display:block}.module.layoutWithSidebar .sidebarBox .headerBox .text p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox{border-top:1px solid #e6e7e8}.module.layoutWithSidebar .sidebarBox .actionBox .userBox p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox{margin-top:10px}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox button{padding-top:5px;padding-bottom:5px;width:100%}.module.layoutWithSidebar .sidebarBox .headerBox{border-bottom:1px solid #353386}.module.layoutWithSidebar .sidebarBox .actionBox,.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px}.module.layoutWithSidebar .sidebarBox .menuBox{flex:1;overflow-y:auto}.module.layoutWithSidebar .bodyBox{margin-left:250px;min-width:550px;padding:2rem}.module.layoutWithSidebar .menuSidebar{width:100%;margin:0!important;min-height:unset;border:none;border-radius:unset}.module.layoutWithSidebar .menuSidebar .item{margin:0!important;color:#353386;font-weight:700;background-color:#353386;border-radius:unset!important}.module.layoutWithSidebar .menuSidebar .active.item,.module.layoutWithSidebar .menuSidebar .item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar .menuSidebar .active.item{margin:0!important;font-weight:700;cursor:unset!important}.module.layoutWithSidebar .menuSidebar .active.item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar{width:10px;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-thumb{border-radius:0;background-color:#353386;border:2px solid #353386}.module.layoutBlank{height:100vh;height:calc(var(--vh, 1vh)*100);overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center}.module.layoutMaster,.module.layoutMaster .boxBody{background-color:#f9f9f9;height:100vh}.module.layoutMaster .boxBody{display:flex;flex:1;flex-direction:column}.module.layoutMaster .boxBody .boxHeader.expand{width:250px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage{width:100%;padding:5px;display:inline-flex;height:50px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem{width:30%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem img.ui.image,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem img.ui.image{margin-top:5px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem{width:70%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName{margin-top:-4px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName p{font-size:14px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .logout,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .logout{margin-top:-10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText{margin-top:10px;font-weight:400;text-align:left}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText p{font-size:13px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom{left:140px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom p{padding-left:15px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom .language{padding-left:8px}.module.layoutMaster .boxBody .boxHeader.expand .item.logo img.ui.image{width:180px;height:40px}.module.layoutMaster .boxBody .boxHeader{position:fixed;left:0;z-index:200;height:100vh;width:85px;background-color:#f9f9f9;border-right:1px solid #ccc;box-shadow:3px 0 7px #ccc;border-top-right-radius:10px}.module.layoutMaster .boxBody .boxHeader .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:10px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader .item.logo img.ui.image{width:40px;height:40px}.module.layoutMaster .boxBody .boxHeader .item{height:50px;overflow:hidden;cursor:pointer;width:100%}.module.layoutMaster .boxBody .boxHeader .item .itemIcon,.module.layoutMaster .boxBody .boxHeader .item .userImage{width:100%;text-align:center;height:40px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon img.ui.image,.module.layoutMaster .boxBody .boxHeader .item .userImage img.ui.image{left:45%;transform:translate(-45%);width:30px;height:30px;border-radius:5px;margin-top:10px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .itemIcon .logout,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .logout{text-align:left}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName{font-weight:700;padding-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName p,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName p{text-overflow:ellipsis;white-space:nowrap;height:30px;overflow:hidden;width:20ch}.module.layoutMaster .boxBody .boxHeader .item i.icon{padding-top:5px;text-align:center;font-size:30px;margin:0}.module.layoutMaster .boxBody .boxHeader .item .logout p{font-size:12px}.module.layoutMaster .boxBody .boxHeader .item .logout{cursor:pointer}.module.layoutMaster .boxBody .boxHeader .item.active{background-color:#e8e8e8}.module.layoutMaster .boxBody .boxHeader .item.line{border-top:1px solid #ccc;width:100%;height:1px;padding:0}.module.layoutMaster .boxBody .boxHeader .item.bottom{position:fixed;left:0;bottom:0;display:inline-table;padding:0;padding-bottom:10px;width:250px}.module.layoutMaster .boxBody .boxHeader .item.bottom p{font-size:12px;padding-left:8px}.module.layoutMaster .boxBody .boxHeader .item.bottom .language img.ui.image{display:inline;width:25px}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew{padding:10px 0;cursor:pointer}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .rowLayout{font-weight:100;display:inline-flex;margin-left:10px;text-transform:uppercase;width:90%}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .rowLayout i.icon{margin-right:15px;right:0;position:absolute;margin-top:2px}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .rowLayout.active{font-weight:bolder}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .iconShow{text-align:center}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .iconShow i.icon{color:#c9c9c9!important;font-size:30px}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .iconShow.active i.icon{color:#5b5b5b!important}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .iconShow.active{font-size:30px}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .rowInLayout{font-weight:100;cursor:pointer;width:100%;padding:10px;display:inline-flex;margin-left:15px}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .rowInLayout i.icon{margin-top:2px}.module.layoutMaster .boxBody .boxHeader .itemNewLayout .itemNew .rowInLayout.active{font-weight:bolder}.module.layoutMaster .boxBody .boxContent{padding-bottom:50px;height:100vh}.module.layoutMaster .boxBody .boxContent .contentBox{background-color:#f9f9f9;padding-top:2rem;width:100%;padding-bottom:100px}.module.layoutMaster .boxBody .boxHeader.mobile{width:100vw;z-index:200;position:fixed;left:0;height:45px;background-color:#f9f9f9}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo img.ui.image{width:30px;height:30px}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:3px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader.mobile.expand{height:100%;width:80vw}.module.layoutMaster .boxBody .boxHeader.mobile.expand .item.bottom{height:100vh;top:80%;left:50vw}.module.layoutMaster .logoImageHeader img{width:8rem;margin:0;display:inline-flex}.module.menuData .boxMenu{display:flex;flex-direction:row}.module.menuData .boxMenu .itemMenu{border:1px solid #353386;text-align:center;min-width:140px;padding:5px 0;cursor:pointer;background-color:#353386;transition:color .5s,background-color .5s}.module.menuData .boxMenu .itemMenu p{font-weight:700;color:#353386!important}.module.menuData .boxMenu .itemMenu.active{background-color:#353386}.module.menuData .boxMenu .itemMenu.active p{color:#353386!important}.module.menuData .boxMenu .itemMenu:hover{background-color:#353386}.module.menuData .boxMenu .itemMenu:hover p{color:#353386!important}.module.menuData .boxMenu .itemMenu:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.module.menuData .boxMenu .itemMenu:last-child{border-top-right-radius:5px;border-bottom-right-radius:5px}.overflowWrap{overflow-wrap:anywhere;align-self:center}.menuRightData{float:right}.txtFullName{font-size:18px}.module.login{text-align:center;margin-top:-50px}.module.login .logoImage img{width:45rem;margin:0;display:inline-flex}.module.login .loginButton{padding-top:30px}.loginMessage{color:red;margin-top:30px;font-size:1.2em}.module.loginForm .image-box{display:flex;justify-content:center;align-items:center}.module.loginForm .image-box .image{max-width:100%}.module.loginForm .image-box .image img{width:100%;display:block}.module.loginForm .text-box{text-align:left}.module.loginForm .text-box p{margin:0;font-weight:700}.module.itemSettingBox{width:100%}.module.itemSettingBox .boxTextValueSetting{height:70px;display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextValueSetting p{font-weight:700}.module.itemSettingBox .boxTextValueSetting img{width:100%;max-height:100%;display:block}.module.itemSettingBox .boxTextValueSetting .btnAction{position:absolute;right:0;top:0}.module.itemSettingBox .boxTextHeaderSetting{display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextHeaderSetting p{font-weight:700}.xDatabase{border-radius:3px;padding:5px;background:#fff;border:1px solid #dededf;min-height:42px}.xDatabase.readonly{background:#e3e3e3;border:1px solid #d1d1d1}.xDatabase .axDatabaseArray{margin-top:2.5px;display:inline-flex;margin-right:10px}.xDatabase .axDatabaseArray .section{display:inline-flex;padding:5px 10px;border:1px solid #797979;border-radius:5px;height:25px}.xDatabase .axDatabaseArray p.text{margin-top:-5px;cursor:default}.xDatabase .axDatabaseArray i{margin-top:-2px;margin-left:5px;color:red;cursor:pointer}.marginDatabaseName20{margin-top:20px!important}i.checkWarningModal{color:#ff9100;font-size:10.3em;margin-bottom:45px}.module.itemMailContentBox{width:100%}.module.itemMailContentBox .boxEnabled{display:flex}.module.itemMailContentBox .boxEnabled p{font-weight:700;margin-right:1rem}.module.itemMailContentBox .boxMailContent .boxContent .subject,.module.itemMailContentBox .boxMailContent .boxSubject .subject{font-weight:700;margin:0}.module.itemMailContentBox .boxMailContent .boxContent .detail,.module.itemMailContentBox .boxMailContent .boxSubject .detail{margin-left:1rem}.reportForm .stepHeader h1{color:#353386}.reportForm .contentReportInfomation{display:inline-flex;height:220px;overflow-y:scroll}.reportForm .accordionItem{display:inline-flex}.reportForm .accordionItem h1{margin:0;color:#353386}.reportForm .accordionItem i.icon{margin:7px 0 0!important}.reportForm .subItem2{padding:15px 40px;border:2px solid rgba(34,36,38,.15);border-radius:5px;margin:0 10px;margin-bottom:20px}.reportForm .subItem2 :last-child{margin-bottom:0}.reportForm .subItemError{background-color:hsla(0,91%,82%,.4509803922);color:#4e4e4e}.reportForm .noMargin{margin:0!important}.reportForm .dataLabelItem{height:20px;display:inline-flex;position:absolute;padding-left:1rem}.reportForm .viewSummaryItem{padding:10px 30px}.reportForm .viewSummaryItem .generateCode{padding:10px;border:1px dotted #b8b8b8;border-radius:5px;background-color:rgba(213,234,253,.4117647059)}.reportForm .viewSummaryItem .generateCode h2{padding:10px 0}.reportForm .error{color:red}.reportForm .viewSummaryHeader{display:contents;font-size:20px}.reportForm .viewSummarySubHeader{font-size:17px}.reportForm .checkBoxAssambly,.reportForm .radioSpecial{font-size:14px!important;padding-bottom:14px}.reportForm .btnRightConfirm{float:right;vertical-align:middle}.reportForm .tubeItem{padding:15px 20px;border:1px dotted #ccc;border-radius:10px;margin-bottom:5px}.reportForm .finItem,.reportForm .plateItem{padding:10px 25px!important;border:1px dotted #ccc;border-radius:10px;background-color:#f3f3f3;margin-bottom:5px}.reportForm .finItem.validateError,.reportForm .plateItem.validateError{background-color:#fde5e5}.reportForm .accordionError,.reportForm .ui.styled.accordion .title.accordionError{background-color:#ffc2c2}.reportForm .accordionSuccess,.reportForm .ui.styled.accordion .title.accordionSuccess{background-color:#d0ffc2}.actionLog{margin-top:50px}.actionLog .viewCommentHeader{font-size:small}.viewSummaryInline{display:inline-flex!important}.viewSummaryInline .viewSummaryHeader{padding-right:10px}.viewSummaryInline .ui.basic.red.label{padding-top:7px}.module.listNpiReport .title{font-weight:700;font-size:20px}.module.listNpiReport .searchSection{padding:20px;border:1px solid #e3e3e3;margin:10px;padding-bottom:30px;background-color:#fff}.module.listNpiReport .searchSection .titleLabel{margin-bottom:10px;font-weight:700}.module.listNpiReport .searchSection .borderStyle{border:1px solid #dededf;padding:10px;border-radius:3px;line-height:30px;min-height:110px}.module.listNpiReport .searchSection .marginTopLayout10{margin-top:15px}.module.listNpiReport .detail .headerVName{margin-right:10px}.module.listNpiReport .controlButton{padding-top:30px}.module.listNpiReport .controlButton.downloader{padding-top:40px}.module.listNpiReport .reportRowSummary{margin:5px 10px;background-color:#dee6ee}.module.drawing .header{width:80vw;position:fixed;z-index:100}.module.drawing .header .addDrawing{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.module.drawing .header .addDrawing .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.drawing .header .tableDrawingHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.drawing .header .tableDrawingHeader .th{text-align:center;padding:10px;font-size:14px;font-weight:600}.module.drawing .header .tableDrawingHeader .drawingNo{width:20%}.module.drawing .header .tableDrawingHeader .customerCode,.module.drawing .header .tableDrawingHeader .status{width:15%}.module.drawing .header .tableDrawingHeader .drawingRev{width:5%}.module.drawing .header .tableDrawingHeader .action,.module.drawing .header .tableDrawingHeader .coilSize,.module.drawing .header .tableDrawingHeader .customerName,.module.drawing .header .tableDrawingHeader .pipeType{width:20%}.module.drawing .drawingContent{padding-top:13rem}.module.drawing .drawingContent .tableDrawingContent{width:81vw;height:70vh;overflow:hidden;overflow-y:scroll;padding:10px 0}.module.drawing .drawingContent .tableDrawingContent .tr{display:inline-flex;width:80vw;color:#757575;border-bottom:1px solid #ccc}.module.drawing .drawingContent .tableDrawingContent .tr:hover{background-color:#e6e6e6;color:#000}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnAdd:disabled,.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnDelete:disabled,.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnView:disabled{opacity:.4!important}.module.drawing .drawingContent .tableDrawingContent .tableItem{padding:10px}.module.drawing .drawingContent .tableDrawingContent .tr:last-child{border:none}.module.drawing .drawingContent .tableDrawingContent .drawingRev,.module.drawing .drawingContent .tableDrawingContent .status{text-align:center}.module.drawing .drawingContent .tableDrawingContent .drawingNo{width:20%}.module.drawing .drawingContent .tableDrawingContent .customerCode,.module.drawing .drawingContent .tableDrawingContent .status{width:15%}.module.drawing .drawingContent .tableDrawingContent .drawingRev{width:5%}.module.drawing .drawingContent .tableDrawingContent .action,.module.drawing .drawingContent .tableDrawingContent .coilSize,.module.drawing .drawingContent .tableDrawingContent .customerName,.module.drawing .drawingContent .tableDrawingContent .pipeType{width:20%}.module.drawing .drawingContent .tableDrawingContent .coilSize,.module.drawing .drawingContent .tableDrawingContent .customerCode,.module.drawing .drawingContent .tableDrawingContent .customerName,.module.drawing .drawingContent .tableDrawingContent .drawingNo,.module.drawing .drawingContent .tableDrawingContent .drawingRev,.module.drawing .drawingContent .tableDrawingContent .pipeType,.module.drawing .drawingContent .tableDrawingContent .status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px}.module.drawing .drawingContent .tableDrawingContent .action .btnAdd,.module.drawing .drawingContent .tableDrawingContent .action .btnAdd:disabled,.module.drawing .drawingContent .tableDrawingContent .action .btnDelete,.module.drawing .drawingContent .tableDrawingContent .action .btnDelete:disabled,.module.drawing .drawingContent .tableDrawingContent .action .btnView,.module.drawing .drawingContent .tableDrawingContent .action .btnView:disabled{margin-right:5px;background-color:#cecece;color:#fffefe;opacity:1!important}.module.drawing .drawingContent .tableDrawingContent .action .btnDelete{margin:0}.module.drawing .drawingContent .drawingShowAllContent{text-align:center;width:80%;z-index:200;padding:0;display:inline;position:absolute}.module.drawing .drawingContent .drawingShowAllContent .ui.button{font-size:16px;background-color:inherit;color:#1b2c57}.module.drawing .drawingContent .drawingShowAllContent .ui.button .icon{margin-left:10px}.module.drawing .searchCoil .title{margin-top:20px;margin-right:20px}.btnAddDrawing,.ui.button.btnAddDrawing{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.btnAddDrawing .icon,.ui.button.btnAddDrawing .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.home .topUserSubject{font-size:15px;font-weight:500;color:#4183c4}.module.home .topUserContent{font-size:13px}.module.home .topUserTitle{color:#4183c4;font-size:20px;font-weight:900}.module.home .card{padding:10px;margin:10px}.module.home .description{margin-top:15px!important}.module.home input,.module.home input[type=text]{border:1px solid #ccc;padding:10px;border-radius:5px;font-size:14px;color:#5d5d5d}.module.home .react-datepicker,.module.home .react-datepicker-time__header,.module.home .react-datepicker-year-header,.module.home .react-datepicker__current-month{font-size:1.4rem}.module.home p{font-size:16px;color:#5d5d5d}.module.home .controlButton{padding-top:30px}.module.home .title{font-size:20px;font-weight:900}.module.home .ui.menu .active.item{color:#fff!important;background:rgba(154,86,219,.7215686275)}.module.home .bgWhiteComponent{background-color:#fff;border:1px solid #d4d4d5;padding:25px 15px}.module.home .bgWhiteComponent .searchSection .titleLabel{margin-bottom:10px}.module.home .bgWhiteComponent .actionSearch .btnAddText{margin-bottom:5px}.module.info{padding:3rem}.module.info .subject{font-size:16px;text-decoration:underline}.module.info .content{line-height:26px;padding:20px 0}.module.info .content ol.ui.list li{padding-bottom:10px;font-size:15px}.module.info .marginBottom20{margin-bottom:20px}.module.info .overflowContent{border:1px solid gray;padding:15px;border-radius:10px;max-height:70vh;overflow-y:auto;overflow-x:hidden}.systemInfo{background-color:#fff;padding:10px 15px}.systemInfo .updateLog{border:1px solid #bcbcbc;border-radius:10px;padding:20px;margin:0 15px;height:65vh;overflow-y:auto}.systemInfo .updateLog .listLogs{display:inline-flex}.systemInfo .updateLog .listLogs .versionUpdate{font-weight:700;font-size:1em;padding-right:4px;color:#a4a4a4}.systemInfo .updateLog .listLogs .createDate{font-size:1em;color:#b7b7b7}.headerListForm{border-radius:10px}.headerListForm .titleText{padding-left:10px;font-size:2em;font-weight:bolder}.headerListForm .minWidth1{min-width:1em!important;font-size:1em!important}.headerListForm .minWidth1 .text{font-size:1.2em!important}.headerListForm .fieldTitle{font-size:1em}.customMasterHome .ui.card{margin:10px}.customMasterHome .ui.card .header{text-overflow:ellipsis;overflow:hidden;height:1.2em;white-space:nowrap}.module.masterData .customMasterFormBorder{padding:40px 0}.module.masterData .ui.button{padding:10px;font-size:1.4rem;line-height:1.4rem}.module.masterData .addItem{margin-top:20px}.masterData{padding:20px 0}.masterData .tableMasterDataHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.sellForm .react-datepicker{font-size:1.1em}.sellForm .react-datepicker__header{padding-top:.8em}.sellForm .react-datepicker__month{margin:.4em 1em}.sellForm .react-datepicker__day,.sellForm .react-datepicker__day-name{width:1.9em;line-height:1.9em;margin:.166em}.sellForm .react-datepicker__current-month{font-size:1.1em}.sellForm .react-datepicker__navigation{top:1em;line-height:1.7em;border:.45em solid transparent}.sellForm .react-datepicker__navigation--previous{border-right-color:#ccc;left:1em}.sellForm .react-datepicker__navigation--next{border-left-color:#ccc;right:1em}.tableDownload{display:inline-flex;padding:5px;width:100%;padding-top:10px}.tableDownload .th{padding:10px;font-size:12px}.tableDownload .fileName{overflow-wrap:break-word;text-align:left;width:40%}.tableDownload .fileName.v2{width:60%;padding-left:20px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.tableDownload .action,.tableDownload .createDate,.tableDownload .fileSize,.tableDownload .fileType{align-self:center;text-align:center;width:30%}.tableDownload .action.v2,.tableDownload .createDate.v2,.tableDownload .fileSize.v2,.tableDownload .fileType.v2{width:20%}.fileDownload{max-height:200px;overflow-y:auto}.ui.button.loading.clearBG{background-color:hsla(0,0%,100%,0)!important}.htmlRenderText{overflow-wrap:break-word}.module.sellOrder{padding:20px 0}.module.sellOrder .header{width:80vw;z-index:100}.module.sellOrder .header .tableSellOrderHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.sellOrder .header .tableSellOrderHeader .th{text-align:center;padding:10px;font-size:14px;font-weight:600}.module.sellOrder .header .tableSellOrderHeader .customerCode,.module.sellOrder .header .tableSellOrderHeader .isWaitingCustomerApprove,.module.sellOrder .header .tableSellOrderHeader .status{width:15%}.module.sellOrder .header .tableSellOrderHeader .accountNum,.module.sellOrder .header .tableSellOrderHeader .custGroup,.module.sellOrder .header .tableSellOrderHeader .drawingNo{width:10%}.module.sellOrder .header .tableSellOrderHeader .drawingRev,.module.sellOrder .header .tableSellOrderHeader .isNormalPriority,.module.sellOrder .header .tableSellOrderHeader .requestType{width:5%}.module.sellOrder .header .tableSellOrderHeader .action,.module.sellOrder .header .tableSellOrderHeader .customerName,.module.sellOrder .header .tableSellOrderHeader .pipeType{width:15%}.module.sellOrder .addSellOrder{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.module.sellOrder .addSellOrder .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.sellOrder .minWidth1{min-width:1em!important;font-size:1em!important}.module.sellOrder .minWidth1 .text{font-size:1.2em!important}.module.sellOrder .sellOrderContent{padding-top:13rem}.module.sellOrder .sellOrderContent .tableSellOrderContent{width:81vw;height:70vh;overflow:hidden;overflow-y:scroll;padding:10px 0}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr{display:inline-flex;width:80vw;color:#757575;border-bottom:1px solid #ccc}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover{background-color:#e6e6e6;color:#000}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnAdd:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnDelete:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnView:disabled{opacity:.4!important}.module.sellOrder .sellOrderContent .tableSellOrderContent .tableItem{padding:10px}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:last-child{border:none}.module.sellOrder .sellOrderContent .tableSellOrderContent .customerCode,.module.sellOrder .sellOrderContent .tableSellOrderContent .isWaitingCustomerApprove,.module.sellOrder .sellOrderContent .tableSellOrderContent .status{width:15%}.module.sellOrder .sellOrderContent .tableSellOrderContent .accountNum,.module.sellOrder .sellOrderContent .tableSellOrderContent .custGroup,.module.sellOrder .sellOrderContent .tableSellOrderContent .drawingNo{width:10%}.module.sellOrder .sellOrderContent .tableSellOrderContent .drawingRev,.module.sellOrder .sellOrderContent .tableSellOrderContent .isNormalPriority,.module.sellOrder .sellOrderContent .tableSellOrderContent .requestType{width:5%;text-align:center}.module.sellOrder .sellOrderContent .tableSellOrderContent .action,.module.sellOrder .sellOrderContent .tableSellOrderContent .customerName,.module.sellOrder .sellOrderContent .tableSellOrderContent .pipeType{width:15%}.module.sellOrder .sellOrderContent .tableSellOrderContent .status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px;text-align:center;font-size:medium}.module.sellOrder .sellOrderContent .tableSellOrderContent .REJECT,.module.sellOrder .sellOrderContent .tableSellOrderContent .SUBMIT{color:red}.module.sellOrder .sellOrderContent .tableSellOrderContent .PRE-APPROVE{color:#ecc900}.module.sellOrder .sellOrderContent .tableSellOrderContent .WAIT-CUSTOMER-APPROVE{color:#52b1ff}.module.sellOrder .sellOrderContent .tableSellOrderContent .COMPLETE{color:#87ff6a}.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnAdd,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnAdd:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnView,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnView:disabled{margin-right:5px;background-color:#cecece;color:#fffefe;opacity:1!important}.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete{margin:0}.module.sellOrder .sellOrderContent .sellOrderShowAllContent{text-align:center;width:80%;z-index:200;padding:0;display:inline;position:absolute}.module.sellOrder .sellOrderContent .sellOrderShowAllContent .ui.button{font-size:16px;background-color:inherit;color:#1b2c57}.module.sellOrder .sellOrderContent .sellOrderShowAllContent .ui.button .icon{margin-left:10px}.module.inputForm .editorInputHtml.drawingOrder{height:100px!important;border:1px solid #a8a8a8!important;font-size:1.5em;font-weight:400;font-family:unset}.module.inputForm .editorInputHtml.drawingOrder span{font-family:inherit}.tableItem.status{word-break:normal;font-size:1em;font-weight:800}.tableItem.status .REJECT,.tableItem.status .SUBMIT{color:red}.tableItem.status .PRE-APPROVE{color:#ecc900}.tableItem.status .WAIT-CUSTOMER-APPROVE{color:#52b1ff}.tableItem.status .COMPLETE{color:#5fca00}.tableItem.status .DRAFT{color:#a5a5a5}.tableItem.action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.tableItem.action .btnView:hover{background-color:rgba(30,74,249,.3882352941);margin-right:5px;color:#fff}.tableItem.action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.tableItem.action .btnAdd:hover{background-color:rgba(244,213,34,.3411764706);margin-right:5px;color:#fff}.tableItem.action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.tableItem.action .btnAdd:disabled,.tableItem.action .btnDelete:disabled,.tableItem.action .btnView:disabled{opacity:.4!important}.module.user .ui.button{font-size:1.2rem;line-height:16px}.module.reqDrawing span.titleWithButton{display:inline-flex}.module.reqDrawing span.titleWithButton p.titleName{padding-top:3px;font-weight:700}.module.reqDrawing span.titleWithButton .ui.button.btn2CreateText{margin-left:25px;padding-top:3px;display:inline-flex}.module.reqDrawing span.titleWithButton .ui.button.btn2CreateText p.textAlign{color:#fff;font-size:12px;font-weight:400}.module.reqDrawing .ui.button.btnAdd{padding:0;width:40px;height:40px;color:#e0e0e0;background-color:#071a29;font-size:13px}.module.reqDrawing .ui.button.btnAdd .i.icon,.module.reqDrawing .ui.button.btnAdd i.icons{padding-right:2px!important;color:#e0e0e0}.module.reqDrawing .ui.button.btn2Clear{border:1px solid #e0e0e0;padding:0;width:40px;height:40px;color:#071a29;background-color:unset;font-size:13px}.module.reqDrawing .ui.button.btn2Clear .i.icon,.module.reqDrawing .ui.button.btn2Clear i.icons{padding-right:2px!important;color:#e0e0e0}.module.reqDrawing .minWidth1,.module.reqDrawing .minWidth1 .ui.selection.dropdown{min-width:1px!important}.module.reqDrawing .testLayout{height:300px}.module.reqDrawing .testLayout .heightText{transform:rotate(270deg);margin-top:-32vh;margin-left:-15vw}.ui.breadcrumb a{color:#e2e2e2}.ui.breadcrumb .active.section{color:#636363}.btn2CreateText,.ui.button.btn2CreateText{background-color:#1e48f9;padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.reqDrawing.title{font-weight:400}.reqDrawing .inputSize{display:inline-flex;margin-bottom:-15px;width:100%}.reqDrawing .inputSize .dotSplit{margin:0 10px;padding-top:12px;font-weight:700}.reqDrawing .mmMeasure{padding-top:8px;padding-left:7px}.field.tonsCapa,.ui.form .field .ui.input input,.ui.form .fields .field.tonsCapa .ui.input input{width:100%}.field.tonsCapa.textRight input{width:100%;text-align:right}.field.tonsCapa input:hover{border:1px solid gray}.rdw-editor-wrapper:hover{border:1px solid #1e48f9}.ui.button.btnMenuIcon{padding:0;width:30px;height:30px;border-radius:100%;color:#0f1a28;background-color:inherit;font-size:12px}.ui.button.btnMenuIcon.noBg{width:unset;height:unset;font-size:14px;background-color:unset}.ui.button.btnSubmitComment{font-size:2rem;height:20px;background:url(/assets/images/btn_ok_circle.png);background-repeat:no-repeat;background-size:contain;padding-left:1vh}.ui.button.btnUpload{font-size:3rem;background:url(/assets/images/btn_upload.png);background-repeat:no-repeat;background-size:contain}.ui.button.btnUpload.disable{opacity:.3;cursor:default}.commentInputSection .ui.button.btnSubmitComment{margin-top:10px;margin-right:-5px}.commentInputSection .ui.button.btnSubmitComment.disable{opacity:.5}.fileDownload.v2{margin-top:-20px;background:#fcfcfc;margin-bottom:10px}.module.reqDrawing .ui.input input:hover,.module.reqDrawing .ui.selection.dropdown:hover{border:1px solid #1e48f9}.module.reqDrawing .ui.checkbox.checkBoxSample:hover,.module.reqDrawing .ui.checked.radio.checkbox,.module.reqDrawing .ui.radio.checkbox:hover{font-weight:700}.module.reqDrawing .editorInputHtml.rdw-editor-main:hover{border:1px solid #1e48f9}.module.reqDrawing .module.customTable.data{background:#fff}.module.reqDrawing .module.customTable.data .iPpHLS{background-color:#fff;border-bottom-width:2px;border-bottom-color:#000}.module.reqDrawing .module.customTable.data .gAuPhq{border:1px solid #e2e2e2;margin-top:60px}.module.reqDrawing .module.customTable.data .brRDUc{width:98%;position:absolute;top:0;margin-top:3px}.sellForm .ui.secondary.pointing.menu .active.item{border-color:#1e48f9}.sellForm .ui.secondary.pointing.menu{border-bottom:2px solid #e2e2e2}.uploadNoFile{font-size:1.2em}.uploadNoFile.marginBottom50{margin-bottom:50px}i.checkSuccessModal{color:green;font-size:7em;margin-bottom:30px}", ""]);

// exports


/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"OK","cancel":"Cancel","back":"Back","welcome":"Welcome","hello":"Hello","somethingWrong":"Something Went Wrong, Please Try Again.","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","squareInch":"SQUARE INCH","version":"Version","logout":"Log out","npiSystem":"NPI System","pageNotFound":"Page not found, Please re-check your url again.","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","save":"Save","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","noWaitingSale":"No","waitingSale":"Yes","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","noFile":"No File","unknow":"UNKNOW","wrongDrawing":"Wrong Drawing No.","itemCode":"Item Code","itemStatus":"Item Status","actionLog":"Action Log","user":"User","action":"Action","timeStamp":"TimeStamp","chooseOptions":"Choose an option","endBeforeStart":"End before start","confirm":"Confirm","close":"Close","clear":"Clear","new":"New","home":"Home","modalConfirmReStatus":"Re-Status Drawing","reStatus":"Re-Status","restatusConfirm":"Are you sure to Re-Status this drawing no:","reStatusSuccess":"Re-Status Success","modalConfirmAxDatabase":"Modal Confirm","dangerWarningRemove":"Are you sure to delete this item?. Deleting may cause application error","delete":"Delete","confirmDB":"type the database name","duplicateValue":"Duplicate Database","fromDate":"From","toDate":"To","overview":"Overview","reportFollow":"Report Follow","reportSummary":"Report Summary","":""}}

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"Sign in with o365","title":"Login","logout":"Logout","loginFail":"Login Fail","getUserInfoFail":"Get User Info Fail From Microsoft Graph"}}

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

module.exports = {"report":{"create":"Create Report","information":"Information","orderNo":"Order No","orderType":"Order Type","orderTypeName":"Order Type Name","orderTypeOther":"Order Type Other","drawingNo":"Drawing No","drawingRev":"Drawing Rev","custCode":"Customer Code","custName":"Customer Name","model":"Model","code":"Code","priority":"Priority","priorityName":"Priority name","custApproval":"Customer Approval","custApprovalName":"Customer Approvalname","shipmentDate":"Shipment Date","coilGroup":"Coil Group","coilGroupName":"Coil Group Name","coilGroupOther":"Coil Group Other","coilType":"Coil Type","coilTypeName":"Coil Type Name","coilTypeOther":"Coil Type Other","pipeSize":"Pipe Size","pipeSizeName":"Pipe Size Name","pipeSizeOther":"Pipe Size Other","coilSize":"Coil Size","head":"Head","fhSize":"FH Size","fhMeasurement":"FH Measurement","flSize":"FL Size","flMeasurement":"FL Measurement","rowSize":"Row Size","fpiSize":"FPI Size","finMaterial":"Fin Material","finMaterialname":"Fin Material Name","finMaterialother":"Fin Material Other","finStrip":"Fin Strip","finStripName":"Surface","finStripOther":"Fin Strip Other","finMargin":"Fin Margin","finMarginName":"Edges","pipeMaterial":"Pipe Material","pipeMaterialName":"Tube Material Spec","pipeMaterialOther":"Pipe Material Other","pipeType":"Pipe Type","pipeTypeName":"Pipe Type Name","pipeTypeOther":"Pipe Type Other","plateType":"Plate Type","plateTypeName":"Plate Material Spec","plateTypeOther":"Plate Type Other","status":"Status","createdBy":"Created By","createdDate":"Created Date","updatedBy":"Updated By","updatedDate":"Updated Date","custApprovalBy":"Customer Approval By","custApprovalDate":"Customer Approval Date","drawingOld":"Drawing Old","customerCode":"Customer Code","customerName":"Customer Name","modelCode":"Model Code","approval":"Approval","coating":"Coating","confirmDrawing":"Confirm Drawing","headL":"L","headR":"R","headPipeSize":"Inside Shape","coilSizeFH":"FH","coilSizeFL":"FL","coilSizeRow":"ROW","coilSizeFPI":"FPI","pipePatternAndType":"Pipe Type And Pattern ","sites":"Sites","reGen":"Gen Code","excelRequestDrawing":"Overview Drawing ","overview":" Overview Request Drawing","overV":"Overview","coilObject":"Coil Object","internalTube":"Internal Tube","externalTube":"External Tube","tubeSize":"Tube Size","tubeMaterial":"Tube Material","insideShape":"Inside Shape","itemName":"Item Name","itemNumber":"Item Number","productName":"Product Name","tonsCapacity":"Tons Capacity","accessoryType":"Accessory Type","stickerTitle":"Sticker Title","stickerDescription":"Sticker Description","year":"Year","month":"Month","week":"Week","request":"Request","onProcess":"On Process","pdf":"PDF","complete":"Complete","cancel":"Cancel","waitNPIApprove":"Wait NPI Approve","waitPDFDrawing":"Wait PDF Drawing","waitCustomerApprove":"Wait Customer Approve","waitBank":"Wait Bank","reject":"Reject","drawingType":"Drawing Type","drawingStatusReport":"Drawing Status Report","pdfDrawing":"PDF Drawing","completeDrawing":"Complete Drawing","fileDownload":"File Download","drawingRequestType":"Drawing Request Type","search":"Search","download":"Download","file":"File","fileCompleteDrawing":"Complete Drawing File","filePdf":"PDF File","searchName":"Search Name","draftToSubmitMinTime":"Draft To Submit","submitDrawingToPreApproveMinTime":"Submit Drawing To PreApprove","preApproveToApproveMinTime":"PreApprove To Approve","approveToCustomerApproveMinTime":"Approve To Customer Approve","approveToWaitingCustomerApproveMinTime":"Approve To Waiting Customer Approve","customerApproveToShopSubmitMinTime":"Customer Approve To Shop Submit","shopSubmitToShopApproveMinTime":"Shop Submit To Shop Approve","shopApproveToCompleteMinTime":"Shop Approve To Complete","createYYYYMMDD":"Create Date","reqDrawingStatus":"Status","actionSummaryMins":"Summary","actionDay":"Day","actionHr":"Hour","actionMin":"Min","summaryDrawingMins":"Summary Drawing Mins","summaryReqDrawing":"Summary Req Drawing","":""}}

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

module.exports = {"finTube":{"finSemi":"Semi","finSurface":"Surface","finMaterialSpec":"Material Spec","finPattern":"Pattern","finLength":"Fin Length (Inch)","finHeight":"Fin Height (Inch)","finTubeHeight":"Tube High","finFPI":"FPI","finEdges":"Edges","tubeDiameter":"Tube Diameter","tubeInsideShape":"Inside Shape","tubeThinkness":"Thinkness (mm)","tubeFin":"Fin (Inch)","tubeType":"Type","tubeSemi":"Semi","tubeMaterialSpec":"Material Spec","mm":"(mm)","row":"Row","tubeFinLength":"FL (Inch)","tubeHairPin":"Hairpin (mm)","pattern":"Tube Pattern","finQuality":"Fin Quantity"}}

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

module.exports = {"fg":{"coilType":"Coil Type","pipeMaterial":"Pipe Material","pipeSize":"Pipe Size","coating":"Coating/Paint","drawingNo":"Drawing No.","objectType":"Object Type","drawingRev":"Drawing REV","tubeMaterial":"Material Tube","type":"TUBE Size","pattern":"Pattern","year":"Year","runNo":"Run No.","coilObject":"Coil Objective","rev":"Revision","sites":"Sites","layer":"Layer","tubeHeight":"Tube High"}}

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports = {"tube":{"":""}}

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"Search","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"Search","showLess":"Show Less","showAll":"Show All"}}

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

module.exports = {"header":{"material":"Material","special":"Special","assambly":"Assambly"}}

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports = {"plate":{"semi":"Semi","material":"Material","surface":"Surface","thickness":"Thickness","drawingNo":"Drawing No.","rev":"Revision"}}

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"Start Date","endDate":"End Date","user":"User","action":"Action","count":"Count","topActionByUser":"Top action by user","version":"Version","exportExcel":"Export Excel","reportType":"Report Type"}}

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

module.exports = {"menu":{"drawingSystem":"Drawing System","drawingSystem2":"Drawing System New","about":"About","master":"Master Data","sellOrder":"Drawing Request","user":"Users","settings":"Settings","systemSettings":"System","onedriveDownload":"Drawing OneDrive (Download)","onedriveNew":"Drawing OneDrive (New)","onedriveOld":"Drawing OneDrive (Old)","onedrive":"OneDrive","ovewviewSellOrder":"Overview Request Drawing","report":"Report","info":"Info","reqdrawingCoil":"Coil","reqdrawingTubeInTube":"Tube in Tube","reqdrawingAccessory":"Accessary","reqdrawingDownloadPDF":"Drawing Downloader","reqdrawingRestatus":"Re-Status Drawing","viewDrawingRequest":"View Drawing Request","overviewViewDrawing":"Overview View Drawing","":""}}

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports = {"drawing":{"create":"Create","update":"Update","view":"View","information":"Information","orderNo":"Order No.","orderType":"Order Type","orderTypeName":"Order Type Name","orderTypeOther":"Order Type Other","drawingNo":"Drawing No.","drawingRev":"Rev.","cust":"Customer","custCode":"Customer Code","custName":"Customer Name","model":"Model","code":"Code","normal":"Normal","urgent":"Urgent","approve":"(Waiting for customer approve)","approved":"(Proceed)","shipmentDate":"Shipment Date","productGroup":"Product Group","coilType":"Coil Type","pipeSize":"Pipe Size","pipeSizeName":"Pipe Size Name","pipeSizeOther":"Pipe Size Other","coilSize":"Coil Size","finMaterial":"Fin Material","finMaterialname":"Fin Material Name","finMaterialother":"Fin Material Other","finStrip":"Fin Strip","finStripName":"Fin Surface","finStripOther":"Fin Strip Other","finMargin":"Fin Margin","finMarginName":"Fin Edge","pipeMaterial":"Pipe Material","pipeMaterialName":"Tube Material","pipeMaterialOther":"Pipe Material Other","pipeType":"Pipe Type","pipeTypeName":"Pipe Type Name","pipeTypeOther":"Pipe Type Other","plateType":"Plate Type","plateTypeName":"Plate Material","plateTypeOther":"Plate Type Other","status":"Status","createdBy":"Created By","createdDate":"Created Date","updatedBy":"Updated By","updatedDate":"Updated Date","custApprovalBy":"Customer Approval By","custApprovalDate":"Customer Approval Date","drawingOld":"Drawing Old","customerCode":"Customer Code","customerName":"Customer Name","modelCode":"Model Code","approval":"Approval","coating":"Coating/Paint","confirmDrawing":"Confirm Drawing","headL":"L","headR":"R","headPipeSize":"Inside Shape","coilSizeFH":"FH","coilSizeFL":"FL","coilSizeRow":"ROW","coilSizeFPI":"FPI","pipePatternAndType":"Pipe Type And Pattern","tubeSizeAndPattern":"Tube Size And Pattern","sites":"Sites","drawingOrder":"Drawing Request Order","comment":"Special Information","typeOfRequest":"Type Of Request","priority":"Priority","sampleRequestDetails":"Sample Request Details","customerApproval":"Customer Approval","lh":"Left Hand Side","rh":"Right Hand Side","inch":"Inch","paintLocation":"Paint Location","reqSampleDetail":"Sample Detail","reqSample":"Request Sample","attachFileNPI":"Attach File (NPI)","attachFileCustomerApprove":"Attach File (Customer Approve)","attachFileSell":"Attach File (Sell)","accountNum":"AccNum","custGroup":"Customer Group","requestType":"Type","isNormalPriority":"Priority","isWaitingCustomerApprove":"Customer Approve","customerType":"Customer Type","side":"Side","btnPreApprove":"Pre Approve","btnCustomerApprove":"Customer Approve","btnApprove":"Final Approve","btnSubmit":"Submit","btnShopSubmit":"Shop Submit","btnComplete":"Complete","none":"None","reject":"Reject","preApprove":"Create Drawing By","createBy":"Create by","updateBy":"Update by","submit":"Submit","customerApprove":"Customer Approve","fileName":"File Name","fileType":"File Type","fileSize":"File Size","attachFile":"Attachment File","attachSale":"Sale File","attachSaleFile":"Sale Attach File","attachNPI":"NPI Attach File","attachCustomerFile":"Customer Attach File","attachCustomer":"Customer File","attachShopSubmitsFile":"Shop Submit File","attachCompletesFile":"Complete Drawing File","createDate":"Create Date","updateDate":"Update Date","document":"Document","commentMenu":"Comment","attachMenu":"Attach","shopSubmitsFile":"Shop Submit File","completesFile":"Complete Drawing File","designPlan":"Design Plan","pdfDrawingFile":"PDF Drawing File","attachPDFDrawing":"PDF Drawing Attach File","reviewFile":"Review File","submitPdfNpiFile":"Drawing Submit File PDF","cadFile":"CAD Drawing File","shopSubmitsFilePDF":"Shop Submit File PDF","shopSubmitsFileDxf":"Shop Submit File DXF","shopSubmitsFileCAD":"Shop Submit File CAD","attachReviewFile":"Review Attach File","attachSubmitPdfNpiFile":"Attach Drawing Submit File PDF","attachCADDrawingFile":"CAD Drawing Attach File","attachShopSubmitsFilePDF":"Shop Submit Attach File PDF","attachShopSubmitsFileDXF":"Shop Submit Attach File DXF","attachShopSubmitsFileCAD":"Shop Submit Attach File CAD","notFoundAndInsert":"Not found your customer. Please fill in form","coilSide":"Coil Side","unknow":"UNKNOW","genItem":"Gen Item","saleFile":"Sale File","saleDraft":"(Sale) Save","saleSubmmited":"(Sale) Submit","npiSave":"(NPI) Save","npiSubmit":"(NPI) Submit","npiPreApproved":"(NPI) Pre Approved","npiSummitDrawing":"(NPI) Drawing Submited","npiWaitingCustomerApproval":"(NPI) Waiting Customer Approval","finalApprove":"(NPI) Final-Approve","saleCusApproved":"(Sale) Customer Approved","npiShopSubmited":"(NPI) Shop Submited","npiShopApproved":"(NPI) Shop Approved","npiComplete":"(NPI) Completed","rejected":"Rejected","all":"All","convert":" Convert","newDrawing":"New Drawing","revDrawing":"Revise Drawing","repDrawing":"Repair Drawing","mm":"mm","sendToNPI":"SEND TO NPI","btnSubmitDrawing":"Submit Drawing","drawingSubmitted":"(NPI) Drawing Submitted","btnCancel":"Cancel","btnShopApprove":"Shop Approve","rejectedDrawing":"Rejected Drawing","customerRejected":"Customer Rejected","rejectedShop":"Rejected Shop","summary":"Summary","detail":"Detail","internalTube":"Internal Tube","externalTube":"External Tube","tubeSize":"Tube Size","tubeMaterial":"Tube Material","insideShape":"Inside Shape","tonsCapacity":"Tons Capacity","selectCustomer":"Select Customer","selectReqDrawing":"Select Request Drawing","itemName":"Item Name","productName":"Product Name","listCoil":"List Drawing Coil","listTubeInTube":"List Drawing Tube In Tube","listAccessory":"List Drawing Accessory","type":"Type","material":"Material","width":"Width","height":"Height","thickness":"Thickness","surface":"Surface","edge":"Edge","inlet":"Inlet","outlet":"Outlet","way":"Way","tubeType":"Tube Type","updateDesignPlan":"Update Design Plan","checkDataDesignPlan":"Please, Check data before submit.","designPlanName":"Design Plan","dueDateDesign":"Design Plan Due Date","total":"Total","percent":"Percent","":""}}

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports = {"systemInfo":{"title":"System Info","name":"Name","description":"Description","updateLog":"Update Log","headerTitle":"System Infomation","version":"Version","100-1":"Create new application","100-2":"Create module ( Login, Logout, Create Drawing, Support switch 2 Language)","110-1":"Fixed bug, module Create Drawing","110-2":"Change search to smart search","110-3":"Change UI (menu, home, search)","110-4":"Add module ( view summary at home page )","120-1":"Create module ( Create Drawing version 2 )","120-2":"Change gencode ax from UI to api","120-3":"Change gencode UI response","200-1":"Add Drawing Request","200-2":"Upgrade File Upload","200-3":"New Route to Drawing Folder on One Drive","200-4":"Add Step Approval Status.","300-0":"New UI","300-1":"Add Drawing Request Tube In Tube","300-2":"New Drawing System Tube In Tube","300-3":"Add Drawing Reqeust Accessory","300-4":"Add All Menu For Drawing Request and System","310-0":"Add New Feature Restatus","310-1":"Upgrade system for multi database","310-2":"Display reports in tabular format","310-3":"Changed the transmission of gen items connected to ax to FG-CL and SEMI-GROUP."}}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

module.exports = {"msCoating":{"title":"Coating/Paint","description":"** description"},"msCoilType":{"title":"Coil Type","description":"** description","fgType":"FG Type"},"msFinEdge":{"title":"Fin Edge","description":"** description"},"msFinMaterial":{"title":"Fin Material","description":"** description"},"msFinSurface":{"title":"Fin Surface","description":"** description"},"msTubeSize":{"title":"Tube Size","description":"** description"},"msTubePattern":{"title":"Tube Pattern","description":"** description"},"msTubeSizeAndPattern":{"title":"Tube Size & Pattern","description":"** description","patternId":"Pattern","typeId":"Type","value":"Value","codeIMS":"Code","nameIMS":"Name"},"msInsideShape":{"title":"Inside Shape","description":"** description"},"msTubeMaterial":{"title":"Tube Material","description":"** description","nameProd":"Gen Code"},"msPlateMaterial":{"title":"Plate Material","description":"** description"},"msSite":{"title":"Site Material","description":"** description"},"msProductGroup":{"title":"Product Group","description":"** description"},"msPaintLocation":{"title":"Paint Location","description":"** description"},"msError":{"code":"Please input Code","name":"Please input Name","value":"Please input Value","typeId":"Please input Type","patternId":"Please input Pattern","fgType":"Please input fg type","nameProd":"Please input  Gen Code"},"ovReqDraw":{"title":"Overview Reqeust Drawing","description":""},"ovDraw":{"title":"Overview Drawing","description":""}}

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

module.exports = {"setting":{"buttonChange":"Change Setting","buttonSaveChange":"Save Change","buttonCancel":"Cancel Change","allowDomainName":"Allow Domain Name","axDatabaseName":"AX Database Name","drawingPrefix":"Drawing Prefix","isEnableSinginWithO365":"Enabled Signin with o365","serviceToken":"Service Token","allowDomainNameError":"Require, Allow Domain Name","axDatabaseNameError":"Require, AX Database Name","drawingPrefixError":"Require, Drawing Prefix","serviceTokenError":"Require, Service Token","title":"Setting Info","reportWarningOverdueError":"Require, Report Warning Overdue","reportWarningOverdue":"Report Warning Overdue","":""}}

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data","addWork":"Add Work","startDate":"Start Date","dueDate":"Due Date","dateRang":"Date Rang","updateBy":"Update By","lastUpdateBy":"Last Update By","updateDate":"Update Date","activity":"Activity","remark":"Remark","searchOneDeive":"Search OneDrive File","fileName":"File Name","action":"Action","download":"Download","createDate":"Create Date"}}

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"Name","empId":"Employee Id","isAdmin":"Is Admin","isNpiAdmin":"Is Npi","manage":"Manage Users","costCenterName":"Cost Center","viewList":"View Users","manageNpi":"Manage NPI admin","manageAdmin":"Manage Admin","edit":"Edit","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"Back to List"}}

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

module.exports = {"reqDrawing":{"home":"Home","requestDrawing":"Request Drawing","drawRequest":"Drawing Request","tubeInTubeDrawingRequestOrder":"Tube in Tube Drawing Request Order","tubeInTubeListOrder":"Tube in Tube List Order","createNew":"Create New","customer":"Customer","status":"Status","priority":"Priority","search":"Search","placeholderSearch":"Select for search","placeholderInputSearch":"Input for search","tubeInTubeOrder":"Tube In Tube List Order","accessoryOrder":"Accessory List Order","uBend":"U-Bend","sticker":"Sticker","crossOver":"Cross-over","insulation":"Insulation","plate":"Plate","header":"Header","fin":"Fin","distributor":"Distributor","titleTubeInTube":"Tube In Tube","drawingSystemNew":"Coil","drawingSystemTubeInTube":"Tube In Tube","titleAccessory":"Accessory","mm":"mm","title":"Title","titleDescription":"Description","pefoam":"Pefoam","class":"Class","glue":"Glue","1sideGlue":"1 Side","noGlue":"No","black":"Black","gray":"Gray","color":"Color","tubeHeader":"Tube Header / Tools Extract","accessoryType":"Accessory Type","menuRestatus":"Re-Status","":""},"menuText":{"reqCoil":"Coil","reqTubeInTube":"Tube In Tube","reqAccessory":"Accessory"}}

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports = {"urlTranslate":{"requestDrawing":"Request Drawing","coil":"Coil","tubeInTube":"Tube In Tube","create":"Create","update":"Update","view":"View","accessory":"Accessory"}}

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"ตกลง","cancel":"ยกเลิก","back":"กลับ","welcome":"ยินดีต้อนรับ","hello":"สวัสดี","somethingWrong":"เกิดความผิดพลาด ลองใหม่อีกครั้ง","yourData":"ข้อมูลที่จะทำการบันทึก","validateError":"ไม่สามารถทำรายการต่อไปได้ กรุณากรอกข้อมูลให้ครบถ้วน","validateCommentError":"กรุณาแสดงความคิดเห็น","attachError":"ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากท่านยังไม่ได้ทำการเลือกไฟล์","squareInch":"SQUARE INCH","version":"เวอร์ชั่น","logout":"ออกจากระบบ","npiSystem":"ระบบ NPI","pageNotFound":"ไม่พบข้อมูล กรุณาตรวจสอบ url อีกครั้ง","unauthen":"ไม่มีสิทธิเข้าใช้งาน, กรุณาติดต่อเจ้าหน้าที่ เพื่อขอสิทธิใช้งาน","success":"สำเร็จ","fail":"ไม่สำเร็จ","save":"บันทึก","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"ใช่","no":"No","noWaitingSale":"ไม่รอ","waitingSale":"รอ","left":"Left","right":"Right","edit":"แก้ไข","reject":"Reject","search":"ค้นหา","lastUpdateBy":"แก้ไขโดย","create":"เพิ่ม","view":"ดูรายละเอียด","update":"แก้ไข","value":"Value","createFail":"บันทึกไม่สำเร็จ","updateFail":"ปรับปรุงไม่สำเร็จ","upload":"อัพโหลด","comment":"แสดงความคิดเห็น","noFile":"ไม่มีไฟล์","unknow":"ไม่รู้","wrongDrawing":"Wrong Drawing No.","itemCode":"รหัสรายการ","itemStatus":"สถานะ","actionLog":"บันทึกการกระทำ","user":"ผู้ใช้งาน","action":"การกระทำ","timeStamp":"วัน เวลาที่กระทำ","chooseOptions":"เลือกตัวเลือก","endBeforeStart":"จบก่อนเริ่ม","confirm":"ยืนยัน","close":"ปิด","clear":"เคลียร์","new":"New","home":"หน้าหลัก","modalConfirmReStatus":"Re-Status Drawing","reStatus":"Re-Status","restatusConfirm":"Are you sure to re-status this drawing no:","reStatusSuccess":"Re-Status Success","modalConfirmAxDatabase":"Modal Confirm","dangerWarningRemove":"Are you sure to delete this item?. Deleting may cause application error","delete":"Delete","confirmDB":"type the database name","duplicateValue":"Duplicate Database","fromDate":"From","toDate":"To","overview":"Overview","reportFollow":"Report Follow","reportSummary":"Report Summary","":""}}

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"ลงชื่อเข้าใช้ด้วย o365","title":"ลงชื่อเข้าใช้","logout":"ลงชื่อออก","loginFail":"ลงชื่อเข้าใช้งาน ไม่สำเร็จ","getUserInfoFail":"ดึงข้อมูลจาก Microsoft Graph ไม่สำเร็จ"}}

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

module.exports = {"report":{"create":"เพิ่มรายการใหม่","information":"รายละเอียดทั่วไป","orderNo":"เลขที่รายการ","orderType":"ประเภทรายการ","orderTypeName":"ชื่อประเภทรายการ","orderTypeOther":"ประเภทอื่นๆ","drawingNo":"Drawing No","drawingRev":"Rev","custCode":"รหัสลูกค้า","custName":"ชื่อลูกค้า","model":"Model","code":"Code","priority":"Priority","priorityName":"Priority name","approval":"Approval","custApproval":"Customer Approval","custApprovalName":"Customer Approvalname","shipmentDate":"Shipment Date","coilGroup":"Coil Group","coilGroupName":"กลุ่มผลิตภัณฑ์","coilGroupOther":"Coil Group Other","coilType":"Coil Type","coilTypeName":"ประเภทคอยล์","coilTypeOther":"Coil Type Other","pipeSize":"Pipe Size","pipeSizeName":"ขนาดท่อคอยล์","pipeSizeOther":"Pipe Size Other","coilSize":"ขนาดคอยล์","head":"Head","fhSize":"FH Size","fhMeasurement":"FH Measurement","flSize":"FL Size","flMeasurement":"FL Measurement","rowSize":"Row Size","fpiSize":"FPI Size","finMaterial":"Fin Material","finMaterialname":"วัสดุฟิน","finMaterialother":"Fin Material Other","finStrip":"Fin Strip","finStripName":"ลายฟิน","finStripOther":"Fin Strip Other","finMargin":"Fin Margin","finMarginName":"ขอบฟิน","pipeMaterial":"วัสดุท่อ","pipeMaterialName":"วัสดุท่อ","pipeMaterialOther":"Pipe Material Other","pipeType":"Pipe Type","pipeTypeName":"ชนิดท่อ","pipeTypeOther":"Pipe Type Other","plateType":"Plate Type","plateTypeName":"ชื่อชนิดเพลท","plateTypeOther":"Plate Type Other","status":"Status","createdBy":"Created By","createdDate":"Created Date","updatedBy":"Updated By","updatedDate":"Updated Date","custApprovalBy":"Customer Approval By","custApprovalDate":"Customer Approval Date","drawingOld":"Old Drawing","customerCode":"รหัสลูกค้า","customerName":"ชื่อลูกค้า","modelCode":"CODE","colorDetail":"Color Detail","colorDetailName":"รายละเอียดสี","colorType":"Color Type","coating":"Coating","confirmDrawing":"Confirm Drawing","headL":"L","headR":"R","headPipeSize":"Inside Shape","coilSizeFH":"FH","coilSizeFL":"FL","coilSizeRow":"ROW","coilSizeFPI":"FPI","pipePatternAndType":"Pipe Type And Pattern ","sites":"Sites","drawingOrder":"เลขที่ใบสั่งทำ","reGen":"Gen Code","excelRequestDrawing":"ภาพรวม","overview":" ภาพรวมใบสั่งทำแบบ","overV":"ภาพรวม","coilObject":"Coil Object","internalTube":"Internal Tube","externalTube":"External Tube","tubeSize":"Tube Size","tubeMaterial":"Tube Material","insideShape":"Inside Shape","itemName":"Item Name","itemNumber":"Item Number","productName":"Product Name","tonsCapacity":"Tons Capacity","accessoryType":"Accessory Type","stickerTitle":"Sticker Title","stickerDescription":"Sticker Description","year":"Year","month":"Month","week":"Week","request":"Request","onProcess":"On Process","pdf":"PDF","complete":"Complete","cancel":"Cancel","waitNPIApprove":"รอรับทราบ","waitPDFDrawing":"รอแผ่นหน้า","waitCustomerApprove":"รอลูกค้าตรวจ","waitBank":"รอแบงค์","reject":"ปฏิเสธ","drawingType":"Drawing Type","drawingStatusReport":"Drawing Status Report","pdfDrawing":"PDF Drawing","completeDrawing":"Complete Drawing","fileDownload":"File Download","drawingRequestType":"Drawing Request Type","search":"Search","download":"Download","file":"File","fileCompleteDrawing":"Complete Drawing File","filePdf":"PDF File","searchName":"Search Name","draftToSubmitMinTime":"Draft To Submit","submitDrawingToPreApproveMinTime":"Submit Drawing To PreApprove","preApproveToApproveMinTime":"PreApprove To Approve","approveToCustomerApproveMinTime":"Approve To Customer Approve","approveToWaitingCustomerApproveMinTime":"Approve To Waiting Customer Approve","customerApproveToShopSubmitMinTime":"Customer Approve To Shop Submit","shopSubmitToShopApproveMinTime":"Shop Submit To Shop Approve","shopApproveToCompleteMinTime":"Shop Approve To Complete","createYYYYMMDD":"Create Date","reqDrawingStatus":"Status","actionSummaryMins":"Summary","actionDay":"Day","actionHr":"Hour","actionMin":"Min","summaryDrawingMins":"Summary Drawing Mins","summaryReqDrawing":"Summary Req Drawing","":""}}

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

module.exports = {"finTube":{"finSemi":"Semi","finSurface":"Surface","finMaterialSpec":"Material Spec","finPattern":"Pattern","finLength":"Fin Length (Inch)","finHeight":"Fin Height (Inch)","finTubeHeight":"Tube High","finFPI":"FPI","finEdges":"Edges","tubeDiameter":"Tube Diameter","tubeInsideShape":"Inside Shape","tubeThinkness":"Thinkness (mm)","tubeFin":"Fin (Inch)","tubeType":"Type","tubeSemi":"Semi","tubeMaterialSpec":"Material Spec","mm":"(mm)","row":"Row","tubeFinLength":"FL (Inch)","tubeHairPin":"Hairpin (mm)","pattern":"Tube Pattern","finQuality":"Fin Quantity"}}

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports = {"fg":{"coilType":"Coil Type","pipeMaterial":"Pipe Material","pipeSize":"Pipe Size","coating":"Coating/Paint","drawingNo":"Drawing No.","objectType":"Object Type","drawingRev":"Drawing REV","tubeMaterial":"Material Tube","type":"TUBE Size","pattern":"Pattern","year":"Year","runNo":"Run No.","coilObject":"Coil Objective","rev":"Revision","sites":"Sites","layer":"Layer","tubeHeight":"Tube High"}}

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

module.exports = {"tube":{"":""}}

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

module.exports = {"plate":{"semi":"Semi","material":"Material","surface":"Surface","thickness":"Thickness","drawingNo":"Drawing No.","rev":"Revision"}}

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"วันที่เริ่มต้น","endDate":"วันที่สิ้นสุด","user":"ผู้ใช้งาน","action":"สถานะ","count":"จำนวน","topActionByUser":"ผู้ใช้งานที่ใช้งานสูงสุด ในแต่ละสถานะ","version":"เวอร์ชั่น","exportExcel":"ออกรายงาน","reportType":"ประเภทรายงาน"}}

/***/ }),

/***/ 940:
/***/ (function(module, exports) {

module.exports = {"menu":{"drawingSystem":"ระบบสร้าง ไอเทม เข้า AX","drawingSystem2":"ระบบสร้าง ไอเทม เข้า AX","about":"รายละเอียด","master":"ข้อมูล เริ่มต้น","sellOrder":"ใบสั่งทำแบบ","user":"ผู้ใช้งาน","settings":"ตั้งค่า","systemSettings":"ระบบ","onedriveDownload":"Drawing OneDrive (Download)","onedriveNew":"Drawing OneDrive (New)","onedriveOld":"Drawing OneDrive (Old)","onedrive":"OneDrive","ovewviewSellOrder":"ภาพรวมใบสั่งทำแบบ","report":"รายงาน","info":"ข้อมูลระบบ","reqdrawingCoil":"Coil","reqdrawingTubeInTube":"Tube in Tube","reqdrawingAccessory":"Accessary","reqdrawingDownloadPDF":"Download PDF","reqdrawingRestatus":"Re-Status Drawing","viewDrawingRequest":"View Drawing Request","overviewViewDrawing":"Overview View Drawing","":""}}

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

module.exports = {"drawing":{"create":"สร้าง","update":"แก้ไข","view":"รายละเอียด","information":"ข้อมูล","orderNo":"เลขที่รายการ","orderType":"ประเภทรายการ","orderTypeName":"ชื่อประเภทรายการ","orderTypeOther":"ประเภทรายการอื่นๆ","drawingNo":"เลขที่แบบ","drawingRev":"เวอร์ชั่น","cust":"ลูกค้า","custCode":"รหัสลูกค้า","custName":"ชื่อลูกค้า","model":"รุ่น","code":"รหัส","normal":"ปกติ","urgent":"ด่วน","approve":"(รอลูกค้าอนุมัติ)","approved":"(ดำเนินการต่อ)","shipmentDate":"วันจัดส่ง","productGroup":"กลุ่มผลิตภัณฑ์","coilType":"ประเภทคอยล์","pipeSize":"ขนาดท่อคอยล์","coilSize":"ขนาดของคอยล์","finMaterial":"วัสดุฟิน","finMaterialname":"วัสดุ","finMaterialother":"Fin Material Other","finStrip":"Fin Strip","finStripName":"ลายฟิน","finStripOther":"Fin Strip Other","finMargin":"Fin Margin","finMarginName":"ขอบฟิน","pipeMaterial":"Pipe Material","pipeMaterialName":"วัสดุท่อ","pipeMaterialOther":"Pipe Material Other","pipeType":"Pipe Type","pipeTypeName":"ชนิดท่อ","pipeTypeOther":"Pipe Type Other","plateType":"Plate Type","plateTypeName":"ชนิดเพลท","plateTypeOther":"Plate Type Other","status":"สถานะ","createdBy":"สร้างโดย","createdDate":"วันที่สร้าง","updatedBy":"แก้ไขโดย","updatedDate":"วันที่แก้ไข","custApprovalBy":"โดยลูกค้า","custApprovalDate":"วันที่อนุมัติ","drawingOld":"แบบเก่า","customerCode":"ลูกค้า Code","customerName":"ลูกค้า Name","modelCode":"รหัสรุ่น","approval":"อนุมัติ","coating":"ชนิดของสี/รูปแบบการพ่น","confirmDrawing":"ยืนยันแบบ","headL":"L","headR":"R","headPipeSize":"ชนิดท่อ","coilSizeFH":"FH","coilSizeFL":"FL","coilSizeRow":"ROW","coilSizeFPI":"FPI","pipePatternAndType":"รูปแบบและชนิดท่อ","tubeSizeAndPattern":"รูปแบบและชนิดท่อ","sites":"โรงงาน","drawingOrder":"ใบสั่งทำแบบ","comment":"รายละเอียดที่ต้องการเน้นเป็นพิเศษ","typeOfRequest":"ประเภทของแบบ","priority":"ลำดับความสำคัญ","sampleRequestDetails":"รายละเอียดขอตัวอย่าง","customerApproval":"ลูกค้า Approval","lh":"ด้านซ้ายมือ","rh":"ด้านขวามือ","inch":"นิ้ว","paintLocation":"สถานที่พ่นสี","reqSampleDetail":"รายละเอียดตัวอย่าง","reqSample":"ขอตัวอย่าง","attachFileNPI":"แนบไฟล์ (NPI)","attachFileCustomerApprove":"แนบไฟล์ (Customer Approve)","attachFileSell":"แนบไฟล์ (Sell)","accountNum":"AccNum","custGroup":"ลูกค้า Group","requestType":"ประเภท","isNormalPriority":"ความสำคัญ","isWaitingCustomerApprove":"ลูกค้า Approve","customerType":"ลูกค้า Type","side":"ด้าน","btnPreApprove":"ส่งขอรีวิว","btnCustomerApprove":"Customer Approve","btnApprove":"Final Approve","btnSubmit":"ขอทำแผน","btnShopSubmit":"Shop Submit","btnComplete":"สำเร็จ","none":"None","reject":"ปฏิเสธ","preApprove":"Create Drawing By","createBy":"สร้างโดย","updateBy":"แก้ไขโดย","submit":"ยืนยัน","customerApprove":"ลูกค้า Approve","fileName":"ชื่อไฟล์","fileType":"ประเภทไฟล์","fileSize":"ขนาดไฟล์","attachFile":"แนบไฟล์","createDate":"วันที่สร้าง","updateDate":"วันที่แก้ไข","document":"เอกสาร","commentMenu":"แสดงความคิดเห็น","attachMenu":"ไฟล์แนบ","designPlan":"แผนการออกแบบ","attachSaleFile":"แนบไฟล์ Sale","attachNPIFile":"แนบไฟล์ NPI","attachCustomerFile":"แนบไฟล์ลูกค้า","attachCompletesFile":"แนบไฟล์แบบสมบูรณ์","shopSubmitsFile":"Shop Submit File","pdfDrawingFile":"แนบไฟล์แบบ PDF","attachReviewFile":"แนบไฟล์รีวิว ","attachSubmitPdfNpiFile":"แนบไฟล์ Submit PDF","attachCADDrawingFile":"แนบไฟล์แบบ CAD","attachShopSubmitsFilePDF":"แนบไฟล์ Shop Submit PDF","attachShopSubmitsFileDXF":"แนบไฟล์ Shop Submit DXF","attachShopSubmitsFileCAD":"แนบไฟล์ Shop Submit CAD","saleFile":"ไฟล์แนบ Sale","completesFile":"ไฟล์แนบแบบสมบูรณ์","attachPDFDrawing":"ไฟล์แนบแบบ PDF ","reviewFile":"ไฟล์แนบรีวิว","submitPdfNpiFile":"ไฟล์แนบ Submit PDF","cadFile":"ไฟล์แนบแบบ CAD","attachCustomer":"ไฟล์แนบลูกค้า","shopSubmitsFilePDF":"ไฟล์แนบ Shop Submit PDF","shopSubmitsFileDxf":"ไฟล์แนบ Shop Submit DXF","shopSubmitsFileCAD":"ไฟล์แนบ Shop Submit CAD","notFoundAndInsert":"Not found your customer. Please fill in form","coilSide":"ด้านของคอยล์","unknow":"ไม่ทราบ","genItem":"Gen Item","saleDraft":"(Sale) ฉบับร่าง","saleSubmmited":"(Sale) ส่งขอทำแบบ","npiSave":"(NPI) บันทึก","npiSubmit":"(NPI) ส่ง","npiPreApproved":"(NPI) รีวิวผ่าน","npiSummitDrawing":"(NPI) ใบหน้าส่งตรวจ","npiWaitingCustomerApproval":"(NPI) รอลูกค้า APPROVE","saleCusApproved":"(Sale) ลูกค้า APPROVED แล้ว","npiShopSubmited":"(NPI) เขียนแบบ SHOP แล้ว","npiShopApproved":"(NPI) ตรวจ Shop ผ่าน","npiComplete":"(NPI) สำเร็จ","rejected":"ปฎิเสธ","all":"ทั้งหมด","convert":"แปลงค่า","newDrawing":"แบบใหม่","revDrawing":"แก้ไขแบบ","repDrawing":"ซ่อมแบบ","mm":"มม","finalApprove":"(NPI) รีวิวรอบสุดท้ายผ่าน","sendToNPI":"ส่งไปถึง NPI","btnSubmitDrawing":"Submit Drawing","drawingSubmitted":"(NPI) ใบหน้าส่งตรวจ","btnCancel":"ยกเลิก","btnShopApprove":"ตรวจ Shop","summary":"summary","detail":"detail","internalTube":"Internal Tube","externalTube":"External Tube","tubeSize":"Tube Size","tubeMaterial":"Tube Material","insideShape":"Inside Shape","tonsCapacity":"Tons Capacity","selectCustomer":"Select Customer","selectReqDrawing":"Select Request Drawing","itemName":"Item Name","productName":"Product Name","listCoil":"List Drawing Coil","listTubeInTube":"List Drawing Tube In Tube","listAccessory":"List Drawing Accessory","type":"Type","material":"Material","width":"Width","height":"Height","thickness":"Thickness","surface":"Surface","edge":"Edge","inlet":"Inlet","outlet":"Outlet","way":"Way","tubeType":"Tube Type","updateDesignPlan":"Update Design Plan","checkDataDesignPlan":"กรุณาตรวจสอบข้อมูลก่อนกดยืนยัน","designPlanName":"แผนการออกแบบ","dueDateDesign":"แผนการออกแบบ (วันสิ้นสุด)","total":"รวม","percent":"เปอร์เซ็นต์","":""}}

/***/ }),

/***/ 942:
/***/ (function(module, exports) {

module.exports = {"systemInfo":{"title":"ข้อมูลระบบ","name":"ชื่อ","description":"รายละเอียด","updateLog":"รายการปรับปรุง","headerTitle":"รายละเอียดของระบบ","version":"เวอร์ชั่น","100-1":"เพิ่มโปรเจค","100-2":"เพิ่มเมนู ( ลงชื่อเข้าใช้งาน, ออกจากระบบ, เพิ่มรายการ Drawing, ระบบ 2 ภาษา)","110-1":"แก้บัค เพิ่มรายการ Drawing ","110-2":"เปลี่ยนเมนูค้นหา ให้ใช้งานง่ายขึ้น ","110-3":"เปลี่ยนการแสดงผล ของ เมนู","110-4":"เพิ่มการแสดงผลหน้าหลัก ให้แสดงผลภาพรวม","120-1":"เพิ่มเมนู ( เพิ่มรายการ เวอร์ชั่น 2 )","120-2":"เปลี่ยนการสร้างรายการใน ax จากการเปิด tab เป็นให้ api จัดการแทน","120-3":"เปลี่ยนการแสดงผลหลังจากสร้างรายการใน ax","200-1":"เพิ่มระบบใบสั่งทำแบบ","200-2":"อัพเกรดระบบอัพโหลดไฟล์","200-3":"เพิ่มช่องทางการเข้า Drawing บน One Drive","200-4":"เพิ่มลำดับขั้นในการอัพเดทสถานะ","300-0":"หน้าจอผู้ใช้งานแบบใหม่","300-1":"เพิ่มระบบใบสั่งทำแบบ ประเภทท่อ","300-2":"เพิ่มระบบสร้างไอเทม เช้า AX ประเภทท่อ","300-3":"เพิ่มระบบใบสั่งทำแบบ ประเภทส่วนประกอบ","300-4":"เพิ่มระบบสร้างไอเทม เช้า AX ประเภทส่วนประกอบ","310-0":"รองรับการย้อนสถานะของระบบ","310-1":"เพิ่มการตั้งค่าระบบเก็บข้อมูล","310-2":"เพิ่มการแสดงรายงานในรูปแบบตาราง","310-3":"เปลี่ยนแปลงการส่งข้อมูลสร้างไอเทม ที่เชื่อมต่อกับ ax เป็น FG-CL และ SEMI-GROUP"}}

/***/ }),

/***/ 943:
/***/ (function(module, exports) {

module.exports = {"msCoating":{"title":"Coating/Paint","description":"** description"},"msCoilType":{"title":"Coil Type","description":"** description","fgType":"FG Type"},"msFinEdge":{"title":"Fin Edge","description":"** description"},"msFinMaterial":{"title":"Fin Material","description":"** description"},"msFinSurface":{"title":"Fin Surface","description":"** description"},"msTubeSize":{"title":"Tube Size","description":"** description"},"msTubePattern":{"title":"Tube Pattern","description":"** description"},"msTubeSizeAndPattern":{"title":"Tube Size & Pattern","description":"** description","patternId":"Pattern","typeId":"Type","value":"Value","codeIMS":"Code","nameIMS":"Name"},"msInsideShape":{"title":"Inside Shape","description":"** description"},"msTubeMaterial":{"title":"Tube Material","description":"** description","nameProd":"Gen Code"},"msPlateMaterial":{"title":"Plate Material","description":"** description"},"msSite":{"title":"Plate Material","description":"** description"},"msProductGroup":{"title":"Product Group","description":"** description"},"msPaintLocation":{"title":"Paint Location","description":"** description"},"msError":{"code":"กรุณาระบุข้อมูล รหัส","name":"กรุณาระบุข้อมูล ชื่อ","value":"กรุณาระบุข้อมูล Value","typeId":"กรุณาระบุข้อมูล Type","patternId":"กรุณาระบุข้อมูล Pattern","fgType":"กรุณาระบุข้อมูล fg type","nameProd":"กรุณาระบุข้อมูล Gen Code"},"ovReqDraw":{"title":"Overview Reqeust Drawing","description":""},"ovDraw":{"title":"Overview Drawing","description":""}}

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

module.exports = {"setting":{"buttonChange":"Change Setting","buttonSaveChange":"Save Change","buttonCancel":"Cancel Change","allowDomainName":"Allow Domain Name","axDatabaseName":"AX Database Name","drawingPrefix":"Drawing Prefix","isEnableSinginWithO365":"Enabled Signin with o365","serviceToken":"Service Token","allowDomainNameError":"กรุณาระบุ, Allow Domain Name","axDatabaseNameError":"กรุณาระบุ, AX Database Name","drawingPrefixError":"กรุณาระบุ, Drawing Prefix","serviceTokenError":"กรุณาระบุ, Service Token","title":"Setting Info","reportWarningOverdueError":"กรุณาระบุ Report Warning Overdue","reportWarningOverdue":"Report Warning Overdue","":""}}

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล","addWork":"เพิ่มรายการ","startDate":"วันที่เริ่มต้น","dueDate":"วันที่สิ้นสุด","dateRang":"ระยะเวลา","updateBy":"แก้ไขโดย","lastUpdateBy":"แก้ไขล่าสุดโดย","updateDate":"วันที่แก้ไข","activity":"กิจกรรม","remark":"หมายเหตุ","searchOneDeive":"ค้นหาไฟล์ OneDeive","fileName":"ชื่อไฟล์","action":"ตัวเลือก","download":"ดาวน์โหลด","createDate":"วันที่สร้าง"}}

/***/ }),

/***/ 946:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"ชื่อ","empId":"รหัสพนักงาน","isAdmin":"สิทธิ Admin","isNpiAdmin":"สิทธิ Npi","manage":"รายละเอียด ผู้ใช้งาน","costCenterName":"หน่วยงาน","viewList":"รายละเอียดผู้ใช้งาน","manageNpi":"จัดการ สิทธิ NPI","manageAdmin":"จัดการ สิทธิ Admin","edit":"แก้ไข","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"กลับหน้า รายละเอียดผู้ใช้งาน"}}

/***/ }),

/***/ 947:
/***/ (function(module, exports) {

module.exports = {"reqDrawing":{"home":"Home","requestDrawing":"Request Drawing","drawRequest":"Drawing Request","tubeInTubeDrawingRequestOrder":"Tube in Tube Drawing Request Order","tubeInTubeListOrder":"Tube in Tube List Order","createNew":"Create New","customer":"Customer","status":"Status","priority":"Priority","search":"Search","placeholderSearch":"Select for search","placeholderInputSearch":"Input for search","tubeInTubeOrder":"Tube In Tube List Order","accessoryOrder":"Accessory List Order","uBend":"U-Bend","sticker":"Sticker","crossOver":"Cross-over","insulation":"Insulation","plate":"Plate","header":"Header","fin":"Fin","distributor":"Distributor","titleTubeInTube":"Tube In Tube","drawingSystemNew":"Coil","drawingSystemTubeInTube":"Tube In Tube","titleAccessory":"Accessory","mm":"มม","title":"Title","titleDescription":"Description","pefoam":"Pefoam","class":"Class","glue":"Glue","1sideGlue":"1 Side","noGlue":"No","black":"Black","gray":"Gray","color":"Color","tubeHeader":"ท่อเฮดเดอร์ / อุปกรณ์แยก","accessoryType":"Accessory Type","menuRestatus":"Re-Status","":""},"menuText":{"reqCoil":"Coil","reqTubeInTube":"Tube In Tube","reqAccessory":"Accessory"}}

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

module.exports = {"urlTranslate":{"requestDrawing":"Request Drawing","coil":"Coil","tubeInTube":"Tube In Tube","create":"Create","update":"Update","view":"View","accessory":"Accessory"}}

/***/ })

},[408]);


// WEBPACK FOOTER //
// app.d72d26a85b9447205874.js